import React, { useState, useEffect, useRef } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Button,
  Col,
  Form,
  Row,
  Modal,
  Accordion,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import CustomInput from "../../../CustomControls/CustomInput";
import { post, postFormData } from "../../../helpers/api_helper";
import { SVGICON } from "../../../constant/theme";
import CustomSelect from "../../../CustomControls/CustomSelect";
import CustomTextArea from "../../../CustomControls/CustomTextArea";
import swal from "sweetalert";
// import CustomMultiColumnSelect from "../../../CustomControls/CustomMultiColumnSelect";
import {
  POST_ValidateFormulaExpression,
  POST_GetDepartmentDropDownList,
  // POST_GetMachineParameters,
  POST_GetMachinesDropDownList,
  POST_GetMaterialCategoryDropDownListByCategoryType,
  // POST_GetMaterialDropDownList,
  POST_GetMaterialTypeDDLByProductGroup,
  POST_GetParameterDDLListAJAX,
  POST_GetParameterDetailByID,
  // POST_GetStandardParameterList,
  // POST_GetStandardParameterListUnmapped,
  POST_GetTestMasterDetailByID,
  POST_GetTestMethodDropDownList,
  POST_ParameterInsert,
  POST_ParameterUpdate,
  POST_ProductGroupDropDownListByDepartmentID,
  POST_TestMasterImageSave,
  POST_TestMasterInsert,
  POST_TestMasterProductGroupDepartmentsWiseInsert,
  POST_TestMasterUpdate,
  POST_TestMethodsInsert,
  POST_GetDDLTestMasterByDepartmentProductGroupMaterialType,
  POST_GetShortCodesByMultipleTestIDs,
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetMixDesignMasterListByMixDesignMasterType,
} from "../../../helpers/url_helper";
import QuickAddMaterialCategory from "../MaterialCategories/QuickAddMaterialCategory";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import {
  capitalizeString,
  customConfirmDialog,
  delete_RecordWithoutApi,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import CustomInputAutoSuggest from "../../../CustomControls/CustomInputAutoSuggest";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import QuickAddTestMethod from "../TestMethod/QuickAddTestMethod";

const AddTestMaster = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const { PrimaryIdParam, CopyTestMasterIdParam } = useParams();

  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [productGroupOptions, setProductGroupOptions] = useState([]);
  const [testMethodOptions, setTestMethodOptions] = useState([]);
  // const [materialOptions, setMaterialOptions] = useState([]);
  // const [materialOptionsList, setMaterialOptionsList] = useState([]);
  const [nonStandardParameterOptions, setNonStandardParameterOptions] =
    useState([]);
  const [
    standardParameterUnmappedOptions,
    setStandardParameterUnmappedOptions,
  ] = useState([]);
  const [unitOptions, setUnitOptions] = useState([]);
  const [
    showQuickAddMaterialCategoryModal,
    setShowQuickAddMaterialCategoryModal,
  ] = useState(false);
  const [categoryType, setCategoryType] = useState(0);
  const [categoryTypeName, setCategoryTypeName] = useState("");
  const [addTestMasterImageModal, setAddTestMasterImageModal] = useState(false);
  const [showQuickAddParametersModal, setShowQuickAddParametersModal] =
    useState(false);

  const [showQuickAddProductGroupModal, setShowQuickAddProductGroupModal] =
    useState(false);

  const [showQuickAddTestMethodModal, setShowQuickAddTestMethodModal] =
    useState(false);
  const [addNonStandardParametersModal, setAddNonStandardParametersModal] =
    useState(false);
  const [showAddStandardParametersModal, setShowAddStandardParametersModal] =
    useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const testTypeOptions = [
    { label: "DT", value: 1 },
    { label: "NDT", value: 2 },
  ];

  const ndtProcessTypeOptions = [
    { label: "UT", value: 1 },
    { label: "RT", value: 2 },
    { label: "MT", value: 3 },
    { label: "PT", value: 4 },
  ];

  const ParameterResultTypeOptions = [
    { label: "Quantitative", value: 1 },
    { label: "Qualitative", value: 2 },
  ];

  const scrollToRefTop = (ref) => {
    ref.current.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  const testMethodDivRef = useRef();
  const materialTypeDivRef = useRef();

  const validationSchema = Yup.object().shape({
    btnSubmitType: Yup.number(),
    TestType: Yup.number(),
    NDTProcessType: Yup.number().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1 && TestType == 2)
          return Yup.number()
            .required("NDT Process Type is required field")
            .min(1, "NDT Process Type is required field");
        return schema;
      }
    ),
    TestName: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1)
        return Yup.string().required("Test Name is required field");
      return schema;
    }),

    DepartmentID: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Department is required field");
        return schema;
      }
    ),

    ProductGroupID: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Material Group is required field");
        return schema;
      }
    ),

    TestMasterDisplayName: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required("Display Name is required field");
        return schema;
      }
    ),

    ParameterHeaderDisplayName: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1)
          return Yup.string().required(
            "Parameter Header Display Name is required field"
          );
        return schema;
      }
    ),

    DefaultTestCount: Yup.string().when(
      "btnSubmitType",
      ([btnSubmitType], schema) => {
        if (btnSubmitType != 1 && TestType == 1)
          return Yup.string().required("Default Test Count is required field");
        return schema;
      }
    ),

    TestRate: Yup.string().when("btnSubmitType", ([btnSubmitType], schema) => {
      if (btnSubmitType != 1 && AuthUser?.Permissions?.Account == 1)
        return Yup.string().required("Test Rate Count is required field");
      return schema;
    }),

    //TestName: Yup.string().trim().required("Test Name is required field"),
    //DepartmentID: Yup.string().trim().required("Department is required field"),
    // ProductGroupID: Yup.string()
    //   .trim()
    //   .required("Material Group is required field"),

    // TestMasterDisplayName: Yup.string()
    //   .trim()
    //   .required("Display Name is required field"),
    // ParameterHeaderDisplayName: Yup.string()
    //   .trim()
    //   .required("Parameter Header Display Name is required field"),
    // ParameterHeaderDisplayName: Yup.string()
    //   .trim()
    //   .required("Parameter Header Display Name is required field"),
    // DefaultTestCount: Yup.string()
    //   .trim()
    //   .required("Default Test Count is required field"),
    //TestRate: Yup.string().trim().required("Test Rate is required field"),
  });

  const formik = useFormik({
    validationSchema,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmit(values, formikHelpers),
    initialValues: {
      TestMasterIDEncrypt: PrimaryIdParam ? window.atob(PrimaryIdParam) : "",
      TestType: AuthUser?.Permissions?.DT == 1 ? 1 : 2,
      NDTProcessType: 0,
      TestName: "",
      DepartmentID: "",
      ProductGroupID: "",
      TestMasterDisplayName: "",
      ParameterHeaderDisplayName: "Parameter",
      DefaultTestCount: 1,
      MachiningRequired: false,
      IsNABL: false,
      IsImageInTesting: false,
      IsRecordEdit: true,
      ListMaterialType: [],
      ListTestMethod: [],
      ListMachines: [],
      ListTestMasterImages: [],
      ListOfTestMasterStandardParameters: [],
      ListOfTestMasterNonStandardParameters: [],
      TestRate: "",
      searchMaterialType: "",
      searchTestMethod: "",
      searchMachines: "",
      ListOfMachineWiseParameterRateFinal: [],
      IsMixDesign: false,
      ListOfMixDesignTest: [],
      ListOfMixDesignTestShortCodes: [],
      IsDraft: true,
      // IsIncudeStandardRate: false,
      ListOfMoreTestRates: [],
      btnSubmitType: 1, // 1 = Draft, 2 = Submit
    },
    validateOnBlur: false,
  });

  const {
    setFieldValue,
    values: {
      TestMasterIDEncrypt,
      TestType,
      DepartmentID,
      ProductGroupID,
      IsNABL,
      MachiningRequired,
      IsImageInTesting,
      ListMaterialType,
      ListTestMethod,
      ListMachines,
      ListTestMasterImages,
      ListOfTestMasterStandardParameters,
      ListOfTestMasterNonStandardParameters,
      searchMaterialType,
      searchTestMethod,
      searchMachines,
      IsRecordEdit,
      TestMasterDisplayName,
      ListOfMachineWiseParameterRateFinal,
      IsMixDesign,
      ListOfMixDesignTest,
      ListOfMixDesignTestShortCodes,
      IsDraft,
      btnSubmitType,
      ListOfMoreTestRates,
    },
  } = formik;

  // const handleValidSubmit = (values) => {
  //   if (values?.ListOfTestMasterStandardParameters?.length == 0) {
  //     formik.setFieldError(
  //       "ListOfTestMasterStandardParameters",
  //       "Standard Parameters is required"
  //     );
  //     formik.setFieldTouched("ListOfTestMasterStandardParameters", true);

  //     return;
  //   }

  //   setIsLoading(true);
  //   let formData = new FormData();

  //   formData.append("TestMasterIDEncrypt", values?.TestMasterIDEncrypt);
  //   formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
  //   formData.append("TestName", values?.TestName);
  //   formData.append("TestMasterDisplayName", values?.TestMasterDisplayName);
  //   formData.append(
  //     "ParameterHeaderDisplayName",
  //     values?.ParameterHeaderDisplayName
  //   );
  //   formData.append("IsNABL", values?.IsNABL);
  //   formData.append("IsImageInTesting", values?.IsImageInTesting);
  //   formData.append("DefaultTestCount", values?.DefaultTestCount);
  //   formData.append("MachiningRequired", values?.MachiningRequired);
  //   formData.append("DepartmentIDEncrypt", values?.DepartmentID);
  //   formData.append("ProductGroupIDEncrypt", values?.ProductGroupID);

  //   formData.append(
  //     "MachineIDs",
  //     values?.ListMachines?.filter((e) => e.IsSelected == true).length > 0
  //       ? Array.from(
  //           values?.ListMachines?.filter((e) => e.IsSelected == true),
  //           (x) => x.MachinesIDEncrypt
  //         ).join(",")
  //       : ""
  //   );
  //   formData.append(
  //     "MaterialTypeIDs",
  //     Array.from(
  //       values?.ListMaterialType?.filter((e) => e.IsSelected == true),
  //       (x) => x.MaterialCategoryIDEncrypt
  //     ).join(",")
  //   );
  //   formData.append(
  //     "TestMethodIDs",
  //     Array.from(
  //       values?.ListTestMethod?.filter((e) => e.IsSelected == true),
  //       (x) => x.TestMethodIDEncrypt
  //     ).join(",")
  //   );

  //   formData.append(
  //     "CreatedByEncrypt",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );
  //   formData.append(
  //     "ModifiedByEncrypt",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );

  //   values?.ListOfTestMasterStandardParameters?.map((x, i) => {
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].TestMasterStandardParameterIDEncrypted`,
  //       x.TestMasterStandardParameterIDEncrypt
  //         ? x.TestMasterStandardParameterIDEncrypt
  //         : "0"
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].TestMethodID`,
  //       x.TestMethodID
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].ParameterIDEncrypted`,
  //       x.ParameterIDEncrypt
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].DisplayName`,
  //       x.DisplayName
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].Requirement`,
  //       x.Requirement
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].DefaultValue`,
  //       x.DefaultValue
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].ConsiderAdditionalCharge`,
  //       x.ConsiderAdditionalCharge
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].AdditionalChargeAmount`,
  //       x.AdditionalChargeAmount ? x.AdditionalChargeAmount : 0
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].DisplaySequence`,
  //       x.DisplaySequence
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].IsDelete`,
  //       x.IsDelete
  //     );
  //     formData.append(
  //       `ListOfTestMasterStandardParameters[${i}].IsSelected`,
  //       x.IsSelected
  //     );
  //   });

  //   values?.ListOfTestMasterNonStandardParameters?.map((x, i) => {
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].TestMasterNonStandardParameterIDEncrypted`,
  //       x.TestMasterNonStandardParameterIDEncrypted
  //         ? x.TestMasterNonStandardParameterIDEncrypted
  //         : "0"
  //     );

  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].ParameterName`,
  //       x.NonParameterName
  //     );

  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].DisplayCode`,
  //       x.DisplayCode ?? ""
  //     );

  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].DisplayName`,
  //       x.DisplayName ?? ""
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].Requirement`,
  //       x.Requirement ?? ""
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].DefaultValue`,
  //       x.DefaultValue ?? ""
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].ConsiderAdditionalCharge`,
  //       x.ConsiderAdditionalCharge
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].AdditionalChargeAmount`,
  //       x.AdditionalChargeAmount ? x?.AdditionalChargeAmount : 0
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].DisplaySequence`,
  //       x.DisplaySequence
  //     );
  //     formData.append(
  //       `ListOfTestMasterNonStandardParameters[${i}].IsDelete`,
  //       x.IsDelete
  //     );
  //   });

  //   values?.ListTestMasterImages?.map((x, i) => {
  //     formData.append(`ListOfTestMasterImages[${i}].ImageFile`, x.ImageFile);
  //     formData.append(
  //       `ListOfTestMasterImages[${i}].ImageFilePath`,
  //       x.ImageFilePath
  //     );
  //     formData.append(`ListOfTestMasterImages[${i}].IsDelete`, x.IsDelete);
  //     formData.append(
  //       `ListOfTestMasterImages[${i}].TestMasterImageIDEncrypted`,
  //       x.TestMasterImageIDEncrypted ? x.TestMasterImageIDEncrypted : "0"
  //     );
  //   });

  //   // console.log("Add", formData);

  //   postFormData(
  //     PrimaryIdParam ? POST_TestMasterUpdate : POST_TestMasterInsert,
  //     formData
  //   )
  //     .then((response) => {
  //       setIsLoading(true);
  //       if (response?.IsSuccess) {
  //         successMessage(response?.Message);
  //         setTimeout(() => {
  //           navigate("/test-master");
  //         }, 1000);
  //       } else {
  //         errorMessage(response?.Message);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const handleValidSubmit = (values) => {
    if (values?.btnSubmitType == 2 && values?.TestType == 1) {
      if (values?.ListOfTestMasterStandardParameters?.length == 0) {
        formik.setFieldError(
          "ListOfTestMasterStandardParameters",
          "Standard Parameters is required"
        );
        formik.setFieldTouched("ListOfTestMasterStandardParameters", true);

        return;
      }
    }

    setIsLoading(true);
    let payload = {
      ...values,
      IsDraft: values?.btnSubmitType == 2 ? false : true,
      //IsIncudeStandardRate: values?.IsIncudeStandardRate,
      DepartmentIDEncrypt: values?.DepartmentID,
      ProductGroupIDEncrypt: values?.ProductGroupID,
      MachineIDs:
        values?.ListMachines?.filter((e) => e.IsSelected == true).length > 0
          ? Array.from(
              values?.ListMachines?.filter((e) => e.IsSelected == true),
              (x) => x.MachinesIDEncrypt
            ).join(",")
          : "",
      // MaterialTypeIDs: Array.from(
      //   values?.ListMaterialType?.filter((e) => e.IsSelected == true),
      //   (x) => x.MaterialCategoryIDEncrypt
      // ).join(","),
      // TestMethodIDs: Array.from(
      //   values?.ListTestMethod?.filter((e) => e.IsSelected == true),
      //   (x) => x.TestMethodIDEncrypt
      // ).join(","),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt,
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt,
      TestRate: values?.TestRate ? values?.TestRate : "0.00",
      // ListOfTestMasterStandardParameters:
      //   values?.ListOfTestMasterStandardParameters?.map((x, i) => {
      //     return {
      //       ...x,
      //       TestMasterStandardParameterIDEncrypted:
      //         x.TestMasterStandardParameterIDEncrypt,
      //       ParameterIDEncrypted: x.ParameterIDEncrypt,
      //       AdditionalChargeAmount: x.AdditionalChargeAmount
      //         ? x?.AdditionalChargeAmount
      //         : 0,
      //     };
      //   }),
      ListOfTestMasterStandardParameters:
        values?.ListOfTestMasterStandardParameters?.map((x, i) => {
          return {
            ...x,
            AdditionalChargeAmount: x.AdditionalChargeAmount
              ? x?.AdditionalChargeAmount.toString()
              : "0.00",
          };
        }),
      ListOfTestMasterNonStandardParameters:
        values?.ListOfTestMasterNonStandardParameters?.map((x, i) => {
          return {
            ...x,
            ParameterName: x.NonParameterName,
            AdditionalChargeAmount: x.AdditionalChargeAmount
              ? x?.AdditionalChargeAmount.toString()
              : "0.00",
          };
        }),
      ListOfMachineWiseParameterRate: [],
      // ListOfMachineWiseParameterRate: ListOfMachineWiseParameterRateFinal?.map(
      //   (x, i) => {
      //     return {
      //       ...x,
      //       ParameterRate: x.ParameterRate
      //         ? x?.ParameterRate.toString()
      //         : "0.00",
      //     };
      //   }
      // ),

      // TestMasterIDsIncludesInMixDesign:
      //   values?.ListOfMixDesignTest?.filter((e) => e.IsSelected == true)
      //     .length > 0
      //     ? Array.from(
      //         values?.ListOfMixDesignTest?.filter((e) => e.IsSelected == true),
      //         (x) => x.TestMasterIDEncrypted
      //       ).join(",")
      //     : "",
      TestMasterIDsIncludesInMixDesign:
        values?.ListOfMixDesignTest?.length > 0
          ? Array.from(
              values?.ListOfMixDesignTest,
              (x) => x.TestMasterIDEncrypted
            ).join(",")
          : "",

      ListOfMoreTestRates: values?.ListOfMoreTestRates?.map((x, i) => {
        return {
          ...x,
          RateType: x?.RateType ? x?.RateType : 0,
          Unit: x?.Unit ? x?.Unit : 0,
          // MinValue: x?.MinValue ? x?.MinValue.toString() : "",
          MinValue: x?.MinValue
            ? x?.MinValue.toString()
            : x?.MaxValue
            ? ""
            : "",
          MaxValue: x?.MaxValue ? x?.MaxValue.toString() : "",
          TestRate: x.TestRate ? x?.TestRate.toString() : "0.00",
          IsDeleted: x?.IsDeleted,
          IsIncudeStandardRate: x?.IsIncudeStandardRate,
        };
      }),
    };

    post(
      PrimaryIdParam ? POST_TestMasterUpdate : POST_TestMasterInsert,
      payload
    )
      .then((response) => {
        setIsLoading(true);
        if (response?.IsSuccess) {
          if (values?.ListTestMasterImages?.length > 0) {
            let formData = new FormData();

            //formData.append("TestMasterIDEncrypt", values?.TestMasterIDEncrypt);
            formData.append("TestMasterIDEncrypt", response?.EncryptID);
            formData.append(
              "CreatedByEncrypt",
              AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
            );
            formData.append("CompanyIDEncrypt", AuthUser?.CompanyIDEncrypt);
            formData.append(
              "IsCopyTestMasterIdParam",
              CopyTestMasterIdParam ? true : false
            );

            Promise.all(
              values?.ListTestMasterImages?.map((x, i) => {
                formData.append(
                  `ListOfTestMasterImages[${i}].ImageFile`,
                  x.ImageFile
                );
                formData.append(
                  `ListOfTestMasterImages[${i}].ImageFilePath`,
                  x.ImageFilePath
                );
                formData.append(
                  `ListOfTestMasterImages[${i}].IsDelete`,
                  x.IsDelete
                );
                formData.append(
                  `ListOfTestMasterImages[${i}].TestMasterImageIDEncrypted`,
                  x.TestMasterImageIDEncrypted
                    ? x.TestMasterImageIDEncrypted
                    : "0"
                );
              })
            );

            postFormData(POST_TestMasterImageSave, formData)
              .then((res) => {
                if (res?.IsSuccess) {
                  successMessage(response?.Message); //show success message from main api response
                  setTimeout(() => {
                    navigate("/test-master");
                  }, 1000);
                } else {
                  errorMessage(res?.Message);
                }
              })
              .catch((error) => {
                console.log(error);
                setIsLoading(false);
              });
          } else {
            successMessage(response?.Message);
            setTimeout(() => {
              navigate("/test-master");
            }, 1000);
          }
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getDepartmentList();
    getNonStandardParametersList();
    getTestMethodList();
    getUnitDDL();
    if (PrimaryIdParam) {
      getTestMasterDetails();
    } else {
      if (CopyTestMasterIdParam) {
        getCopyTestMasterDetails();
      }
      getMachinesList();
      //getMaterialTypeList();
      // getTestMethodList();
      formik.setFieldValue("ListMaterialType", []);
    }
    getMixDesignPrintingGroup();
  }, []);

  const getTestMasterDetails = () => {
    setIsLoading(true);
    post(POST_GetTestMasterDetailByID, {
      //TestMasterIDEncrypted: window.atob(PrimaryIdParam),
      TestMasterIDEncrypted: window.atob(PrimaryIdParam),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // let testMethodList = response?.ListOfTestMethod?.map((item) => ({
          //   TestMethodIDEncrypt: item.TestMethodIDEncrypted,
          //   display: true,
          //   label: item.TestMethodName,
          //   value: item.TestMethodIDEncrypted,
          // }));

          formik.setValues({
            ...response,

            DepartmentID: response?.DepartmentIDEncrypt,
            ProductGroupID: response?.ProductGroupIDEncrypt,
            ListOfMoreTestRates: response?.ListOfMoreTestRates?.map((x) => ({
              ...x,
              IsDeleted: false,
            })),
            ListMaterialType: response?.ListOfMaterialType?.map((x) => ({
              ...x,
              MaterialCategoryIDEncrypt: x?.MaterialCategoryIDEncrypted,
              display: true,
            })),

            // ListTestMethod: response?.ListOfTestMethod?.map((x) => ({
            //   ...x,
            //   TestMethodIDEncrypt: x?.TestMethodIDEncrypted,
            //   display: true,
            // })),
            // ListTestMethod: testMethodList,

            ListMachines: response?.ListOfTestMachine?.map((x) => ({
              ...x,
              MachinesIDEncrypt: x?.MachineIDEncrypted,
              MachinesName: x?.MachineName,
              display: true,
            })),

            ListTestMasterImages: response?.ListOfTestImage?.map((x) => ({
              ...x,
              ImageFile: "",
              TestMasterImagePreview: x?.ImageFilePath,
              IsDelete: false,
            })),

            ListOfTestMasterStandardParameters:
              response?.ListOfStandardParameter?.map((x) => ({
                ...x,
                // TestMasterStandardParameterIDEncrypt:
                //   x?.TestMasterStandardParameterIDEncrypted,
                // ParameterIDEncrypt: x?.ParameterIDEncrypted,
                IsDelete: false,
              })),

            ListOfTestMasterNonStandardParameters:
              response?.ListOfNonStandardParameter?.map((x) => ({
                ...x,
                NonParameterName: x?.ParameterName,
              })),

            //ListOfMachineWiseParameterRateFinal: [],
          });

          formikDefineMoreRates.setFieldValue(
            "IsIncudeStandardRate",
            response?.ListOfMoreTestRates[0]?.IsIncudeStandardRate
          );
          // setTestMethodOptions(testMethodList);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCopyTestMasterDetails = () => {
    setIsLoading(true);
    post(POST_GetTestMasterDetailByID, {
      TestMasterIDEncrypted: window.atob(CopyTestMasterIdParam),
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setValues({
            ...response,
            IsRecordEdit: true,
            TestRate: response.TestRate > 0 ? response.TestRate : "",
            DepartmentID: response?.DepartmentIDEncrypt,
            ProductGroupID: response?.ProductGroupIDEncrypt,
            ListOfMoreTestRates: response?.ListOfMoreTestRates?.map((x) => ({
              ...x,
              IsDeleted: false,
            })),
            ListMaterialType: response?.ListOfMaterialType?.map((x) => ({
              ...x,
              MaterialCategoryIDEncrypt: x?.MaterialCategoryIDEncrypted,
              display: true,
            })),

            ListMachines: response?.ListOfTestMachine?.map((x) => ({
              ...x,
              MachinesIDEncrypt: x?.MachineIDEncrypted,
              MachinesName: x?.MachineName,
              display: true,
            })),

            ListTestMasterImages: response?.ListOfTestImage?.map((x) => ({
              ...x,
              ImageFile: "",
              TestMasterImagePreview: x?.ImageFilePath,
              IsDelete: false,
            })),

            ListOfTestMasterStandardParameters:
              response?.ListOfStandardParameter?.map((x) => ({
                ...x,
                IsDelete: false,
              })),

            ListOfTestMasterNonStandardParameters:
              response?.ListOfNonStandardParameter?.map((x) => ({
                ...x,
                NonParameterName: x?.ParameterName,
              })),
          });
          formikDefineMoreRates.setFieldValue(
            "IsIncudeStandardRate",
            response?.ListOfMoreTestRates[0]?.IsIncudeStandardRate
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getDepartmentList = async () => {
    setIsLoading(true);
    await post(POST_GetDepartmentDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setDepartmentOptions(
            response?.List?.map((item) => ({
              label: item.DepartmentName,
              value: item.DepartmentIDEncrypted,
            }))
          );

          /*select the value when there is only one option while insert only*/
          if (response?.List?.length == 1 && !PrimaryIdParam) {
            formik.setFieldValue(
              "DepartmentID",
              response?.List[0].DepartmentIDEncrypted
            );
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getNonStandardParametersList = async () => {
    setIsLoading(true);
    await post(POST_GetMaterialCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 2, // 2 = Non Standard Parameters
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formikNonStandardParametersAdd.setFieldValue(
          //   "ListOfNonParameterName",
          //   response?.List?.map((item) => ({
          //     MaterialCategoryIDEncrypt: item.MaterialCategoryIDEncrypted,
          //     ParameterName: item.CategoryName,
          //     display: false,
          //     name: item.CategoryName,
          //   }))
          // );
          setNonStandardParameterOptions(
            response?.List?.map((item) => ({
              MaterialCategoryIDEncrypt: item.MaterialCategoryIDEncrypted,
              ParameterName: item.CategoryName,
              name: item.CategoryName,
              ShortCode: item.ShortCode,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (DepartmentID) {
      getProductGroupDDL(DepartmentID);
    } else {
      setProductGroupOptions([]);
      formik.setFieldValue("ProductGroupID", "");
    }
  }, [DepartmentID]);

  const getProductGroupDDL = (DepartmentID) => {
    setIsLoading(true);
    post(POST_ProductGroupDropDownListByDepartmentID, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypt: DepartmentID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setProductGroupOptions(
            response?.ProductGroupDropDownList?.map((item) => ({
              label: item.ProductGroupName,
              value: item.ProductGroupIDEncrypt,
            }))
          );

          if (
            response?.ProductGroupDropDownList?.length > 0 &&
            ProductGroupID &&
            response?.ProductGroupDropDownList?.filter(
              (x) => x.ProductGroupIDEncrypt == ProductGroupID
            ).length == 0
          ) {
            formik.setFieldValue("ProductGroupID", "");
          } else {
            /*select the value when there is only one option while insert only*/
            if (
              response?.ProductGroupDropDownList?.length == 1 &&
              !PrimaryIdParam
            ) {
              formik.setFieldValue(
                "ProductGroupID",
                response?.ProductGroupDropDownList[0].ProductGroupIDEncrypt
              );
            }
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  // useEffect(() => {
  //   if (ProductGroupID) {
  //     getMaterialTypeList(ProductGroupID);
  //   } else {
  //     formik.setFieldValue("ListMaterialType", []);
  //     //formik.setFieldValue("ProductGroupID", "");
  //   }
  // }, [ProductGroupID]);

  // const getMaterialTypeList = (proGpID) => {
  //   setIsLoading(true);
  //   post(POST_GetMaterialTypeDDLByProductGroup, {
  //     ProductGroupIDEncrypted: proGpID,
  //     TestMasterIDEncrypted: TestMasterIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         formik.setFieldValue(
  //           "ListMaterialType",
  //           response?.List?.map((item) => ({
  //             MaterialCategoryIDEncrypt: item?.MaterialCategoryIDEncrypted,
  //             MaterialTypeName: item?.MaterialTypeName,
  //             IsSelected: item?.IsSelected,
  //             display: true,
  //             // MaterialCategoryIDEncrypt: item.MaterialTypeIDEncrypted,
  //             // MaterialTypeName: item.MaterialTypeName,
  //             // IsSelected: false,
  //             // display: true,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });

  //   //console.log("DDL", ListMaterialType);
  // };

  const getTestMethodList = async () => {
    setIsLoading(true);
    await post(POST_GetTestMethodDropDownList, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formik.setFieldValue(
          //   "ListTestMethod",
          //   response?.TestMethodList?.map((item) => ({
          //     TestMethodIDEncrypt: item.TestMethodIDEncrypted,
          //     TestMethodName: item.TestMethod,
          //     IsSelected: false,
          //     display: true,
          //   }))
          // );
          let testMethodList = response?.TestMethodList?.map((item) => ({
            TestMethodIDEncrypt: item.TestMethodIDEncrypted,
            // TestMethodName: item.TestMethod,
            TestMethodName: item.NickName
              ? `${item.TestMethod} (${item.NickName})`
              : item.TestMethod,
            IsSelected: false,
            display: true,
            // label: item.TestMethod,
            label: item.NickName
              ? `${item.TestMethod} (${item.NickName})`
              : item.TestMethod,
            value: item.TestMethodIDEncrypted,
          }));
          // formik.setFieldValue("ListTestMethod", testMethodList);
          setTestMethodOptions(testMethodList);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getMachinesList = async () => {
    setIsLoading(true);
    await post(POST_GetMachinesDropDownList, {
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypt: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formik.setFieldValue(
            "ListMachines",
            response?.MachinesDropDownList?.map((item) => ({
              MachinesIDEncrypt: item.MachineIDEncrypt,
              MachinesName: item.MachineName,
              IsSelected: false,
              display: true,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearchMaterialType = (e) => {
    formik.setFieldValue("searchMaterialType", e?.target?.value);
    formik.setFieldValue(
      "ListMaterialType",
      ListMaterialType?.map((x) => {
        return {
          ...x,
          display: x.MaterialTypeName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const handleChangeSearchTestMethod = (e) => {
    formik.setFieldValue("searchTestMethod", e?.target?.value);
    formik.setFieldValue(
      "ListTestMethod",
      ListTestMethod?.map((x) => {
        return {
          ...x,
          display: x.TestMethodName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const handleChangeSearchMachines = (e) => {
    formik.setFieldValue("searchMachines", e?.target?.value);
    formik.setFieldValue(
      "ListMachines",
      ListMachines?.map((x) => {
        return {
          ...x,
          display: x.MachinesName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  // useEffect(() => {
  //   getStandaradParameterList(
  //     DepartmentID,
  //     ProductGroupID,
  //     ListMaterialType,
  //     ListTestMethod
  //   );
  // }, [DepartmentID, ProductGroupID, ListMaterialType, ListTestMethod]);

  const fnCallbackQuickAddMaterialCategory = (categoryID, categoryName) => {
    if (categoryType == 1) {
      // 1 = Material Type
      formik.setFieldValue("ListMaterialType", [
        {
          MaterialCategoryIDEncrypt: categoryID,
          MaterialTypeName: categoryName,
          IsSelected: true,
          display: true,
        },
        ...ListMaterialType,
      ]);
      scrollToRefTop(materialTypeDivRef);
    }
    // else if (categoryType == 2) {
    //   formikNonStandardParametersAdd.setFieldValue("ListOfNonParameterName", [
    //     ...ListOfNonParameterName,
    //     {
    //       MaterialCategoryIDEncrypt: categoryID,
    //       ParameterName: categoryName,
    //       display: true,
    //     },
    //   ]);
    // }
  };

  const addTestMasterImage = () => {
    formikTestMasterImage.resetForm();
    setAddTestMasterImageModal(true);
  };

  const validationSchemaTestMasterImage = Yup.object().shape({
    ImageFile: Yup.string()
      .trim()
      .required("Test Master Image is required field"),
  });

  const formikTestMasterImage = useFormik({
    validationSchema: validationSchemaTestMasterImage,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitTestMasterImage(values, formikHelpers),
    initialValues: {
      TestMasterImageIDEncrypted: "",
      ImageFile: "",
      TestMasterImagePreview: "",
      ImageFilePath: "",
      indx: "",
      actionFlagImage: 0, // 0 = Add,  1 = edit
    },
    validateOnBlur: false,
  });

  const {
    values: { actionFlagImage },
  } = formikTestMasterImage;

  const handleValidSubmitTestMasterImage = (values) => {
    // if (values?.indx !== "") {
    //   formik.setFieldValue(
    //     "ListTestMasterImages",
    //     ListTestMasterImages?.map((x, idx) => {
    //       if (idx == values?.indx) {
    //         return {
    //           ...x,
    //           ImageFile: values?.ImageFile,
    //           TestMasterImagePreview: values?.TestMasterImagePreview,
    //           ImageFilePath: values?.ImageFilePath,
    //           IsDelete: false,
    //         };
    //       } else {
    //         return { ...x };
    //       }
    //     })
    //   );
    // } else {

    formik.setFieldValue("ListTestMasterImages", [
      ...ListTestMasterImages,
      {
        ...values,
        ImageFile: values?.ImageFile,
        ImageFilePath: "",
        IsDelete: false,
        TestMasterImageIDEncrypted: "",
      },
    ]);
    // }
    setAddTestMasterImageModal(false);
  };

  const deleteTestMasterImage = (i) => {
    formik.setFieldValue(
      "ListTestMasterImages",
      ListTestMasterImages?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDelete: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    // formik.setFieldValue(
    //   "ListTestMasterImages",
    //   ListTestMasterImages?.filter((x, idx) => idx != i)
    // );
  };

  const uploadTestMasterImage = (e) => {
    if (e.target.files[0]) {
      const file = e.target.files[0];
      var pattern = /image-*/;
      if (!file.type.match(pattern)) {
        formikTestMasterImage.setFieldValue("ImageFile", "");
        formikTestMasterImage.setFieldValue("TestMasterImagePreview", "");
        warningMessage("Select valid image file!");
      } else {
        formikTestMasterImage.setFieldValue("ImageFile", file);
        formikTestMasterImage.setFieldValue(
          "TestMasterImagePreview",
          URL.createObjectURL(file)
        );
        //formikTestMasterImage.setFieldError("ImageFile", "");
      }
      formikTestMasterImage.setFieldValue("ImageFilePath", "");
    }
  };

  const addProductGroup = () => {
    formikProductGroupAdd.resetForm();
    setShowQuickAddProductGroupModal(true);
  };

  const validationSchemaProductGroupAdd = Yup.object().shape({
    ProductGroupName: Yup.string()
      .trim()
      .required("Material Group Name is required field"),
  });

  const formikProductGroupAdd = useFormik({
    validationSchema: validationSchemaProductGroupAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitProductGroupAdd(values, formikHelpers),
    initialValues: {
      ProductGroupName: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikProductGroupAdd;

  const handleValidSubmitProductGroupAdd = (values) => {
    setIsLoading(true);
    let payload = {
      ...values,
      DepartmentIDEncrypt: DepartmentID,
      ProductGroupName: values?.ProductGroupName,
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    //console.log("payload: ", payload);

    post(POST_TestMasterProductGroupDepartmentsWiseInsert, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          setTimeout(() => {
            // navigate("/product-groups");
            getProductGroupDDL(DepartmentID);
            setShowQuickAddProductGroupModal(false);
          }, 1000);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addTestMethod = () => {
    //formikTestMethodAdd.resetForm();
    setShowQuickAddTestMethodModal(true);
  };

  const fnCallbackQuickAddTestMethod = (
    testMethodID,
    testMethodName,
    nickName
  ) => {
    setTestMethodOptions([
      ...testMethodOptions,
      {
        label: nickName ? `${testMethodName} (${nickName})` : testMethodName,
        value: testMethodID,
        NickName: nickName,
      },
    ]);
  };

  // const validationSchemaTestMethodAdd = Yup.object().shape({
  //   TestMethodCodeType: Yup.number(),
  //   TestMethodName: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 2)
  //         return Yup.string().required("Test Method Name is required field");
  //       return schema;
  //     }
  //   ),
  //   TestMethodCountryCode: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Country Code is required field");
  //       return schema;
  //     }
  //   ),
  //   StandardCode: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Standard Code is required field");
  //       return schema;
  //     }
  //   ),
  //   Delimiter: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Delimiter is required field");
  //       return schema;
  //     }
  //   ),
  //   MethodYear: Yup.string().when(
  //     "TestMethodCodeType",
  //     ([TestMethodCodeType], schema) => {
  //       if (TestMethodCodeType == 1)
  //         return Yup.string().required("Year is required field");
  //       return schema;
  //     }
  //   ),
  //   DisplayName: Yup.string().trim().required("Display Name is required field"),
  // });

  // const formikTestMethodAdd = useFormik({
  //   validationSchema: validationSchemaTestMethodAdd,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidSubmitTestMethodAdd(values, formikHelpers),
  //   initialValues: {
  //     TestMethodCodeType: 1,
  //     TestMethodName: "",
  //     TestMethodCountryCode: "",
  //     StandardCode: "",
  //     Delimiter: "",
  //     MethodYear: "",
  //     Description: "",
  //     TestMethodIsNABL: false,
  //     DisplayName: "",
  //     NickName: "",
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: {
  //     TestMethodIsNABL,
  //     TestMethodCodeType,
  //     TestMethodCountryCode,
  //     StandardCode,
  //     Delimiter,
  //     MethodYear,
  //     DisplayName,
  //     NickName,
  //   },
  // } = formikTestMethodAdd;

  // function createTestMethodName(CountryCode, StandardCode, Delimiter, Year) {
  //   let name = "";

  //   if (CountryCode) {
  //     name += CountryCode + " ";
  //   }
  //   if (StandardCode) {
  //     name += StandardCode + " ";
  //   }
  //   if (Delimiter) {
  //     name += Delimiter + " ";
  //   }
  //   if (Year) {
  //     name += Year;
  //   }

  //   formikTestMethodAdd.setFieldValue("TestMethodName", name);
  //   //setTestMethod(name);
  // }

  // useEffect(() => {
  //   if (TestMethodCodeType == 1) {
  //     createTestMethodName(
  //       TestMethodCountryCode,
  //       StandardCode,
  //       Delimiter,
  //       MethodYear
  //     );
  //   }
  //   //formik.setFieldValue("TestMethod", testMethod);
  // }, [TestMethodCountryCode, StandardCode, Delimiter, MethodYear]);

  // const handleValidSubmitTestMethodAdd = (values) => {
  //   setIsLoading(true);
  //   let formData = new FormData();

  //   //formData.append("TestMethodIDEncrypt", values?.TestMethodIDEncrypt);
  //   formData.append("CompanyIDEncrypted", AuthUser?.CompanyIDEncrypt);
  //   formData.append("BranchIDEncrypted", AuthUser?.BranchIDEncrypt);
  //   formData.append("TestMethod", values?.TestMethodName.trim());
  //   formData.append("TestMethodCodeType", values?.TestMethodCodeType);
  //   formData.append("DisplayName", values?.DisplayName.trim());
  //   formData.append("NickName", values?.NickName.trim());
  //   formData.append(
  //     "TestMethodCountryCode",
  //     values?.TestMethodCountryCode ? values?.TestMethodCountryCode.trim() : ""
  //   );

  //   formData.append(
  //     "StandardCode",
  //     values?.StandardCode ? values?.StandardCode.trim() : ""
  //   );
  //   formData.append(
  //     "Delimiter",
  //     values?.Delimiter ? values?.Delimiter.trim() : ""
  //   );
  //   formData.append(
  //     "MethodYear",
  //     values?.MethodYear ? values?.MethodYear.trim() : ""
  //   );
  //   // formData.append(
  //   //   "StandardCode",
  //   //   values?.StandardCode ? values?.StandardCode : ""
  //   // );
  //   // formData.append("Delimiter", values?.Delimiter ? values?.Delimiter : "");
  //   // formData.append("MethodYear", values?.MethodYear ? values?.MethodYear : "");
  //   formData.append("Description", values?.Description);
  //   formData.append("IsNABL", values?.TestMethodIsNABL);
  //   formData.append(
  //     "VerificationDoneByEncrypted",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );
  //   formData.append("TestMethodRefDocFilePathURL", "");
  //   formData.append("TestMethodRefDocFilePath", "");
  //   formData.append(
  //     "CreatedByEncrypted",
  //     AuthUser?.ReferenceIDEncrypt ? AuthUser?.ReferenceIDEncrypt : "0"
  //   );

  //   //console.log("Add", formData);

  //   postFormData(POST_TestMethodsInsert, formData)
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         setTimeout(() => {
  //           // formik.setFieldValue("ListTestMethod", [
  //           //   {
  //           //     TestMethodIDEncrypt: response?.EncryptID,
  //           //     TestMethodName: values?.TestMethodName,
  //           //     IsSelected: true,
  //           //     display: true,
  //           //   },
  //           //   ...ListTestMethod,
  //           // ]);
  //           getTestMethodList();
  //           setShowQuickAddTestMethodModal(false);
  //           //scrollToRefTop(testMethodDivRef);
  //         }, 1000);
  //       } else {
  //         errorMessage(response?.Message);
  //         setIsLoading(false);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const addParameters = () => {
    // let selectedMaterialData = "";
    // let selectedTestMethodData = "";
    // let IsSelectedFlag = false;

    // selectedMaterialData = Array.from(
    //   ListMaterialType?.filter((e) => e.IsSelected == true),
    //   (x) => x.MaterialCategoryIDEncrypt
    // ).join(",");

    // selectedTestMethodData = Array.from(
    //   ListTestMethod?.filter((e) => e.IsSelected == true),
    //   (x) => x.TestMethodIDEncrypt
    // ).join(",");

    // if (selectedMaterialData !== "" && selectedTestMethodData !== "") {
    //   IsSelectedFlag = true;
    // }

    // if (IsSelectedFlag === true) {
    // formikParametersAdd.resetForm();
    // setShowQuickAddParametersModal(true);
    //   getParaMaterialList();
    //   getParaTestMethodList();
    //   getParaMachineParameterList();
    //   //inputRef.current.focus();
    //   //inputRef.current.focus();
    // } else {
    //   warningMessage(
    //     "Please select Material Type & Test Method first for Add New Standard Parameters..."
    //   );
    // }
    formikParametersAdd.resetForm();
    formikParametersAdd.setFieldValue(
      "ParameterDepartmentList",
      departmentOptions?.map((x) => {
        return {
          DepartmentIDEncrypt: x?.value,
          DepartmentName: x?.label,
          IsSelected: x?.value == DepartmentID ? true : false,
          IsDisabled: x?.value == DepartmentID ? true : false,
          display: true,
        };
      })
    );
    setShowQuickAddParametersModal(true);
  };

  // const getParaMaterialList = async () => {
  //   setIsLoading(true);

  //   let selectedMaterialData = "";

  //   selectedMaterialData = Array.from(
  //     ListMaterialType?.filter((e) => e.IsSelected == true),
  //     (x) => x.MaterialCategoryIDEncrypt
  //   ).join(",");

  //   await post(POST_GetMaterialDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         let optionsListMain = response?.MaterialTypeList?.filter((e) =>
  //           selectedMaterialData.includes(e?.MaterialTypeIDEncrypted)
  //         );

  //         //let optionsList = response?.MaterialTypeList.map((item) => ({
  //         let optionsList = optionsListMain.map((item) => ({
  //           searchableText:
  //             item.ProductGroupName +
  //             " " +
  //             item.DepartmentName +
  //             " " +
  //             item.MaterialType,
  //           ProductGroupIDEncrypt: item.ProductGroupIDEncrypted,
  //           ProductGroupName: item.ProductGroupName,
  //           DepartmentIDEncrypt: item.DepartmentIDEncrypted,
  //           DepartmentName: item.DepartmentName,
  //           MaterialTypeIDEncrypt: item.MaterialTypeIDEncrypted,
  //           MaterialType: item.MaterialType,
  //           display: true,
  //         }));

  //         let finalList = optionsList?.filter(
  //           (e) =>
  //             e.DepartmentIDEncrypt == DepartmentID &&
  //             e.ProductGroupIDEncrypt == ProductGroupID
  //         );
  //         setMaterialOptions(finalList);
  //         setMaterialOptionsList(finalList);
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const getParaTestMethodList = async () => {
  //   let selectedTestMethodData = "";

  //   selectedTestMethodData = Array.from(
  //     ListTestMethod?.filter((e) => e.IsSelected == true),
  //     (x) => x.TestMethodIDEncrypt
  //   ).join(",");

  //   setIsLoading(true);
  //   await post(POST_GetTestMethodDropDownList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response.IsSuccess) {
  //         let optionsListMain = response?.TestMethodList?.filter((e) =>
  //           selectedTestMethodData.includes(e?.TestMethodIDEncrypted)
  //         );
  //         setTestMethodOptions(
  //           // response.TestMethodList.map((item) => ({
  //           optionsListMain.map((item) => ({
  //             label: item.TestMethod,
  //             value: item.TestMethodIDEncrypted,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const getParaMachineParameterList = async () => {
  //   setIsLoading(true);
  //   await post(POST_GetMachineParameters, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
  //   })
  //     .then((response) => {
  //       if (response.IsSuccess) {
  //         formikParametersAdd.setFieldValue(
  //           "ParameterMachineMappingList",
  //           response.MachineParameterList.map((item) => ({
  //             ...item,
  //             IsSelected: false,
  //             display: true,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  const initNABLTestMethodRange = {
    ParameterNABLTestMethodRangeIDEncrypted: "",
    TestMethodIDEncrypt: "",
    NABLRangeFrom: "",
    NABLRangeTo: "",
    IsDelete: false,
  };

  const validationSchemaCustomerParametersAdd = Yup.object().shape({
    ParameterName: Yup.string()
      .trim()
      .required("Parameter Name is required field"),
    ParameterResultType: Yup.string()
      .trim()
      .required("Parameter Result Type is required field"),
  });

  const formikParametersAdd = useFormik({
    validationSchema: validationSchemaCustomerParametersAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitParametersAdd(values, formikHelpers),
    initialValues: {
      UnmappedParameterIDEncrypted: "",
      ParameterName: "",
      ShortCode: "",
      ParametersIsNABL: false,
      // ParameterMaterialTypeList: [],
      ParameterMachineMappingList: [],
      // MaterialID: "",
      // MaterialText: "",
      // DepartmentIDEncrypt: "",
      // DepartmentName: "",
      // ProductGroupIDEncrypt: "",
      // ProductGroupName: "",
      // MaterialTypeIDEncrypt: "",
      // MaterialType: "",
      // TestMethodIDEncrypt: "",
      // TestMethodName: "",
      // NABLRangeFrom: "",
      // NABLRangeTo: "",
      // Parameterindx: "",
      searchDepartment: "",
      ParameterDepartmentList: [],
      ParameterNABLTestMethodRangeList: [],
      ParameterResultType: 1,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ParametersIsNABL,
      // ParameterMaterialTypeList,
      ParameterMachineMappingList,
      // MaterialID,
      // MaterialText,
      // DepartmentIDEncrypt,
      // DepartmentName,
      // ProductGroupIDEncrypt,
      // ProductGroupName,
      // MaterialTypeIDEncrypt,
      // MaterialType,
      // TestMethodIDEncrypt,
      // TestMethodName,
      // NABLRangeFrom,
      // NABLRangeTo,
      // Parameterindx,
      UnmappedParameterIDEncrypted,
      searchDepartment,
      ParameterDepartmentList,
      ParameterNABLTestMethodRangeList,
      ParameterResultType,
    },
  } = formikParametersAdd;

  useEffect(() => {
    if (UnmappedParameterIDEncrypted) {
      getStandardParameterDetails(UnmappedParameterIDEncrypted);
    } else {
      formikParametersAdd.setFieldValue("ParameterNABLTestMethodRangeList", []);
      formikParametersAdd.setFieldValue("ParameterMachineMappingList", []);
      formikParametersAdd.setFieldValue(
        "ParameterDepartmentList",
        departmentOptions?.map((x) => {
          return {
            DepartmentIDEncrypt: x?.value,
            DepartmentName: x?.label,
            IsSelected: x?.value == DepartmentID ? true : false,
            IsDisabled: x?.value == DepartmentID ? true : false,
            display: true,
          };
        })
      );
      formikParametersAdd.setFieldValue("ShortCode", "");
      formikParametersAdd.setFieldValue("ParameterResultType", 1);
    }
  }, [UnmappedParameterIDEncrypted]);

  const getStandardParameterDetails = (parameterID) => {
    setIsLoading(true);
    post(POST_GetParameterDetailByID, {
      ParameterIDEncrypted: parameterID,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          // formikParametersAdd.setFieldValue(
          //   "ParameterMaterialTypeList",
          //   response?.MaterialTypeList?.map((item) => ({
          //     ParameterMaterialTypeIDEncrypted:
          //       item.ParameterMaterialTypeIDEncrypted,
          //     MaterialName:
          //       item.DepartmentName +
          //       " | " +
          //       item.ProductGroupName +
          //       " | " +
          //       item.MaterialType,
          //     DepartmentIDEncrypt: item.DepartmentIDEncrypted,
          //     DepartmentName: item.DepartmentName,
          //     ProductGroupIDEncrypt: item.ProductGroupIDEncrypted,
          //     ProductGroupName: item.ProductGroupName,
          //     MaterialTypeIDEncrypt: item.MaterialTypeIDEncrypted,
          //     MaterialType: item.MaterialType,
          //     TestMethodIDEncrypt: item.TestMethodIDEncrypted,
          //     TestMethodName: item.TestMethod,
          //     NABLRangeFrom: item.NABLRangeFrom,
          //     NABLRangeTo: item.NABLRangeTo,
          //     IsDeleted: false,
          //   }))
          // );
          formikParametersAdd.setValues({
            UnmappedParameterIDEncrypted: response?.ParameterIDEncrypted,
            ParameterName: response?.ParameterName,
            ShortCode: response?.ShortCode,
            ParametersIsNABL: response?.IsNABL,
            IsActive: response?.IsActive,
            ParameterResultType: response?.ParameterResultType,
            // ParameterMaterialTypeList: response?.MaterialTypeList?.map(
            //   (item) => ({
            //     ParameterMaterialTypeIDEncrypted:
            //       item.ParameterMaterialTypeIDEncrypted,
            //     MaterialName:
            //       item.DepartmentName +
            //       " | " +
            //       item.ProductGroupName +
            //       " | " +
            //       item.MaterialType,
            //     DepartmentIDEncrypt: item.DepartmentIDEncrypted,
            //     DepartmentName: item.DepartmentName,
            //     ProductGroupIDEncrypt: item.ProductGroupIDEncrypted,
            //     ProductGroupName: item.ProductGroupName,
            //     MaterialTypeIDEncrypt: item.MaterialTypeIDEncrypted,
            //     MaterialType: item.MaterialType,
            //     TestMethodIDEncrypt: item.TestMethodIDEncrypted,
            //     TestMethodName: item.TestMethod,
            //     NABLRangeFrom: item.NABLRangeFrom,
            //     NABLRangeTo: item.NABLRangeTo,
            //     IsDeleted: false,
            //   })
            // ),
            ParameterDepartmentList: response?.ParameterDepartmentList?.map(
              (item) => ({
                ...item,
                IsSelected:
                  item?.DepartmentIDEncrypt == DepartmentID
                    ? true
                    : item?.IsSelected,
                IsDisabled:
                  item?.DepartmentIDEncrypt == DepartmentID
                    ? true
                    : item?.IsSelected,
                display: true,
              })
            ),
            ParameterNABLTestMethodRangeList:
              response?.ParameterNABLTestMethodRangeList,
            ParameterMachineMappingList: response?.MachineMappingList?.map(
              (item) => ({
                ...item,
                display: true,
              })
            ),
          });
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleValidSubmitParametersAdd = (values) => {
    // if (
    //   values?.ParameterMaterialTypeList?.filter((x) => x.IsDeleted == false)
    //     .length == 0
    // ) {
    //   formikParametersAdd.setFieldError(
    //     "ParameterMaterialTypeList",
    //     " Material /Test Method  is required"
    //   );
    //   formikParametersAdd.setFieldTouched("ParameterMaterialTypeList", true);

    //   return;
    // }

    if (
      ParameterNABLTestMethodRangeList?.filter(
        (x) => x.IsDelete == false
      )?.filter((item) => !item?.TestMethodIDEncrypt)?.length > 0
    ) {
      formikParametersAdd.setFieldError(
        "ParameterNABLTestMethodRangeList",
        "Please select Test Method or delete the record.."
      );
      formikParametersAdd.setFieldTouched(
        "ParameterNABLTestMethodRangeList",
        true
      );
      return;
    }

    if (
      values?.ShortCode?.trim()?.toLowerCase() == "pi" ||
      values?.ShortCode?.trim()?.toLowerCase() == "e" ||
      values?.ShortCode?.trim()?.toLowerCase() == "null"
    ) {
      formikParametersAdd.setFieldError(
        "ShortCode",
        "'Pi', 'E' & 'NULL' can not be used as short code"
      );
      formikParametersAdd.setFieldTouched("ShortCode", true);
      return;
    }

    setIsLoading(true);

    // let payload = {
    //   ParameterIDEncrypt: values?.UnmappedParameterIDEncrypted,
    //   ParameterName: values?.ParameterName,
    //   IsNABL: values?.ParametersIsNABL,
    //   ParameterMaterialTypeList: values?.ParameterMaterialTypeList,
    //   ParameterMachineMappingList: values?.ParameterMachineMappingList?.filter(
    //     (x) => x.IsSelected == true
    //   ),
    //   CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
    //   CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    //   ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
    //     ? AuthUser?.ReferenceIDEncrypt
    //     : "0",
    // };

    let payload = {
      ParameterIDEncrypt: values?.UnmappedParameterIDEncrypted,
      ParameterName: values?.ParameterName,
      ShortCode: values?.ShortCode?.trim(),
      ParameterResultType: values?.ParameterResultType,
      IsNABL: values?.ParametersIsNABL,
      // ParameterMaterialTypeList: values?.ParameterMaterialTypeList,
      DepartmentIDs: Array.from(
        values?.ParameterDepartmentList?.filter((e) => e.IsSelected == true),
        (x) => x.DepartmentIDEncrypt
      ).join(","),
      ListOfParameterNABLTestMethodRange:
        values?.ParameterNABLTestMethodRangeList?.map((item) => {
          return {
            ...item,
            NABLRangeFrom:
              values?.ParameterResultType == 2
                ? ""
                : item?.NABLRangeFrom
                ? item?.NABLRangeFrom.toString()
                : item?.NABLRangeFrom,
            NABLRangeTo:
              values?.ParameterResultType == 2
                ? ""
                : item?.NABLRangeTo
                ? item?.NABLRangeTo.toString()
                : item?.NABLRangeTo,
            // NABLRangeFrom: item?.NABLRangeFrom
            //   ? item?.NABLRangeFrom.toString()
            //   : item?.NABLRangeFrom,
            // NABLRangeTo: item?.NABLRangeTo
            //   ? item?.NABLRangeTo.toString()
            //   : item?.NABLRangeTo,
          };
        }),
      ParameterMachineMappingList: values?.ParameterMachineMappingList?.filter(
        (x) => x.IsSelected == true
      ),
      CompanyIDEncrypt: AuthUser?.CompanyIDEncrypt,
      CreatedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
      ModifiedByEncrypt: AuthUser?.ReferenceIDEncrypt
        ? AuthUser?.ReferenceIDEncrypt
        : "0",
    };
    //console.log("payload: ", payload);

    post(
      values?.UnmappedParameterIDEncrypted
        ? POST_ParameterUpdate
        : POST_ParameterInsert,
      payload
    )
      .then((response) => {
        if (response?.IsSuccess) {
          // //successMessage(response?.Message);
          // setTimeout(() => {
          //   // navigate("/parameters");
          //   getStandaradParameterList(
          //     DepartmentID,
          //     ProductGroupID,
          //     ListMaterialType,
          //     ListTestMethod
          //   );
          //   setShowQuickAddParametersModal(false);
          // }, 1000);
          setShowQuickAddParametersModal(false);
          setIsLoading(false);
        } else {
          errorMessage(response?.Message);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleChangeSearchDepartment = (e) => {
    formikParametersAdd.setFieldValue("searchDepartment", e?.target?.value);
    formikParametersAdd.setFieldValue(
      "ParameterDepartmentList",
      ParameterDepartmentList?.map((x) => {
        return {
          ...x,
          display: x.DepartmentName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const AddNewNABLTestMethodRange = () => {
    formikParametersAdd.setFieldValue("ParameterNABLTestMethodRangeList", [
      ...ParameterNABLTestMethodRangeList,
      initNABLTestMethodRange,
    ]);
  };

  const deleteNABLTestMethodRange = (i) => {
    if (
      ParameterNABLTestMethodRangeList[i]
        ?.ParameterNABLTestMethodRangeIDEncrypted
    ) {
      formikParametersAdd.setFieldValue(
        `ParameterNABLTestMethodRangeList[${i}].IsDelete`,
        true
      );
    } else {
      formikParametersAdd.setFieldValue(
        "ParameterNABLTestMethodRangeList",
        ParameterNABLTestMethodRangeList?.filter((x, idx) => idx != i)
      );
    }
  };

  // const handleChangeMaterial = (e) => {
  //   formikParametersAdd.setFieldValue("MaterialText", e?.target?.value ?? "");

  //   setMaterialOptions(
  //     materialOptionsList?.filter((x) =>
  //       x.searchableText
  //         ?.toLowerCase()
  //         .includes(e?.target?.value?.toLowerCase() ?? "")
  //     )
  //   );
  // };

  // const addParameterMaterialType = () => {
  //   let IsValidate = true;
  //   if (
  //     !DepartmentIDEncrypt ||
  //     !ProductGroupIDEncrypt ||
  //     !MaterialTypeIDEncrypt
  //   ) {
  //     IsValidate = false;
  //     formikParametersAdd.setFieldError(
  //       "MaterialID",
  //       "Material is required field"
  //     );
  //     formikParametersAdd.setFieldTouched("MaterialID", true);
  //   }

  //   if (!TestMethodIDEncrypt) {
  //     IsValidate = false;
  //     formikParametersAdd.setFieldError(
  //       "TestMethodIDEncrypt",
  //       "Test Method is required field"
  //     );
  //     formikParametersAdd.setFieldTouched("TestMethodIDEncrypt", true);
  //   }

  //   // if (
  //   //   ParameterMaterialTypeList?.filter((x, i) => i != Parameterindx)?.filter(
  //   //     (x) =>
  //   //       x.DepartmentIDEncrypt == DepartmentIDEncrypt &&
  //   //       x.ProductGroupIDEncrypt == ProductGroupIDEncrypt &&
  //   //       x.MaterialTypeIDEncrypt == MaterialTypeIDEncrypt &&
  //   //       x.TestMethodIDEncrypt == TestMethodIDEncrypt
  //   //   )?.length > 0
  //   // ) {
  //   //   IsValidate = false;
  //   //   //swal("", "Data already exist!", "warning");
  //   //   warningMessage("Data already exist!");
  //   // }
  //   if (
  //     ParameterMaterialTypeList?.filter(
  //       (x, i) =>
  //         x.DepartmentIDEncrypt == DepartmentIDEncrypt &&
  //         x.ProductGroupIDEncrypt == ProductGroupIDEncrypt &&
  //         x.MaterialTypeIDEncrypt == MaterialTypeIDEncrypt &&
  //         x.TestMethodIDEncrypt == TestMethodIDEncrypt &&
  //         (Parameterindx ? i != Parameterindx : 1 == 1)
  //     )?.length > 0
  //   ) {
  //     IsValidate = false;
  //     //swal("", "Data already exist!", "warning");
  //     warningMessage("Data already exist!");
  //   }

  //   if (IsValidate) {
  //     if (Parameterindx != "") {
  //       //edit
  //       let newData = ParameterMaterialTypeList;
  //       newData[Parameterindx].MaterialName = MaterialText;
  //       newData[Parameterindx].DepartmentIDEncrypt = DepartmentIDEncrypt;
  //       newData[Parameterindx].DepartmentName = DepartmentName;
  //       newData[Parameterindx].ProductGroupIDEncrypt = ProductGroupIDEncrypt;
  //       newData[Parameterindx].ProductGroupName = ProductGroupName;
  //       newData[Parameterindx].MaterialTypeIDEncrypt = MaterialTypeIDEncrypt;
  //       newData[Parameterindx].MaterialType = MaterialType;
  //       newData[Parameterindx].TestMethodIDEncrypt = TestMethodIDEncrypt;
  //       newData[Parameterindx].TestMethodName = TestMethodName;
  //       newData[Parameterindx].NABLRangeFrom = NABLRangeFrom;
  //       newData[Parameterindx].NABLRangeTo = NABLRangeTo;
  //       formikParametersAdd.setFieldValue("ParameterMaterialTypeList", newData);
  //     } else {
  //       //add
  //       formikParametersAdd.setFieldValue("ParameterMaterialTypeList", [
  //         ...ParameterMaterialTypeList,
  //         {
  //           ParameterMaterialTypeIDEncrypted: "",
  //           MaterialName: MaterialText,
  //           DepartmentIDEncrypt: DepartmentIDEncrypt,
  //           DepartmentName: DepartmentName,
  //           ProductGroupIDEncrypt: ProductGroupIDEncrypt,
  //           ProductGroupName: ProductGroupName,
  //           MaterialTypeIDEncrypt: MaterialTypeIDEncrypt,
  //           MaterialType: MaterialType,
  //           TestMethodIDEncrypt: TestMethodIDEncrypt,
  //           TestMethodName: TestMethodName,
  //           NABLRangeFrom: NABLRangeFrom,
  //           NABLRangeTo: NABLRangeTo,
  //           IsDeleted: false,
  //         },
  //       ]);
  //     }
  //     cancelParameterMaterialType();
  //   }
  // };

  // const editParameterMaterialType = (idx) => {
  //   let editData = ParameterMaterialTypeList?.filter((x, i) => i == idx)[0];
  //   formikParametersAdd.setFieldValue("Parameterindx", idx.toString());
  //   formikParametersAdd.setFieldValue("MaterialText", editData?.MaterialName);
  //   formikParametersAdd.setFieldValue(
  //     "DepartmentIDEncrypt",
  //     editData?.DepartmentIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "DepartmentName",
  //     editData?.DepartmentName
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "ProductGroupIDEncrypt",
  //     editData?.ProductGroupIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "ProductGroupName",
  //     editData?.ProductGroupName
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "MaterialTypeIDEncrypt",
  //     editData?.MaterialTypeIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue("MaterialType", editData?.MaterialType);
  //   formikParametersAdd.setFieldValue(
  //     "TestMethodIDEncrypt",
  //     editData?.TestMethodIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "TestMethodName",
  //     editData?.TestMethodName
  //   );
  //   formikParametersAdd.setFieldValue("NABLRangeFrom", editData?.NABLRangeFrom);
  //   formikParametersAdd.setFieldValue("NABLRangeTo", editData?.NABLRangeTo);
  // };

  // const setValuesOnSelectMultiColumn = (idx) => {
  //   formikParametersAdd.setFieldValue(
  //     "MaterialText",
  //     materialOptions[idx]?.DepartmentName +
  //       " | " +
  //       materialOptions[idx]?.ProductGroupName +
  //       " | " +
  //       materialOptions[idx]?.MaterialType
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "DepartmentIDEncrypt",
  //     materialOptions[idx]?.DepartmentIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "DepartmentName",
  //     materialOptions[idx]?.DepartmentName
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "ProductGroupIDEncrypt",
  //     materialOptions[idx]?.ProductGroupIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "ProductGroupName",
  //     materialOptions[idx]?.ProductGroupName
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "MaterialTypeIDEncrypt",
  //     materialOptions[idx]?.MaterialTypeIDEncrypt
  //   );
  //   formikParametersAdd.setFieldValue(
  //     "MaterialType",
  //     materialOptions[idx]?.MaterialType
  //   );

  //   /*select the value when there is only one option while insert only*/
  //   if (
  //     testMethodOptions?.length == 1 &&
  //     Parameterindx == "" //Add
  //   ) {
  //     formikParametersAdd.setFieldValue(
  //       "TestMethodIDEncrypt",
  //       testMethodOptions[0]?.value
  //     );
  //     formikParametersAdd.setFieldValue(
  //       "TestMethodName",
  //       testMethodOptions[0]?.label
  //     );
  //   }
  // };

  // const resetValueOnUnSelectMultiColumn = () => {
  //   if (DepartmentIDEncrypt || ProductGroupIDEncrypt || MaterialTypeIDEncrypt) {
  //     formikParametersAdd.setFieldValue("MaterialText", "");
  //     formikParametersAdd.setFieldValue("DepartmentIDEncrypt", "");
  //     formikParametersAdd.setFieldValue("DepartmentName", "");
  //     formikParametersAdd.setFieldValue("ProductGroupIDEncrypt", "");
  //     formikParametersAdd.setFieldValue("ProductGroupName", "");
  //     formikParametersAdd.setFieldValue("MaterialTypeIDEncrypt", "");
  //     formikParametersAdd.setFieldValue("MaterialType", "");
  //     setMaterialOptions(materialOptionsList);
  //   }
  // };

  // const cancelParameterMaterialType = () => {
  //   resetValueOnUnSelectMultiColumn();
  //   formikParametersAdd.setFieldValue("TestMethodIDEncrypt", "");
  //   formikParametersAdd.setFieldValue("TestMethodName", "");
  //   formikParametersAdd.setFieldValue("NABLRangeFrom", "");
  //   formikParametersAdd.setFieldValue("NABLRangeTo", "");
  //   formikParametersAdd.setFieldValue("Parameterindx", "");
  // };

  // const deleteParameterMaterialType = (idx) => {
  //   formikParametersAdd.setFieldValue(
  //     "ParameterMaterialTypeList",
  //     ParameterMaterialTypeList?.filter((x, i) => i != idx)
  //   );
  //   // }
  //   cancelParameterMaterialType();
  // };

  const addNonStandardParameters = () => {
    formikNonStandardParametersAdd.resetForm();
    //getNonStandardParametersList();
    setAddNonStandardParametersModal(true);

    // let len = ListOfTestMasterNonStandardParameters?.filter(
    //   (x) => x.IsDelete == false
    // ).length;
    // len = len + 1;
    // formik.setFieldValue("ListOfTestMasterNonStandardParameters", [
    //   ...ListOfTestMasterNonStandardParameters,
    //   { ...initialNonStandardParameter, DisplaySequence: len },
    // ]);
  };

  const validationSchemaNonStandardParametersAdd = Yup.object().shape({
    NonParameterName: Yup.string()
      .trim()
      .required("Parameter Name is required field"),
    // DisplayCode: Yup.string().trim().required("Display Code is required field"),
    // DisplayName: Yup.string().trim().required("Display Name is required field"),
    // Requirement: Yup.string().trim().required("Requirement is required field"),
    // DefaultValue: Yup.string()
    //   .trim()
    //   .required("Default Value is required field"),
    AdditionalChargeAmount: Yup.string().when(
      "ConsiderAdditionalCharge",
      ([ConsiderAdditionalCharge], schema) => {
        if (ConsiderAdditionalCharge == true)
          return Yup.string().required("Additional Amount is required field");
        return schema;
      }
    ),
  });

  // const initialNonStandardParameter = {
  //   TestMasterNonStandardParameterIDEncrypted: "",
  //   NonParameterName: "",
  //   DisplayCode: "",
  //   DisplayName: "",
  //   Requirement: "",
  //   DefaultValue: "",
  //   ConsiderAdditionalCharge: false,
  //   AdditionalChargeAmount: "",
  //   DisplaySequence: 0,
  //   IsDelete: false,
  // };

  const formikNonStandardParametersAdd = useFormik({
    validationSchema: validationSchemaNonStandardParametersAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitNonStandardParametersAdd(values, formikHelpers),
    initialValues: {
      TestMasterNonStandardParameterIDEncrypted: "",
      NonParameterName: "",
      DisplayCode: "",
      DisplayName: "",
      Requirement: "",
      DefaultValue: "",
      ConsiderAdditionalCharge: false,
      AdditionalChargeAmount: "",
      DisplaySequence: 0,
      indx: "",
      IsDelete: false,
      ShortCode: "",
      FormulaExpression: "",
      FormulaVariables: "",
      FormulaEvaluationStatus: 0,
      IsAverageRequired: false,
      //ListOfNonParameterName: [],
    },
    validateOnBlur: false,
  });

  const {
    values: {
      TestMasterNonStandardParameterIDEncrypted,
      ConsiderAdditionalCharge,
      NonParameterName,
      //ListOfNonParameterName,
    },
  } = formikNonStandardParametersAdd;

  const handleValidSubmitNonStandardParametersAdd = (values) => {
    if (
      values?.ShortCode?.trim()?.toLowerCase() == "pi" ||
      values?.ShortCode?.trim()?.toLowerCase() == "e" ||
      values?.ShortCode?.trim()?.toLowerCase() == "null"
    ) {
      formikNonStandardParametersAdd.setFieldError(
        "ShortCode",
        "'Pi', 'E' & 'NULL' can not be used as short code"
      );
      formikNonStandardParametersAdd.setFieldTouched("ShortCode", true);
      return;
    } else if (values?.ShortCode && (values?.ShortCode?.trim() ?? "") !== "") {
      if (
        ListOfTestMasterNonStandardParameters?.filter(
          (x, i) =>
            x.ShortCode?.trim() == values?.ShortCode?.trim() &&
            (values?.indx !== "" ? i != values?.indx : 1 == 1)
        )?.length > 0 ||
        ListOfTestMasterStandardParameters?.filter(
          (x) => x.ShortCode?.trim() == values?.ShortCode?.trim()
        )?.length > 0
      ) {
        formikNonStandardParametersAdd.setFieldError(
          "ShortCode",
          "Parameter short code should be unique."
        );
        formikNonStandardParametersAdd.setFieldTouched("ShortCode", true);
        return;
      }
    }

    if (values?.indx !== "") {
      formik.setFieldValue(
        "ListOfTestMasterNonStandardParameters",
        ListOfTestMasterNonStandardParameters?.map((x, idx) => {
          if (idx == values?.indx) {
            return {
              ...x,
              NonParameterName:
                values?.NonParameterName?.charAt(0).toUpperCase() +
                values?.NonParameterName?.slice(1),
              DisplayCode: values?.DisplayCode,
              DisplayName: values?.DisplayName,
              Requirement: values?.Requirement,
              DefaultValue: values?.DefaultValue,
              ConsiderAdditionalCharge: values?.ConsiderAdditionalCharge,
              AdditionalChargeAmount: values?.AdditionalChargeAmount
                ? values?.AdditionalChargeAmount
                : 0,
              DisplaySequence: values?.DisplaySequence,
              IsDelete: false,
              ShortCode: values?.ShortCode?.trim(),
              IsAverageRequired: values?.IsAverageRequired,
            };
          } else {
            return { ...x };
          }
        })
      );
    } else {
      // let len = ListOfTestMasterNonStandardParameters.length;
      let len = ListOfTestMasterNonStandardParameters?.filter(
        (x) => x.IsDelete == false
      ).length;
      len = len + 1;

      formik.setFieldValue("ListOfTestMasterNonStandardParameters", [
        ...ListOfTestMasterNonStandardParameters,
        {
          ...values,
          NonParameterName:
            values?.NonParameterName?.charAt(0).toUpperCase() +
            values?.NonParameterName?.slice(1),
          DisplaySequence: len,
          IsDelete: false,
          TestMasterNonStandardParameterIDEncrypted: "",
          AdditionalChargeAmount: values?.ConsiderAdditionalCharge
            ? values?.AdditionalChargeAmount
            : 0,
        },
      ]);
    }

    // if (values?.ConsiderAdditionalCharge == true) {
    //   const updatedList = ListOfMachineWiseParameterRate.map((x) => ({
    //     ...x,
    //     ParameterName: values?.NonParameterName,
    //     ParameterRate: x?.ParameterRate ? x?.ParameterRate : "0.00",
    //   }));

    //   const mergedList = [
    //     ...ListOfMachineWiseParameterRateFinal,
    //     ...updatedList,
    //   ];

    //   formik.setFieldValue("ListOfMachineWiseParameterRateFinal", mergedList);
    //   formikMachineWiseParameterRate.setFieldValue(
    //     "ListOfMachineWiseParameterRate",
    //     []
    //   );
    // }

    setAddNonStandardParametersModal(false);
    if (IsMixDesign == true) {
      setIsPrintingGroupAdd(true);
    }
  };

  const editNonStandardParameters = (i) => {
    let editData = ListOfTestMasterNonStandardParameters?.filter(
      (x, index) => index == i
    )[0];

    formikNonStandardParametersAdd.setValues({
      TestMasterNonStandardParameterIDEncrypted:
        editData?.TestMasterNonStandardParameterIDEncrypted,
      NonParameterName: editData?.NonParameterName,
      DisplayCode: editData?.DisplayCode,
      DisplayName: editData?.DisplayName,
      Requirement: editData?.Requirement,
      DefaultValue: editData?.DefaultValue,
      ConsiderAdditionalCharge: editData?.ConsiderAdditionalCharge,
      AdditionalChargeAmount:
        editData?.ConsiderAdditionalCharge == true
          ? editData?.AdditionalChargeAmount
          : "",
      DisplaySequence: editData?.DisplaySequence,
      indx: i,
      IsDelete: editData?.IsDelete,
      ShortCode: editData?.ShortCode,
      IsAverageRequired: editData?.IsAverageRequired,
    });

    setAddNonStandardParametersModal(true);
  };

  const deleteNonStandardParameters = (i) => {
    formik.setFieldValue(
      "ListOfTestMasterNonStandardParameters",
      ListOfTestMasterNonStandardParameters?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            IsDelete: true,
          };
        } else {
          return { ...x };
        }
      })
    );

    // formik.setFieldValue(
    //   "ListOfTestMasterNonStandardParameters",
    //   ListOfTestMasterNonStandardParameters?.filter((x, idx) => idx != i)
    // );
  };

  // const handleChangeSearchNonParameterName = (e) => {
  //   formikNonStandardParametersAdd.setFieldValue(
  //     "NonParameterName",
  //     e?.target?.value
  //   );

  //   formikNonStandardParametersAdd.setFieldValue(
  //     "ListOfNonParameterName",
  //     ListOfNonParameterName?.map((x) => {
  //       return {
  //         ...x,

  //         display: x.ParameterName?.toLowerCase().includes(
  //           e?.target?.value?.toLowerCase()
  //         )
  //           ? true
  //           : false,
  //       };
  //     })
  //   );
  // };

  // const getStandaradParameterList = async (
  //   departmentID,
  //   productGroupID,
  //   listOfMaterialType,
  //   listOfTestMethod
  // ) => {
  //   let selectedMaterialData = "";
  //   let selectedTestMethodData = "";

  //   formik.setFieldValue("ListOfTestMasterStandardParameters", []);

  //   selectedMaterialData = Array.from(
  //     listOfMaterialType?.filter((e) => e.IsSelected == true),
  //     (x) => x.MaterialCategoryIDEncrypt
  //   ).join(",");

  //   selectedTestMethodData = Array.from(
  //     listOfTestMethod?.filter((e) => e.IsSelected == true),
  //     (x) => x.TestMethodIDEncrypt
  //   ).join(",");

  //   setIsLoading(true);
  //   await post(POST_GetStandardParameterList, {
  //     CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
  //     MaterialTypeIDs: selectedMaterialData,
  //     TestMethodIDs: selectedTestMethodData,
  //     TestMasterIDEncrypt: TestMasterIDEncrypt,
  //     ProductGroupIDEncrypt: productGroupID,
  //     DepartmentIDEncrypt: departmentID,
  //   })
  //     .then((response) => {
  //       if (response?.IsSuccess) {
  //         formik.setFieldValue(
  //           "ListOfTestMasterStandardParameters",
  //           response?.GetStandardParameterList?.map((item, idx) => ({
  //             ParameterIDEncrypt: item.ParameterIDEncrypt,
  //             TestMethodID: item.TestMethodID,
  //             ParameterName: item.ParameterName,
  //             DisplayName: item.DisplayName,
  //             Requirement: item.Requirement,
  //             DefaultValue: item.DefaultValue,
  //             ConsiderAdditionalCharge: item.ConsiderAdditionalCharge,
  //             AdditionalChargeAmount: item.AdditionalChargeAmount,
  //             DisplaySequence: idx + 1,
  //             //item.DisplaySequence > 0 ? item.DisplaySequence : idx + 1,
  //             TestMasterStandardParameterIDEncrypt:
  //               item.TestMasterStandardParameterIDEncrypt
  //                 ? item.TestMasterStandardParameterIDEncrypt
  //                 : "0",
  //             IsDelete: false,
  //             IsSelected: TestMasterIDEncrypt ? item.IsSelected : true,
  //             IsShow: true,
  //           }))
  //         );
  //       }
  //       setIsLoading(false);
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //       setIsLoading(false);
  //     });
  // };

  // const deleteStandardParameters = (i) => {
  //   formik.setFieldValue(
  //     "ListOfTestMasterStandardParameters",
  //     ListOfTestMasterStandardParameters?.map((x, idx) => {
  //       if (idx == i) {
  //         return {
  //           ...x,
  //           IsDelete: true,
  //         };
  //       } else {
  //         return { ...x };
  //       }
  //     })
  //   );
  //   // formik.setFieldValue(
  //   //   "ListOfTestMasterStandardParameters",
  //   //   ListOfTestMasterStandardParameters?.filter((x, idx) => idx != i)
  //   // );
  // };

  const setConsiderAdditionalCharge = (i, checkflag) => {
    formik.setFieldValue(
      "ListOfTestMasterStandardParameters",
      ListOfTestMasterStandardParameters?.map((x, idx) => {
        if (idx == i) {
          return {
            ...x,
            ConsiderAdditionalCharge: checkflag,
            AdditionalChargeAmount:
              checkflag == false && IsRecordEdit == true
                ? ""
                : x.AdditionalChargeAmount,
          };
        } else {
          return { ...x };
        }
      })
    );
  };

  // const setHideRow = () => {
  //   formikNonStandardParametersAdd.setFieldValue(
  //     "ListOfNonParameterName",
  //     ListOfNonParameterName?.map((x) => {
  //       return {
  //         ...x,
  //         display: false,
  //       };
  //     })
  //   );
  // };

  const reorder = (list, startIndex, endIndex) => {
    //console.log("List", list);
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListOfTestMasterNonStandardParameters,
      result.source.index,
      result.destination.index
    );

    // //formik.setFieldValue("ListOfTestMasterNonStandardParameters", items);
    // formik.setFieldValue(
    //   "ListOfTestMasterNonStandardParameters",
    //   items?.map((x, idx) => {
    //     return {
    //       ...x,
    //       DisplaySequence: idx + 1,
    //     };
    //   })
    // );

    let newList = [];
    Promise.all(
      items
        ?.filter((item) => item.IsDelete === false)
        ?.map((x, idx) => {
          newList.push({
            ...x,
            DisplaySequence: idx + 1,
          });
        })
    );
    Promise.all(
      items
        ?.filter((item) => item.IsDelete === true)
        ?.map((x, idx) => {
          newList.push({
            ...x,
            DisplaySequence: 0,
          });
        })
    );

    formik.setFieldValue("ListOfTestMasterNonStandardParameters", newList);
  };

  const onDragSTParaEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const items = reorder(
      ListOfTestMasterStandardParameters,
      result.source.index,
      result.destination.index
    );

    //formik.setFieldValue("ListOfTestMasterStandardParameters", items);
    // formik.setFieldValue(
    //   "ListOfTestMasterStandardParameters",
    //   items?.map((x, idx) => {
    //     return {
    //       ...x,
    //       DisplaySequence: idx + 1,
    //     };
    //   })
    // );

    let newList = [];
    Promise.all(
      items
        //?.filter((item) => item.IsDelete === false)
        ?.map((x, idx) => {
          newList.push({
            ...x,
            DisplaySequence: idx + 1,
          });
        })
    );

    // items
    //   //?.filter((item) => item.IsDelete === true)
    //   ?.map((x, idx) => {
    //     newList.push({
    //       ...x,
    //       DisplaySequence: 0,
    //     });
    //   });
    formik.setFieldValue("ListOfTestMasterStandardParameters", newList);
  };

  // const setConsiderAdditionalChargeNonStdPara = (i, checkflag) => {
  //   formik.setFieldValue(
  //     "ListOfTestMasterNonStandardParameters",
  //     ListOfTestMasterNonStandardParameters?.map((x, idx) => {
  //       if (idx == i) {
  //         return {
  //           ...x,
  //           ConsiderAdditionalCharge: checkflag,
  //         };
  //       } else {
  //         return { ...x };
  //       }
  //     })
  //   );
  // };

  const getStandardParametersListUnmapped = async (searchText) => {
    // let selectedMaterialData = "";
    // let selectedTestMethodData = "";

    // selectedMaterialData = Array.from(
    //   ListMaterialType?.filter((e) => e.IsSelected == true),
    //   (x) => x.MaterialCategoryIDEncrypt
    // ).join(",");

    // selectedTestMethodData = Array.from(
    //   ListTestMethod?.filter((e) => e.IsSelected == true),
    //   (x) => x.TestMethodIDEncrypt
    // ).join(",");

    // setIsLoading(true);
    // await post(POST_GetStandardParameterListUnmapped, {
    //   CurrentPage: 1,
    //   PageSize: 100,
    //   Search: searchText,
    //   Sorting: "",
    //   MaterialTypeIDs: selectedMaterialData,
    //   TestMethodIDs: selectedTestMethodData,
    //   TestMasterIDEncrypt: TestMasterIDEncrypt,
    //   ProductGroupIDEncrypt: ProductGroupID,
    //   DepartmentIDEncrypt: DepartmentID,
    //   CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    // })
    //   .then((response) => {
    //     if (response?.IsSuccess) {
    //       setStandardParameterUnmappedOptions(
    //         response?.ParameterList?.map((item) => ({
    //           ParameterIDEncrypt: item.ParameterIDEncrypt,
    //           ParameterName: item.ParameterName,
    //           name: item.ParameterName,
    //           value: item.ParameterIDEncrypt,
    //         }))
    //       );
    //     }
    //     setIsLoading(false);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     setIsLoading(false);
    //   });

    setIsLoading(true);
    await post(POST_GetParameterDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypt: DepartmentID,
      SearchParameterName: searchText ?? "",
      Unmapped: true,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setStandardParameterUnmappedOptions(
            response?.ParameterList?.map((item) => ({
              ParameterIDEncrypt: item.ParameterIDEncrypt,
              ParameterName: item.ParameterName,
              name: item.ParameterName,
              value: item.ParameterIDEncrypt,
            }))
          );
        } else {
          setStandardParameterUnmappedOptions([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setStandardParameterUnmappedOptions([]);
        setIsLoading(false);
      });
  };

  const handleChangeSearchParameter = (e) => {
    formik.setFieldValue(
      "ListOfTestMasterStandardParameters",
      ListOfTestMasterStandardParameters?.map((x) => {
        if (
          e?.target?.value &&
          x.ParameterName?.toLowerCase().includes(
            e?.target?.value?.trim().toLowerCase()
          ) == false
        ) {
          return {
            ...x,
            IsShow: false,
          };
        } else {
          return { ...x, IsShow: true };
        }
      })
    );
  };

  const validationSchemaStandardParametersAdd = Yup.object().shape({
    ParameterIDEncrypted: Yup.string().required(
      "Parameter Name is required field"
    ),
    // DisplayName: Yup.string().trim().required("Display Name is required field"),
    // Requirement: Yup.string().trim().required("Requirement is required field"),
    // DefaultValue: Yup.string()
    //   .trim()
    //   .required("Default Value is required field"),
    AdditionalChargeAmount: Yup.string().when(
      "ConsiderAdditionalChargeStandardPara",
      ([ConsiderAdditionalChargeStandardPara], schema) => {
        if (ConsiderAdditionalChargeStandardPara == true)
          return Yup.string().required("Additional Amount is required field");
        return schema;
      }
    ),
  });

  const formikStandardParametersAdd = useFormik({
    validationSchema: validationSchemaStandardParametersAdd,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitStandardParametersAdd(values, formikHelpers),
    initialValues: {
      TestMasterStandardParameterIDEncrypted: "",
      ParameterIDEncrypted: "",
      ParameterName: "",
      DisplayName: "",
      Requirement: "",
      DefaultValue: "",
      ConsiderAdditionalChargeStandardPara: false,
      AdditionalChargeAmount: "",
      DisplaySequence: 0,
      ShortCode: "",
      FormulaExpression: "",
      FormulaVariables: "",
      FormulaEvaluationStatus: 0,
      IsAverageRequired: false,
    },
    validateOnBlur: false,
  });

  const {
    values: {
      ConsiderAdditionalChargeStandardPara,
      ParameterName,
      ParameterIDEncrypted,
    },
  } = formikStandardParametersAdd;

  const addNewStandardParameters = () => {
    if (DepartmentID) {
      formikStandardParametersAdd.resetForm();
      setShowAddStandardParametersModal(true);
    } else {
      warningMessage("Please select Department first...");
    }
  };

  const handleValidSubmitStandardParametersAdd = (values) => {
    if (
      ListOfTestMasterStandardParameters?.filter(
        (x) =>
          x?.IsDelete == false &&
          x?.ParameterIDEncrypted == values?.ParameterIDEncrypted
      ).length == 0
    ) {
      let len = ListOfTestMasterStandardParameters?.filter(
        (x) => x?.IsDelete == false
      ).length;
      len = len + 1;

      formik.setFieldValue("ListOfTestMasterStandardParameters", [
        ...ListOfTestMasterStandardParameters,
        {
          ...values,
          ConsiderAdditionalCharge:
            values?.ConsiderAdditionalChargeStandardPara,
          AdditionalChargeAmount:
            values?.ConsiderAdditionalChargeStandardPara == true
              ? values?.AdditionalChargeAmount
              : "",
          DisplaySequence: len,
          IsSelected: true,
          IsDelete: false,
        },
      ]);

      // if (values?.ConsiderAdditionalChargeStandardPara == true) {
      //   const updatedList = ListOfMachineWiseParameterRate.map((x) => ({
      //     ...x,
      //     ParameterIDEncrypted: values?.ParameterIDEncrypted,
      //     ParameterRate: x?.ParameterRate ? x?.ParameterRate : "0.00",
      //   }));

      //   const mergedList = [
      //     ...ListOfMachineWiseParameterRateFinal,
      //     ...updatedList,
      //   ];

      //   formik.setFieldValue("ListOfMachineWiseParameterRateFinal", mergedList);
      //   formikMachineWiseParameterRate.setFieldValue(
      //     "ListOfMachineWiseParameterRate",
      //     []
      //   );
      // }

      setShowAddStandardParametersModal(false);
      formikStandardParametersAdd.resetForm();
      if (IsMixDesign == true) {
        setIsPrintingGroupAdd(true);
      }
    } else {
      errorMessage("Standard Parameter already exists!");
    }
  };

  const [refreshParameterKey, setRefreshParameterKey] = useState("0");

  const loadOptionsParameter = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getParameterDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const getParameterDDL_AJAX = (inputValue) => {
    return post(POST_GetParameterDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      DepartmentIDEncrypt: DepartmentID,
      SearchParameterName: inputValue ?? "",
      Unmapped: false,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.ParameterList?.map((item) => ({
            label: item.ParameterName,
            value: item.ParameterIDEncrypt,
            ShortCode: item.ShortCode,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  // const [
  //   showMachineWiseParameterRateModal,
  //   setShowMachineWiseParameterRateModal,
  // ] = useState(false);
  // const initMachineWiseParameterRateList = {
  //   MachineParameterRateIDEncrypt: "",
  //   RefParameterIDEncrypt: "",
  //   ParameterIDEncrypted: "",
  //   MachinesIDEncrypt: "",
  //   MachinesName: "",
  //   ParameterName: "",
  //   ParameterRate: "0.00",
  //   ParameterType: "",
  //   IsDelete: false,
  // };

  // const validationMachineWiseParameterRateSchema = Yup.object().shape({});

  // const formikMachineWiseParameterRate = useFormik({
  //   validationMachineWiseParameterRateSchema,
  //   onSubmit: (values, formikHelpers) =>
  //     handleValidMachineWiseParameterRateSubmit(values, formikHelpers),
  //   initialValues: {
  //     ParameterListIndex: -1,
  //     ListOfMachineWiseParameterRate: [initMachineWiseParameterRateList],
  //   },
  //   validateOnBlur: false,
  // });

  // const {
  //   values: { ListOfMachineWiseParameterRate },
  // } = formikMachineWiseParameterRate;

  // const handleValidMachineWiseParameterRateSubmit = (values) => {
  //   if (PrimaryIdParam) {
  //     console.log(
  //       "ListOfMachineWiseParameterRate",
  //       ListOfMachineWiseParameterRate
  //     );
  //     const updatedList = ListOfMachineWiseParameterRate.map((x) => ({
  //       ...x,
  //       ParameterRate: x?.ParameterRate ? x?.ParameterRate : "0.00",
  //     }));

  //     const mergedList = [
  //       ...updatedList,
  //       ...ListOfMachineWiseParameterRateFinal,
  //     ];

  //     console.log("mergedList", mergedList);

  //     formik.setFieldValue("ListOfMachineWiseParameterRateFinal", mergedList);
  //     formikMachineWiseParameterRate.setFieldValue(
  //       "ListOfMachineWiseParameterRate",
  //       []
  //     );
  //   }

  //   setShowMachineWiseParameterRateModal(false);
  // };

  // const getMachineWiseParameterRateList = (PID, PType, PName) => {
  //   formikMachineWiseParameterRate.setFieldValue(
  //     "ListOfMachineWiseParameterRate",
  //     []
  //   );
  //   setShowMachineWiseParameterRateModal(true);

  //   const listofsparameterrate = [];
  //   const listofnonparameterrate = [];

  //   if (PrimaryIdParam) {
  //     if (PType == 1) {
  //       ListOfTestMasterStandardParameters?.map((x, idx) => {
  //         if (x?.ParameterIDEncrypted == PID) {
  //           if (x?.ListOfMachineWiseParameterRate?.length > 0) {
  //             x?.ListOfMachineWiseParameterRate?.map((r, rIndex) =>
  //               listofsparameterrate.push({
  //                 MachineParameterRateIDEncrypt:
  //                   r?.MachineParameterRateIDEncrypt,
  //                 RefParameterIDEncrypt: r?.RefParameterIDEncrypt,
  //                 ParameterIDEncrypted: r?.ParameterIDEncrypted,
  //                 MachinesIDEncrypt: r?.MachinesIDEncrypt,
  //                 MachinesName: r?.MachinesName,
  //                 ParameterName: r?.ParameterName,
  //                 ParameterRate: r?.ParameterRate ? r?.ParameterRate : "0.00",
  //                 ParameterType: r?.ParameterType,
  //                 IsDelete: false,
  //               })
  //             );
  //           } else {
  //             ListMachines?.filter((e) => e.IsSelected == true).map((x) =>
  //               listofsparameterrate.push({
  //                 MachineParameterRateIDEncrypt: "",
  //                 RefParameterIDEncrypt: "",
  //                 ParameterIDEncrypted: PID ? PID : "0",
  //                 MachinesIDEncrypt: x?.MachinesIDEncrypt,
  //                 MachinesName: x?.MachinesName,
  //                 ParameterName: PName,
  //                 ParameterRate: "0.00",
  //                 ParameterType: PType,
  //                 IsDelete: false,
  //               })
  //             );
  //           }
  //         }
  //       });

  //       const newMachineAdd = [];

  //       ListMachines?.filter((e) => e.IsSelected).forEach((rx) => {
  //         const isMachinePresent = listofsparameterrate?.some(
  //           (x) => x?.MachinesIDEncrypt === rx?.MachinesIDEncrypt
  //         );

  //         if (!isMachinePresent) {
  //           newMachineAdd.push({
  //             MachineParameterRateIDEncrypt: "",
  //             RefParameterIDEncrypt: "",
  //             ParameterIDEncrypted: PID ? PID : "0",
  //             MachinesIDEncrypt: rx?.MachinesIDEncrypt,
  //             MachinesName: rx?.MachinesName,
  //             ParameterName: PName,
  //             ParameterRate: "0.00",
  //             ParameterType: PType,
  //             IsDelete: false,
  //           });
  //         }
  //       });

  //       formikMachineWiseParameterRate.setFieldValue(
  //         "ListOfMachineWiseParameterRate",
  //         [...listofsparameterrate, ...newMachineAdd]
  //       );
  //     } else {
  //       ListOfTestMasterNonStandardParameters?.map((x, idx) => {
  //         if (x?.ParameterName == PName) {
  //           x?.ListOfMachineWiseParameterRate?.map((r, rIndex) =>
  //             listofnonparameterrate.push({
  //               MachineParameterRateIDEncrypt: r?.MachineParameterRateIDEncrypt,
  //               RefParameterIDEncrypt: r?.RefParameterIDEncrypt,
  //               ParameterIDEncrypted: r?.ParameterIDEncrypted,
  //               MachinesIDEncrypt: r?.MachinesIDEncrypt,
  //               MachinesName: r?.MachinesName,
  //               ParameterName: r?.ParameterName,
  //               ParameterRate: r?.ParameterRate ? r?.ParameterRate : "0.00",
  //               ParameterType: r?.ParameterType,
  //               IsDelete: false,
  //             })
  //           );
  //         }
  //       });

  //       const newMachineAdd = [];

  //       ListMachines?.filter((e) => e.IsSelected).forEach((rx) => {
  //         const isMachinePresent = listofnonparameterrate?.some(
  //           (x) => x?.MachinesIDEncrypt === rx?.MachinesIDEncrypt
  //         );

  //         if (!isMachinePresent) {
  //           newMachineAdd.push({
  //             MachineParameterRateIDEncrypt: "",
  //             RefParameterIDEncrypt: "",
  //             ParameterIDEncrypted: PID ? PID : "0",
  //             MachinesIDEncrypt: rx?.MachinesIDEncrypt,
  //             MachinesName: rx?.MachinesName,
  //             ParameterName: PName,
  //             ParameterRate: "0.00",
  //             ParameterType: PType,
  //             IsDelete: false,
  //           });
  //         }
  //       });

  //       formikMachineWiseParameterRate.setFieldValue(
  //         "ListOfMachineWiseParameterRate",
  //         [...listofnonparameterrate, ...newMachineAdd]
  //       );
  //     }
  //   } else {
  //     formikMachineWiseParameterRate.setFieldValue(
  //       "ListOfMachineWiseParameterRate",
  //       ListMachines?.filter((e) => e.IsSelected == true).map((x) => ({
  //         MachineParameterRateIDEncrypt: "",
  //         RefParameterIDEncrypt: "",
  //         ParameterIDEncrypted: PID ? PID : "0",
  //         MachinesIDEncrypt: x?.MachinesIDEncrypt,
  //         MachinesName: x?.MachinesName,
  //         ParameterName: PName,
  //         ParameterRate: "0.00",
  //         ParameterType: PType,
  //         IsDelete: false,
  //       }))
  //     );
  //   }

  //   //console.log("ListMachines", ListOfMachineWiseParameterRate);
  // };

  const [showParameterFormulaModal, setShowParameterFormulaModal] =
    useState(false);

  const validationSchemaParameterFormula = Yup.object().shape({});

  const formikParameterFormula = useFormik({
    validationSchema: validationSchemaParameterFormula,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitParameterFormula(values, formikHelpers),
    initialValues: {
      ParameterType: 0,
      indexOfSelectedPara: 0,
      ParameterName: "",
      FormulaExpression: "",
      ParameterShortCodeList: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikParameterFormula;

  const handleValidSubmitParameterFormula = async (values) => {
    if (values?.FormulaExpression?.trim() !== "") {
      let result = await evaluateFormulaExpression(values?.FormulaExpression);
      if (result?.status == true) {
        //console.log("FormulaVariables: ", result?.FormulaVariables);

        if (values?.ParameterType == 1) {
          ListOfTestMasterStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaExpression = values?.FormulaExpression;
          ListOfTestMasterStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaVariables = result?.FormulaVariables;
          ListOfTestMasterStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaEvaluationStatus = 1;
        }
        if (values?.ParameterType == 2) {
          ListOfTestMasterNonStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaExpression = values?.FormulaExpression;
          ListOfTestMasterNonStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaVariables = result?.FormulaVariables;
          ListOfTestMasterNonStandardParameters[
            values?.indexOfSelectedPara
          ].FormulaEvaluationStatus = 1;
        }
        setShowParameterFormulaModal(false);
      }
    } else {
      if (values?.ParameterType == 1) {
        ListOfTestMasterStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaExpression = "";
        ListOfTestMasterStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaVariables = "";
        ListOfTestMasterStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaEvaluationStatus = 0;
      }
      if (values?.ParameterType == 2) {
        ListOfTestMasterNonStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaExpression = "";
        ListOfTestMasterNonStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaVariables = "";
        ListOfTestMasterNonStandardParameters[
          values?.indexOfSelectedPara
        ].FormulaEvaluationStatus = 0;
      }
      setShowParameterFormulaModal(false);
    }
  };

  const openParameterFormulaDialog = (
    parameterType,
    indexOfParameter,
    parameterName
  ) => {
    formikParameterFormula.resetForm();
    formikParameterFormula.setFieldValue("ParameterName", parameterName);
    formikParameterFormula.setFieldValue(
      "indexOfSelectedPara",
      indexOfParameter
    );
    formikParameterFormula.setFieldValue("ParameterType", parameterType);
    let formulaExp = "";
    if (parameterType == 1) {
      formulaExp =
        ListOfTestMasterStandardParameters[indexOfParameter]?.FormulaExpression;
    }
    if (parameterType == 2) {
      formulaExp =
        ListOfTestMasterNonStandardParameters[indexOfParameter]
          ?.FormulaExpression;
    }
    formikParameterFormula.setFieldValue("FormulaExpression", formulaExp);
    let shortCodeParaList = [
      ...ListOfTestMasterStandardParameters?.filter((x) => x.ShortCode !== ""),
      ...ListOfTestMasterNonStandardParameters?.filter(
        (x) => x.ShortCode !== "" && x.IsDelete == false
      )?.map((p) => ({ ...p, ParameterName: p.NonParameterName })),
    ];

    if (IsMixDesign == true && ListOfMixDesignTestShortCodes?.length > 0) {
      shortCodeParaList = [
        ...shortCodeParaList,
        ...ListOfMixDesignTestShortCodes,
      ];
    }

    formikParameterFormula.setFieldValue(
      "ParameterShortCodeList",
      shortCodeParaList
    );
    setShowParameterFormulaModal(true);
  };

  const onCancelParameterFormulaDialog = () => {
    customConfirmDialog(
      "Parameter Formula",
      "Are you sure you want to cancel?",
      () => {
        setShowParameterFormulaModal(false);
      },
      true
    );
  };

  const evaluateFormulaExpression = (formulaExpression) => {
    setIsLoading(true);

    let stdParaCodes = ListOfTestMasterStandardParameters?.filter(
      (x) => x.IsDelete == false && x.ShortCode != "" && x.IsSelected == true
    )?.map((item) => item.ShortCode);

    let nonStdParaCodes = ListOfTestMasterNonStandardParameters?.filter(
      (x) => x.IsDelete == false && x.ShortCode != ""
    )?.map((item) => item.ShortCode);

    let shortCodeList = [...stdParaCodes, ...nonStdParaCodes];

    if (IsMixDesign == true && ListOfMixDesignTestShortCodes?.length > 0) {
      shortCodeList = [
        ...shortCodeList,
        ...ListOfMixDesignTestShortCodes?.map((item) => item.ShortCode),
      ];
    }

    let testMasterShortCodes = shortCodeList?.join(",");

    return post(POST_ValidateFormulaExpression, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      FormulaExpression: formulaExpression,
      TestParametersShortCodes: testMasterShortCodes,
    })
      .then((response) => {
        setIsLoading(false);
        if (response?.IsSuccess) {
          return { status: true, FormulaVariables: response.FormulaVariables };
        } else {
          errorMessage(response?.Message);
          return { status: false, FormulaVariables: "" };
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        return { status: false, FormulaVariables: "" };
      });
  };

  const [showMixDesignTestModal, setShowMixDesignTestModal] = useState(false);

  const validationSchemaMixDesignTest = Yup.object().shape({});

  const formikMixDesignTest = useFormik({
    validationSchema: validationSchemaMixDesignTest,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitMixDesignTest(values, formikHelpers),
    initialValues: {
      searchTests: "",
      TestMasterList: [],
    },
    validateOnBlur: false,
  });

  const {
    values: { searchTests, TestMasterList },
  } = formikMixDesignTest;

  const openMixDesignTestDialog = async () => {
    if (DepartmentID) {
      formikMixDesignTest.resetForm();
      await getTestDDLByDepartmentID(DepartmentID);
      setShowMixDesignTestModal(true);
    } else {
      warningMessage("Please select Department first...");
    }
  };

  const handleValidSubmitMixDesignTest = (values) => {
    let mixDesignTestList = values.TestMasterList?.filter(
      (x) => x.IsSelected == true
    );
    formik.setFieldValue("ListOfMixDesignTest", mixDesignTestList);
    if (mixDesignTestList?.length > 0) {
      GetShortCodesOfTestIncludesInMixDesign(mixDesignTestList);
    } else {
      formik.setFieldValue("ListOfMixDesignTestShortCodes", []);
    }
    setShowMixDesignTestModal(false);
  };

  const getTestDDLByDepartmentID = async (departmentID) => {
    if (departmentID) {
      setIsLoading(true);
      await post(POST_GetDDLTestMasterByDepartmentProductGroupMaterialType, {
        CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
        DepartmentIDEncrypted: departmentID,
        TestType: 1, // 0 - All, 1 - DT, 2 - NDT
      })
        .then((response) => {
          if (response?.IsSuccess) {
            let testList = response?.List?.filter(
              (x) => x.TestMasterIDEncrypted !== TestMasterIDEncrypt
            )?.map((item) => ({
              ...item,
              display: true,
              IsSelected:
                ListOfMixDesignTest?.filter(
                  (x) => x.TestMasterIDEncrypted == item.TestMasterIDEncrypted
                )?.length > 0
                  ? true
                  : false,
            }));
            /*set Tests List with selected on top*/
            formikMixDesignTest.setFieldValue(
              "TestMasterList",
              testList?.sort((a, b) => {
                if (a.IsSelected === b.IsSelected) return 0;
                return a.IsSelected ? -1 : 1;
              })
            );
          }
          setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false);
        });
    }
  };

  const handleChangeSearchTests = (e) => {
    formikMixDesignTest.setFieldValue("searchTests", e?.target?.value);
    formikMixDesignTest.setFieldValue(
      "TestMasterList",
      TestMasterList?.map((x) => {
        return {
          ...x,
          display: x.TestName?.toLowerCase().includes(
            e?.target?.value?.toLowerCase()
          )
            ? true
            : false,
        };
      })
    );
  };

  const GetShortCodesOfTestIncludesInMixDesign = async (listOfTests) => {
    setIsLoading(true);
    await post(POST_GetShortCodesByMultipleTestIDs, {
      TestMasterIDsIncludesInMixDesign: Array.from(
        listOfTests?.filter((e) => e.IsSelected == true),
        (x) => x.TestMasterIDEncrypted
      ).join(","),
    })
      .then((response) => {
        if (response.IsSuccess) {
          formik.setFieldValue(
            "ListOfMixDesignTestShortCodes",
            response.ListOfShortCodes
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getUnitDDL = async () => {
    // setIsLoading(true);
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, //Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setUnitOptions(
            response?.List?.map((item) => ({
              label: item?.CategoryName,
              value: item?.CategoryID,
            }))
          );
        }
        // setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const RateTypeOptions = [
    { label: "Upto Element", value: 1 },
    { label: "Indentification of Material", value: 2 },
    { label: "Purity of Material", value: 3 },
    { label: "Based on Measurement", value: 4 },
    { label: "With Photo", value: 5 },
    { label: "Onsite Testing", value: 6 },
    { label: "Based On Hrs.", value: 7 },
  ];

  let initialMoreTestRatesList = {
    TestMasterDefineMoreRatesIDEncrypt: "",
    TestMasterIDEncrypt: "",
    RateType: "",
    Unit: "",
    MinValue: "",
    MaxValue: "",
    TestRate: "",
    IsDeleted: false,
  };

  const getDefineMoreRatesDetail = async () => {
    if (TestMasterIDEncrypt) {
      let newListOneRecord = ListOfMoreTestRates?.filter(
        (x) => x.IsDeleted == false
      )?.map((item, idx) => {
        if (item?.RateType == "") {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return {
            ...item,
            IsDeleted: false,
          };
        }
      });

      if (newListOneRecord?.filter((x) => x.IsDeleted == false)?.length == 0) {
        formikDefineMoreRates.setFieldValue("MoreTestRatesList", [
          ...newListOneRecord,
          initialMoreTestRatesList,
        ]);
      } else {
        formikDefineMoreRates.setFieldValue(
          "MoreTestRatesList",
          newListOneRecord
        );
      }
    }
    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [initialMoreTestRatesList],
      IsIncudeStandardRate: false,
      isDuplicate: false,
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList, IsIncudeStandardRate },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = (values) => {
    if (values?.isDuplicate) {
      return;
    }

    if (
      values?.MoreTestRatesList?.filter((x) => x?.RateType > 0).length === 0
    ) {
      warningMessage("atleast one Rate Type select to add.");
      return true;
    }
    // Get the list of valid test rates (not deleted)
    const validRates = values?.MoreTestRatesList?.filter(
      (x) => x?.IsDeleted === false
    );

    // // Check required fields for RateTypes 1, 4, and 7
    // const hasMissingFields = validRates?.some((x) => {
    //   if (x?.RateType === 4 && (!x?.Unit || x?.MinValue === "")) {
    //     warningMessage(
    //       "Unit and Min/Max Value are required for Rate Type Based on Measurement."
    //     );
    //     return true;
    //   }
    //   if ((x?.RateType === 1 || x?.RateType === 7) && x?.MinValue === "") {
    //     warningMessage("Min/Max Value is required for the selected Rate Type.");
    //     return true;
    //   }
    //   return false;
    // });

    // if (hasMissingFields) {
    //   return;
    // }
    // Check required fields for RateTypes 1, 4, and 7
    const hasMissingFields = validRates?.some((x) => {
      if (x?.RateType === 4 && (!x?.Unit || (!x?.MinValue && !x?.MaxValue))) {
        warningMessage(
          "Unit and at least one of Min/Max Value are required for Rate Type Based on Measurement."
        );
        return true;
      }
      if (
        (x?.RateType === 1 || x?.RateType === 7) &&
        !x?.MinValue &&
        !x?.MaxValue
      ) {
        warningMessage(
          "At least one of Min/Max Value is required for the selected Rate Type."
        );
        return true;
      }
      return false;
    });

    if (hasMissingFields) {
      return;
    }

    // // Check for overlapping Min and Max values for RateTypes 1, 4, and 7
    // const rateTypeGroups = {}; // Store min-max ranges for each RateType

    // let isOverlapping = false;

    // validRates.forEach((item) => {
    //   if ([1, 4, 7].includes(item.RateType)) {
    //     const { RateType, MinValue, MaxValue } = item;
    //     if (!rateTypeGroups[RateType]) {
    //       rateTypeGroups[RateType] = [];
    //     }

    //     // Check if new range overlaps with existing ranges
    //     for (const range of rateTypeGroups[RateType]) {
    //       if (
    //         (MinValue >= range.MinValue && MinValue <= range.MaxValue) || // MinValue inside an existing range
    //         (MaxValue >= range.MinValue && MaxValue <= range.MaxValue) || // MaxValue inside an existing range
    //         (MinValue < range.MinValue && MaxValue > range.MaxValue) // New range completely covers an existing range
    //       ) {
    //         isOverlapping = true;
    //         return;
    //       }
    //     }

    //     // Store the new valid range
    //     rateTypeGroups[RateType].push({ MinValue, MaxValue });
    //   }
    // });

    // if (isOverlapping) {
    //   warningMessage(`Overlapping Min/Max values !`);
    //   return;
    // }

    const rateTypeGroups = {}; // Store min-max ranges for each RateType
    let isOverlapping = false;

    validRates.forEach((item) => {
      if ([1, 4, 7].includes(item.RateType)) {
        const { RateType } = item;
        const MinValue = item.MinValue !== "" ? parseFloat(item.MinValue) : 0;
        const MaxValue =
          item.MaxValue !== "" ? parseFloat(item.MaxValue) : Infinity;
        const Unit = item.Unit || "default"; // Use 'default' if Unit is empty (only for RateType 4)

        if (RateType === 4) {
          if (!rateTypeGroups[RateType]) {
            rateTypeGroups[RateType] = {};
          }
          if (!rateTypeGroups[RateType][Unit]) {
            rateTypeGroups[RateType][Unit] = [];
          }

          for (const range of rateTypeGroups[RateType][Unit]) {
            if (
              (MinValue !== null &&
                MinValue >= range.MinValue &&
                MinValue <= range.MaxValue) || // Min inside existing range
              (MaxValue !== null &&
                MaxValue >= range.MinValue &&
                MaxValue <= range.MaxValue) || // Max inside existing range
              (MinValue !== null &&
                MaxValue !== null &&
                MinValue < range.MinValue &&
                MaxValue > range.MaxValue) || // New range fully covers existing range
              (MinValue === null &&
                MaxValue !== null &&
                MaxValue > range.MinValue) || // Only MaxValue exists, overlaps with an existing MinValue
              (MaxValue === null &&
                MinValue !== null &&
                MinValue < range.MaxValue) // Only MinValue exists, overlaps with an existing MaxValue
            ) {
              isOverlapping = true;
              return;
            }
          }

          rateTypeGroups[RateType][Unit].push({ MinValue, MaxValue });
        } else {
          if (!rateTypeGroups[RateType]) {
            rateTypeGroups[RateType] = [];
          }

          for (const range of rateTypeGroups[RateType]) {
            if (
              (MinValue !== null &&
                MinValue >= range.MinValue &&
                MinValue < range.MaxValue) ||
              (MaxValue !== null &&
                MaxValue > range.MinValue &&
                MaxValue <= range.MaxValue) ||
              (MinValue !== null &&
                MaxValue !== null &&
                MinValue < range.MinValue &&
                MaxValue > range.MaxValue) ||
              (MinValue === null &&
                MaxValue !== null &&
                MaxValue > range.MinValue) ||
              (MaxValue === null &&
                MinValue !== null &&
                MinValue < range.MaxValue)
            ) {
              isOverlapping = true;
              return;
            }
          }

          rateTypeGroups[RateType].push({ MinValue, MaxValue });
        }
      }
    });

    if (isOverlapping) {
      warningMessage(`Overlapping Min/Max values!`);
      return;
    }

    // const uniqueEntries = new Set();
    // let isDuplicate = false;

    // validRates.forEach((item) => {
    //   const key =
    //     item.RateType === 1 || item.RateType === 4 || item.RateType === 7
    //       ? `${item.RateType}-${item.MinValue}-${item.MaxValue}-${parseFloat(
    //           item.TestRate
    //         )}`
    //       : `${item.RateType}`;
    //   //`${item.RateType}-${parseFloat(item.TestRate)}`;

    //   if (uniqueEntries.has(key)) {
    //     isDuplicate = true;
    //   } else {
    //     uniqueEntries.add(key);
    //   }
    // });

    // if (isDuplicate) {
    //   warningMessage("Duplicate rate details found!");
    //   return;
    // }

    const uniqueEntries = new Set();
    let isDuplicate = false;

    validRates.forEach((item) => {
      const key =
        item.RateType === 4
          ? `${item.RateType}-${item.Unit}-${item.MinValue}-${
              item.MaxValue
            }-${parseFloat(item.TestRate)}`
          : item.RateType === 1 || item.RateType === 7
          ? `${item.RateType}-${item.MinValue}-${item.MaxValue}-${parseFloat(
              item.TestRate
            )}`
          : `${item.RateType}`;

      if (uniqueEntries.has(key)) {
        isDuplicate = true;
      } else {
        uniqueEntries.add(key);
      }
    });

    if (isDuplicate) {
      warningMessage("Duplicate rate details found!");
      return;
    }

    // Check if RateType is selected but TestRate is missing
    const hasMissingTestRate = validRates?.some(
      (x) => x?.RateType && !parseFloat(x?.TestRate)
    );

    // If IsIncudeStandardRate is true, at least one valid row must exist
    if (
      values?.IsIncudeStandardRate &&
      validRates?.filter(
        (x) =>
          x?.IsDeleted === false &&
          x?.RateType !== "" &&
          parseFloat(x?.TestRate)
      ).length === 0
    ) {
      warningMessage(
        "At least one Rate entry is required when 'Include Standard Rate' is selected."
      );
      return;
    }

    if (hasMissingTestRate) {
      warningMessage("Test Rate is required when Rate Type is selected.");
      return;
    }
    // Check if MinValue is greater than MaxValue
    const hasInvalidRange = validRates?.some(
      (x) =>
        x?.MinValue !== "" &&
        x?.MaxValue !== "" &&
        parseFloat(x?.MinValue) > parseFloat(x?.MaxValue)
    );

    if (hasInvalidRange) {
      warningMessage("Min Value cannot be greater than Max Value.");
      return;
    }

    //formik.setFieldValue("IsIncudeStandardRate", values?.IsIncudeStandardRate);

    formik.setFieldValue(
      "ListOfMoreTestRates",
      values?.MoreTestRatesList?.filter((x) => x?.RateType !== "")?.map(
        (item) => {
          return {
            ...item,
            IsIncudeStandardRate: values?.IsIncudeStandardRate,
          };
        }
      )
    );

    setShowDefineMoreRatesModal(false);
  };

  const addDefineMoreRates = (indxTest) => {
    formikDefineMoreRates.setFieldValue(`MoreTestRatesList`, [
      ...MoreTestRatesList,
      initialMoreTestRatesList,
    ]);
  };

  const removeMoreRates = (indxTest) => {
    let newList = MoreTestRatesList?.filter((x) => x?.IsDeleted == false)?.map(
      (item, idx) => {
        if (indxTest == idx) {
          return {
            ...item,
            IsDeleted: true,
          };
        } else {
          return { ...item };
        }
      }
    );

    formikDefineMoreRates.setFieldValue("MoreTestRatesList", newList);
  };

  const checkValidationMoreRates = (index) => {
    const currentItem = MoreTestRatesList[index];

    if (!currentItem) return;

    // Check if any of the fields are blank, then skip validation
    if (!currentItem.RateType || currentItem.TestRate === "") {
      return;
    }

    // // const isDuplicate = MoreTestRatesList.some((item, i) => {
    // //   if (i === index || item.IsDeleted) return false; // Exclude the current item itself and deleted items

    // //   // Convert MinValue and MaxValue to numbers for proper comparison
    // //   const currentMinValue = Number(currentItem.MinValue);
    // //   const currentMaxValue = Number(currentItem.MaxValue);
    // //   const itemMinValue = Number(item.MinValue);
    // //   const itemMaxValue = Number(item.MaxValue);

    // //   if (item.RateType === currentItem.RateType) {
    // //     if (
    // //       currentItem.RateType === 1 ||
    // //       currentItem.RateType === 4 ||
    // //       currentItem.RateType === 7
    // //     ) {
    // //       // If RateType is 4 or 7, MinValue and MaxValue should not be repeated
    // //       return (
    // //         currentMinValue === itemMinValue && currentMaxValue === itemMaxValue
    // //       );
    // //     } else {
    // //       // Otherwise, only TestRate should not be duplicated
    // //       return item.RateType === currentItem.RateType;
    // //     }
    // //   }
    // //   return false;
    // // });

    // // if (isDuplicate) {
    // //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    // //   warningMessage("Duplicate rate details found!");

    // //   // Reset the duplicated values
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].RateType`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].MinValue`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].MaxValue`,
    // //     ""
    // //   );
    // //   formikDefineMoreRates.setFieldValue(
    // //     `MoreTestRatesList[${index}].TestRate`,
    // //     ""
    // //   );
    // //   return;
    // // } else {
    // //   formikDefineMoreRates.setFieldValue("isDuplicate", false);
    // // }

    const currentMinValue = Number(currentItem.MinValue);
    const currentMaxValue = Number(currentItem.MaxValue);
    const currentRateType = currentItem.RateType;

    let isDuplicate = false;
    let hasOverlappingRange = false;
    let hasSequentialError = false;
    let hasMinMaxError = false;
    let hasMinMaxequalError = false;
    //let previousMaxValue = 0; // Track the last MaxValue for sequence validation

    MoreTestRatesList.forEach((item, i) => {
      if (i === index || item.IsDeleted) return;

      const itemMinValue = Number(item.MinValue);
      const itemMaxValue = Number(item.MaxValue);
      const itemRateType = item.RateType;

      if ([1, 4, 7].includes(currentRateType)) {
        if (currentRateType === itemRateType) {
          // if (
          //   (currentMinValue >= itemMinValue &&
          //     currentMinValue <= itemMaxValue) ||
          //   (currentMaxValue >= itemMinValue &&
          //     currentMaxValue <= itemMaxValue) ||
          //   (currentMinValue < itemMinValue && currentMaxValue > itemMaxValue)
          // ) {
          //   hasOverlappingRange = true;
          // }
          // if (itemMaxValue >= previousMaxValue) {
          //   previousMaxValue = itemMaxValue;
          // }
          // if (currentMinValue <= previousMaxValue) {
          //   hasSequentialError = true;
          // }
          // if (currentMaxValue <= currentMinValue) {
          //   hasMinMaxError = true;
          // }
          if (currentMinValue === currentMaxValue) {
            hasMinMaxequalError = true;
          }
        }
      } else {
        if (currentRateType === itemRateType) {
          isDuplicate = true;
        }
      }
    });

    if (isDuplicate) {
      warningMessage(`Duplicate RateType found!`); //${currentRateType}
      resetInvalidRow(index);
      formikDefineMoreRates.setFieldValue("isDuplicate", true);
      return;
    }

    // if (hasOverlappingRange) {
    //   warningMessage(`Overlapping range detected.`); //${currentRateType}
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }

    // if (hasSequentialError) {
    //   warningMessage(`MinValue must start from previous MaxValue .`); //${currentRateType}
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }
    // if (hasMinMaxError) {
    //   warningMessage(`MaxValue must be greater than MinValue.`);
    //   resetInvalidRow(index);
    //   formikDefineMoreRates.setFieldValue("isDuplicate", true);
    //   return;
    // }

    if (hasMinMaxequalError) {
      warningMessage(`MinValue and MaxValue cannot be equal!`);
      resetInvalidRow(index);
      formikDefineMoreRates.setFieldValue("isDuplicate", true);
      return;
    }

    formikDefineMoreRates.setFieldValue("isDuplicate", false);
  };

  const resetInvalidRow = (index) => {
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].MinValue`,
      ""
    );
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].MaxValue`,
      ""
    );
    formikDefineMoreRates.setFieldValue(
      `MoreTestRatesList[${index}].TestRate`,
      ""
    );
  };

  const [mixDesignPrintingGroupOptions, setMixDesignPrintingGroupOptions] =
    useState([]);

  const getMixDesignPrintingGroup = async () => {
    setIsLoading(true);

    let payload = {
      CurrentPage: 1,
      PageSize: 100,
      Search: "",
      Sorting: "",
      Status: 1,
      MixDesignMasterType: 8, //Printing Group
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser.BranchIDEncrypt,
    };

    await post(POST_GetMixDesignMasterListByMixDesignMasterType, payload)
      .then((response) => {
        setMixDesignPrintingGroupOptions(
          response?.List?.map((item) => ({
            MixDesignMasterIDEncrypted: item.MixDesignMasterIDEncrypted,
            name: item.MixDesignMasterName,
            value: item.MixDesignMasterName,
          }))
        );

        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addNewPrintingGroupSuggestion = () => {
    let newList = mixDesignPrintingGroupOptions.filter(
      (x) => x.MixDesignMasterIDEncrypted != ""
    );
    ListOfTestMasterStandardParameters?.map((s) => {
      if (newList.filter((x) => x.name == s.Requirement).length == 0) {
        newList.push({
          MixDesignMasterIDEncrypted: "",
          name: s.Requirement,
          value: s.Requirement,
        });
      }
    });
    ListOfTestMasterNonStandardParameters?.map((n) => {
      if (newList.filter((x) => x.name == n.Requirement).length == 0) {
        newList.push({
          MixDesignMasterIDEncrypted: "",
          name: n.Requirement,
          value: n.Requirement,
        });
      }
    });
    setMixDesignPrintingGroupOptions(newList);
  };

  const [IsPrintingGroupAdd, setIsPrintingGroupAdd] = useState(false);

  useEffect(() => {
    if (IsPrintingGroupAdd == true) {
      addNewPrintingGroupSuggestion();
      setIsPrintingGroupAdd(false);
    }
  }, [IsPrintingGroupAdd]);

  return (
    <div className="card m-1">
      <div className="card-body p-1">
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <div className="tbl-caption p-2">
            <h4 className="heading mb-0">
              {PrimaryIdParam ? "Edit" : "Add"} Test Master
            </h4>
          </div>
          <hr className="mt-0 mb-1"></hr>
          <div className="p-2 pt-0">
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={12}>
                    <Row>
                      {AuthUser?.Permissions?.DT == 1 &&
                        AuthUser?.Permissions?.NDT == 1 && (
                          <Col lg={3}>
                            <Field
                              label="Test Type"
                              name="TestType"
                              placeholder={"Select Test Type"}
                              component={CustomSelect}
                              options={testTypeOptions}
                              isDisabled={IsRecordEdit == true ? false : true}
                              isClearable={false}
                              required
                            />
                          </Col>
                        )}
                      {TestType == 2 && (
                        <Col lg={3}>
                          <Field
                            label="NDT Process Type"
                            name="NDTProcessType"
                            placeholder={"Select NDT Process Type"}
                            component={CustomSelect}
                            options={ndtProcessTypeOptions}
                            isDisabled={IsRecordEdit == true ? false : true}
                            required={true}
                          />
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      <Col lg={6}>
                        <Field
                          label="Test Name"
                          name="TestName"
                          placeholder={"Enter Test Name"}
                          component={CustomInput}
                          required
                          maxLength={200}
                          autoFocus
                          onBlur={(e) => {
                            // if (!TestMasterDisplayName) {
                            if (!PrimaryIdParam) {
                              formik.setFieldValue(
                                "TestMasterDisplayName",
                                e?.target?.value ?? ""
                              );
                            }
                          }}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "TestName",
                              capitalizeString(e)
                            );
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Display Name"
                          name="TestMasterDisplayName"
                          placeholder={"Enter Display Name"}
                          component={CustomInput}
                          required
                          maxLength={200}
                          onChange={(e) => {
                            formik.setFieldValue(
                              "TestMasterDisplayName",
                              capitalizeString(e)
                            );
                          }}
                        />
                      </Col>
                      <Col lg={6}>
                        <Field
                          label="Department"
                          name="DepartmentID"
                          placeholder={"Select Department"}
                          component={CustomSelect}
                          options={departmentOptions}
                          isDisabled={IsRecordEdit == true ? false : true}
                          // isDisabled={
                          //   IsDraft == true
                          //     ? false
                          //     : PrimaryIdParam
                          //     ? true
                          //     : false
                          // }
                          //isClearable={false}
                          required
                        />
                      </Col>
                      <Col lg={6}>
                        {IsRecordEdit == true &&
                        (AuthUser?.UserType !== 1 ||
                          formsList?.filter((x) => x?.FormID == 19 && x?.IsAdd)
                            ?.length > 0) ? (
                          <Link
                            to="#"
                            className="icon-box icon-box-md bg-primary-light me-1"
                            title="New Material Group"
                            style={{ float: "right" }}
                            onClick={() => {
                              if (DepartmentID) {
                                addProductGroup();
                              } else {
                                warningMessage(
                                  "Please select Department first..."
                                );
                              }
                            }}
                          >
                            <i className="fa fa-plus"></i>
                          </Link>
                        ) : (
                          ""
                        )}
                        <Field
                          label="Material Group"
                          name="ProductGroupID"
                          placeholder={"Select Material Group"}
                          component={CustomSelect}
                          options={productGroupOptions}
                          isDisabled={IsRecordEdit == true ? false : true}
                          // isDisabled={
                          //   IsDraft == true
                          //     ? false
                          //     : PrimaryIdParam
                          //     ? true
                          //     : false
                          // }
                          //isClearable={false}
                          required
                        />
                      </Col>

                      <Col lg={6}>
                        <Field
                          label="Parameter Header Display Name"
                          name="ParameterHeaderDisplayName"
                          placeholder={"Select Parameter Header Display Name"}
                          component={CustomInput}
                          maxLength={200}
                          required
                        />
                      </Col>
                      {TestType == 1 && (
                        <Col lg={6}>
                          <Field
                            type="number"
                            label="Default Test Count"
                            name="DefaultTestCount"
                            placeholder={"Select Default Test Count"}
                            component={CustomInput}
                            numberTypeWithoutDot={true}
                            required
                          />
                        </Col>
                      )}
                      {AuthUser?.Permissions?.Account == 1 ? (
                        <Col lg={6}>
                          {TestType == 1 && (
                            <Link
                              to="#"
                              title="Define More Rates"
                              className="text-primary"
                              style={{ float: "right" }}
                              onClick={() => {
                                getDefineMoreRatesDetail();
                              }}
                            >
                              Define More Rates
                            </Link>
                          )}
                          <Field
                            type="number"
                            label="Test Rate"
                            name="TestRate"
                            placeholder="Test Rate"
                            component={CustomInput}
                            required
                            disabled={IsRecordEdit == true ? false : true}
                            // disabled={
                            //   IsDraft == true
                            //     ? false
                            //     : PrimaryIdParam
                            //     ? true
                            //     : false
                            // }
                            onChange={(e) => {
                              if (IsRecordEdit) {
                                formik.setFieldValue(
                                  "TestRate",
                                  e?.target.value ?? ""
                                );
                              }
                              if (CopyTestMasterIdParam) {
                                formik.setFieldValue(
                                  "TestRate",
                                  e?.target.value ?? ""
                                );
                              }
                            }}
                          />
                        </Col>
                      ) : (
                        ""
                      )}
                      <Col lg={6}>
                        <div className="d-flex">
                          <div className="me-5">
                            <label></label>
                            <div
                              className="d-flex mb-2"
                              // style={{ marginTop: "12px" }}
                            >
                              <label>NABL &nbsp;</label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckNABL"
                                  title={IsNABL == true ? "Yes" : "No"}
                                  checked={IsNABL}
                                  onChange={() => {
                                    formik.setFieldValue("IsNABL", !IsNABL);
                                  }}
                                  style={{ cursor: "pointer" }}
                                ></input>
                              </div>
                            </div>
                          </div>

                          <div>
                            {AuthUser?.Permissions?.Machining == 1 &&
                            TestType == 1 ? (
                              <>
                                <label></label>
                                <div className="d-flex mb-2">
                                  <label>Machining Required &nbsp;</label>
                                  <div className="form-check form-switch">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id="flexSwitchCheckMachiningRequired"
                                      title={
                                        MachiningRequired == true ? "Yes" : "No"
                                      }
                                      checked={MachiningRequired}
                                      onChange={() => {
                                        formik.setFieldValue(
                                          "MachiningRequired",
                                          !MachiningRequired
                                        );
                                      }}
                                      style={{ cursor: "pointer" }}
                                    ></input>
                                  </div>
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </Col>

                      {TestType == 1 && AuthUser?.LicenseTypeID != 5 && (
                        <Col lg={6}>
                          <div className="mb-2">
                            <label></label>
                            <div className="d-flex">
                              <label>Mix Design &nbsp;</label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckMixDesign"
                                  title={IsMixDesign == true ? "Yes" : "No"}
                                  checked={IsMixDesign}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "IsMixDesign",
                                      !IsMixDesign
                                    );
                                    if (
                                      e?.target?.checked == true &&
                                      DepartmentID
                                    ) {
                                      openMixDesignTestDialog();
                                    }
                                  }}
                                  style={{ cursor: "pointer" }}
                                ></input>
                              </div>
                              {IsMixDesign == true ? (
                                <div>
                                  <Link
                                    to="#"
                                    className="text-primary ms-2"
                                    onClick={openMixDesignTestDialog}
                                  >
                                    <u>
                                      <i>Test includes in mix design</i>
                                    </u>
                                  </Link>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                      )}
                    </Row>
                  </Col>
                  <Col lg={6}>
                    <Row>
                      {/* <Col lg={3} className="mb-2">
                    {AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 17 && x?.IsAdd)
                      ?.length > 0 ? (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New Material Type"
                        style={{ float: "right" }}
                        onClick={() => {
                          setCategoryType(1); // 1 = Material Type
                          setCategoryTypeName("Material Type");
                          setShowQuickAddMaterialCategoryModal(true);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                    ) : (
                      ""
                    )}

                    <label className="mb-1">Material Types</label>
                    <div className="card mb-0 w-100">
                      <div className="card-header p-0">
                        <input
                          type="text"
                          name="searchMaterialType"
                          placeholder={"Search here..."}
                          className="form-control form-control-sm"
                          value={searchMaterialType}
                          onChange={handleChangeSearchMaterialType}
                          style={{
                            borderBottomLeftRadius: "0",
                            borderBottomRightRadius: "0",
                          }}
                        ></input>
                      </div>
                      <div
                        ref={materialTypeDivRef}
                        className="card-body p-0 table-responsive"
                        style={{
                          maxHeight: "250px",
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-hover header-border no-footer">
                          <tbody>
                            {ListMaterialType?.filter((x) => x.display == true)
                              ?.length > 0 ? (
                              ListMaterialType?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "15%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkMaterialType${indx}`}
                                      name={`chkMaterialType${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListMaterialType[${indx}].IsSelected`,
                                          e.target.checked
                                        );
                                        //getStandaradParameterList();
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "85%",
                                    }}
                                  >
                                    {item.MaterialTypeName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "center" }}>
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} className="mb-2">
                    {AuthUser?.UserType !== 1 ||
                    formsList?.filter((x) => x?.FormID == 20 && x?.IsAdd)
                      ?.length > 0 ? (
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New Test Method"
                        style={{ float: "right" }}
                        onClick={addTestMethod}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                    ) : (
                      ""
                    )}

                    <label className="mb-1">Test Method</label>
                    <div className="card mb-0 w-100">
                      <div className="card-header p-0">
                        <input
                          type="text"
                          name="searchTestMethod"
                          placeholder={"Search here..."}
                          className="form-control form-control-sm"
                          value={searchTestMethod}
                          onChange={handleChangeSearchTestMethod}
                          style={{
                            borderBottomLeftRadius: "0",
                            borderBottomRightRadius: "0",
                          }}
                        ></input>
                      </div>
                      <div
                        ref={testMethodDivRef}
                        className="card-body p-0 table-responsive"
                        style={{
                          maxHeight: "250px",
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-hover header-border no-footer">
                          <tbody>
                            {ListTestMethod?.filter((x) => x.display == true)
                              ?.length > 0 ? (
                              ListTestMethod?.map((item, indx) => (
                                <tr
                                  key={indx}
                                  style={{
                                    display: item.display == true ? "" : "none",
                                  }}
                                >
                                  <td
                                    style={{
                                      textAlign: "center",
                                      padding: "0.5rem",
                                      width: "15%",
                                    }}
                                  >
                                    <input
                                      type="checkbox"
                                      className="form-check-input"
                                      id={`chkTestMethod${indx}`}
                                      name={`chkTestMethod${indx}`}
                                      checked={item.IsSelected}
                                      onChange={(e) => {
                                        formik.setFieldValue(
                                          `ListTestMethod[${indx}].IsSelected`,
                                          e.target.checked
                                        );
                                        //getStandaradParameterList();
                                      }}
                                    />
                                  </td>
                                  <td
                                    style={{
                                      textAlign: "left",
                                      padding: "0.5rem",
                                      width: "85%",
                                    }}
                                  >
                                    {item.TestMethodName}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={2} style={{ textAlign: "center" }}>
                                  <div>{"No options"}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col> */}
                      <Col lg={6}>
                        <div className="mb-2">
                          <label className="mb-1">Machine Mapping</label>
                          <div className="card mb-0 w-100">
                            <div className="card-header p-0">
                              <input
                                type="text"
                                name="searchMachines"
                                placeholder={"Search here..."}
                                className="form-control form-control-sm"
                                value={searchMachines}
                                onChange={handleChangeSearchMachines}
                                style={{
                                  borderBottomLeftRadius: "0",
                                  borderBottomRightRadius: "0",
                                }}
                              ></input>
                            </div>
                            <div
                              className="card-body p-0 table-responsive"
                              style={{
                                maxHeight: "250px",
                                overflow: "auto",
                              }}
                            >
                              <table className="table table-hover header-border no-footer">
                                <tbody>
                                  {ListMachines?.filter(
                                    (x) => x.display == true
                                  )?.length > 0 ? (
                                    ListMachines?.map((item, indx) => (
                                      <tr
                                        key={indx}
                                        style={{
                                          display:
                                            item.display == true ? "" : "none",
                                        }}
                                      >
                                        <td
                                          style={{
                                            textAlign: "center",
                                            padding: "0.5rem",
                                            width: "15%",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`chkMachines${indx}`}
                                            name={`chkMachines${indx}`}
                                            checked={item.IsSelected}
                                            onChange={(e) => {
                                              formik.setFieldValue(
                                                `ListMachines[${indx}].IsSelected`,
                                                e.target.checked
                                              );
                                              // setMachineForParameterRateList();
                                            }}
                                          />
                                        </td>
                                        <td
                                          style={{
                                            textAlign: "left",
                                            padding: "0.5rem",
                                            width: "85%",
                                          }}
                                        >
                                          {item.MachinesName}
                                        </td>
                                      </tr>
                                    ))
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={2}
                                        style={{ textAlign: "center" }}
                                      >
                                        <div>{"No options"}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="mb-2">
                          <div className="d-flex justify-content-between mb-0">
                            <div className="d-flex mb-0">
                              <label>Images &nbsp;</label>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  title={
                                    IsImageInTesting == true ? "Yes" : "No"
                                  }
                                  checked={IsImageInTesting}
                                  onChange={() => {
                                    formik.setFieldValue(
                                      "IsImageInTesting",
                                      !IsImageInTesting
                                    );
                                    // if (IsImageInTesting == false) {
                                    //   formik.setFieldValue(
                                    //     "ListTestMasterImages",
                                    //     []
                                    //   );
                                    // }
                                  }}
                                  style={{ cursor: "pointer" }}
                                ></input>
                              </div>
                            </div>
                            {IsImageInTesting ? (
                              <div>
                                <Link
                                  to="#"
                                  className="text-primary"
                                  onClick={addTestMasterImage}
                                >
                                  + Add Images
                                </Link>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {IsImageInTesting ? (
                            <div
                              className="card mb-0"
                              style={{ height: "280px" }}
                            >
                              {/* <div className="card-body"> */}
                              <div className="table-responsive active-projects style-1 shorting mb-0">
                                <div
                                  id="TestMasterImages-tbl_wrapper"
                                  className="dataTables_wrapper no-footer"
                                >
                                  <table
                                    id="TestMasterImages-tbl"
                                    className="table dataTable no-footer mb-0"
                                  >
                                    <thead>
                                      <tr>
                                        <th width="4%"></th>
                                        <th
                                          width="96%"
                                          style={{ textAlign: "left" }}
                                        >
                                          Image Preview
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {ListTestMasterImages?.filter(
                                        (x) => x.IsDelete == false
                                      ).length > 0 ? (
                                        ListTestMasterImages?.map(
                                          (item, indx) => (
                                            <tr
                                              style={{
                                                display:
                                                  item?.IsDelete == true
                                                    ? "none"
                                                    : "",
                                              }}
                                            >
                                              <td>
                                                <Link
                                                  to="#"
                                                  // className="icon-box icon-box-md bg-primary-light me-1"
                                                  className="icon-box icon-box-md me-1"
                                                  title="Download"
                                                  onClick={() => {
                                                    window.open(
                                                      item.TestMasterImagePreview,
                                                      "_blank"
                                                    );
                                                  }}
                                                >
                                                  <i className="fa fa-download"></i>
                                                </Link>

                                                <Link
                                                  to="#"
                                                  className="icon-box icon-box-md me-1"
                                                  title="Delete"
                                                  onClick={() => {
                                                    //deleteTestMasterImage(indx);
                                                    delete_RecordWithoutApi(
                                                      deleteTestMasterImage,
                                                      indx
                                                    );
                                                  }}
                                                  // onClick={() => {
                                                  //   deleteTestMasterImage(indx);
                                                  // }}
                                                >
                                                  {SVGICON.DeleteDanger}
                                                </Link>
                                              </td>
                                              <td>
                                                <div
                                                  className="image-placeholder"
                                                  style={{
                                                    maxWidth: "100px",
                                                    margin: "10px",
                                                    zIndex: 0,
                                                  }}
                                                >
                                                  <div
                                                    className="avatar-preview"
                                                    style={{
                                                      width: "100px",
                                                      height: "auto",
                                                    }}
                                                  >
                                                    <div id="testMasterImagePreview">
                                                      <img
                                                        id="saveTestMasterImageFile"
                                                        src={
                                                          item.TestMasterImagePreview
                                                        }
                                                        alt={"Image"}
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                              </td>
                                            </tr>
                                          )
                                        )
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan={3}
                                            style={{ textAlign: "left" }}
                                          >
                                            <div>{"No Record Found..."}</div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              {/* </div> */}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                {/* <hr className="mt-1 mb-1"></hr> */}
                {TestType == 1 && (
                  <>
                    <hr className="mt-1 mb-2"></hr>
                    <Row>
                      <Accordion
                        className="accordion accordion-primary"
                        defaultActiveKey={["0", "1"]} // Include all eventKeys here
                        alwaysOpen
                      >
                        <Accordion.Item
                          className="accordion-item"
                          key={0}
                          eventKey={"0"}
                        >
                          <Accordion.Header className="accordion-header rounded-lg">
                            Non Standard Parameters
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-info-light"
                          title="New Non Standard Parameters"
                          onClick={addNonStandardParameters}
                        >
                          <i className="fa fa-plus"> </i>
                        </Link> */}
                          </Accordion.Header>
                          <Accordion.Collapse eventKey={"0"}>
                            <div className="card">
                              <div className="card-body p-0">
                                <DragDropContext onDragEnd={onDragEnd}>
                                  <div className="table-responsive active-projects style-1 shorting">
                                    <div
                                      id="NonStandardParameters-tbl_wrapper"
                                      className="dataTables_wrapper no-footer"
                                    >
                                      <table
                                        id="NonStandardParameters-tbl"
                                        className="table dataTable no-footer mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th width="2%">
                                              <Link
                                                to="#"
                                                className="icon-box icon-box-md bg-primary-light"
                                                title="Add Non Standard Parameter"
                                                onClick={
                                                  addNonStandardParameters
                                                }
                                              >
                                                <i className="fa fa-plus"> </i>
                                              </Link>
                                            </th>
                                            <th width="2%">S. No</th>
                                            <th width="2%"></th>
                                            <th width="19%">Parameter Name</th>
                                            <th width="8%">Short Code</th>
                                            <th width="2%"></th>
                                            <th width="3%">Average</th>
                                            <th width="18%">Display Name</th>
                                            <th width="12%">Display Code</th>
                                            <th width="10%">
                                              {IsMixDesign == false
                                                ? "Requirement"
                                                : "Printing Group"}
                                            </th>
                                            <th
                                              width="10%"
                                              style={{ textAlign: "left" }}
                                            >
                                              Default Value
                                            </th>
                                            {AuthUser?.Permissions?.Account ==
                                              1 && (
                                              <th
                                                width="12%"
                                                style={{ textAlign: "left" }}
                                              >
                                                Additional Charge
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <Droppable droppableId="droppable">
                                          {(provided, _) => (
                                            <tbody
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {ListOfTestMasterNonStandardParameters?.filter(
                                                (x) => x.IsDelete == false
                                              ).length > 0 ? (
                                                ListOfTestMasterNonStandardParameters?.map(
                                                  (item, index) => (
                                                    <Draggable
                                                      key={`idn_${index}`}
                                                      draggableId={`idn_${index}`}
                                                      index={index}
                                                    >
                                                      {(provided, _) => (
                                                        <tr
                                                          role="row"
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          // className="sub-card draggable-handle draggable"
                                                          className={`sub-card draggable-handle draggable ${
                                                            item.IsDelete ==
                                                              true && "d-none"
                                                          }`}
                                                          // style={{
                                                          //   display:
                                                          //     item.IsDelete == true
                                                          //       ? "none"
                                                          //       : "",
                                                          // }}
                                                        >
                                                          <td className="text-center">
                                                            {SVGICON.Dotes}
                                                          </td>
                                                          <td>
                                                            <span className="ms-2">
                                                              {
                                                                item.DisplaySequence
                                                              }
                                                            </span>
                                                          </td>
                                                          <td>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                                              className="icon-box icon-box-md me-1"
                                                              title="Edit"
                                                              onClick={() => {
                                                                editNonStandardParameters(
                                                                  index
                                                                );
                                                              }}
                                                            >
                                                              {
                                                                SVGICON.EditPrimary
                                                              }
                                                            </Link>
                                                            <Link
                                                              to="#"
                                                              // className="icon-box icon-box-md bg-danger-light"
                                                              className="icon-box icon-box-md"
                                                              title="Delete"
                                                              onClick={() => {
                                                                //deleteNonStandardParameters(index);
                                                                delete_RecordWithoutApi(
                                                                  deleteNonStandardParameters,
                                                                  index
                                                                );
                                                              }}
                                                              // onClick={() => {
                                                              //   deleteNonStandardParameters(
                                                              //     index
                                                              //   );
                                                              // }}
                                                            >
                                                              {
                                                                SVGICON.DeleteDanger
                                                              }
                                                            </Link>
                                                          </td>
                                                          <td
                                                            style={{
                                                              minWidth: "200px",
                                                            }}
                                                          >
                                                            {
                                                              item.NonParameterName
                                                            }
                                                          </td>
                                                          <td
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {item.ShortCode}
                                                          </td>
                                                          <td className="p-1 text-center">
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md ${
                                                                item.FormulaEvaluationStatus ==
                                                                1
                                                                  ? "bg-success"
                                                                  : item.FormulaEvaluationStatus ==
                                                                    2
                                                                  ? "bg-danger"
                                                                  : "bg-secondary-light"
                                                              }`}
                                                              title={
                                                                item.FormulaExpression
                                                                  ? item.FormulaExpression
                                                                  : "Set Parameter Formula"
                                                              }
                                                              onClick={() => {
                                                                openParameterFormulaDialog(
                                                                  2,
                                                                  index,
                                                                  item.NonParameterName
                                                                );
                                                              }}
                                                            >
                                                              {SVGICON.Formula}
                                                            </Link>
                                                          </td>
                                                          <td className="text-center">
                                                            {item.IsAverageRequired
                                                              ? "Yes"
                                                              : "No"}
                                                          </td>
                                                          <td
                                                            style={{
                                                              minWidth: "200px",
                                                            }}
                                                          >
                                                            {item.DisplayName}
                                                          </td>
                                                          <td
                                                            style={{
                                                              minWidth: "145px",
                                                            }}
                                                          >
                                                            {item.DisplayCode}
                                                          </td>
                                                          <td>
                                                            {item.Requirement}
                                                          </td>
                                                          <td
                                                            style={{
                                                              textAlign: "left",
                                                            }}
                                                          >
                                                            {item.DefaultValue}
                                                          </td>
                                                          {AuthUser?.Permissions
                                                            ?.Account == 1 && (
                                                            <td
                                                              style={{
                                                                textAlign:
                                                                  "left",
                                                              }}
                                                            >
                                                              <div className="d-flex justify-content-between">
                                                                <span>
                                                                  {item.ConsiderAdditionalCharge
                                                                    ? "Yes"
                                                                    : "No"}
                                                                </span>
                                                                <span className="pe-3">
                                                                  {item.ConsiderAdditionalCharge
                                                                    ? item.AdditionalChargeAmount
                                                                    : ""}
                                                                </span>
                                                              </div>
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={12}
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <div>
                                                      {"No Record Found..."}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}
                                              {provided.placeholder}
                                            </tbody>
                                          )}
                                        </Droppable>
                                      </table>
                                      {/* <table
                                    id="NonStandardParameters-tbl"
                                    className="table dataTable no-footer mb-0"
                                  >
                                    <thead>
                                      <tr>
                                        <th width="2%">
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-info-light"
                                            title="New Non Standard Parameters"
                                            onClick={addNonStandardParameters}
                                          >
                                            <i className="fa fa-plus"> </i>
                                          </Link>
                                        </th>
                                        <th width="2%">S. No</th>
                                        <th width="2%"></th>
                                        <th width="21%">Parameter Name</th>
                                        <th width="21%">Display Name</th>
                                        <th width="15%">Display Code</th>
                                        <th width="11%">Requirement</th>
                                        <th width="11%">Default Value</th>
                                        <th
                                          width="15%"
                                          style={{ textAlign: "left" }}
                                        >
                                          Additional Charge
                                        </th>
                                      </tr>
                                    </thead>
                                    <Droppable droppableId="droppable">
                                      {(provided, _) => (
                                        <tbody
                                          {...provided.droppableProps}
                                          ref={provided.innerRef}
                                        >
                                          {ListOfTestMasterNonStandardParameters?.filter(
                                            (x) => x.IsDelete == false
                                          ).length > 0 ? (
                                            ListOfTestMasterNonStandardParameters?.map(
                                              (item, index) => (
                                                <Draggable
                                                  key={`idn_${index}`}
                                                  draggableId={`idn_${index}`}
                                                  index={index}
                                                >
                                                  {(provided, _) => (
                                                    <tr
                                                      role="row"
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      className={`sub-card draggable-handle draggable ${
                                                        item.IsDelete == true &&
                                                        "d-none"
                                                      }`}
                                                    >
                                                      <td className="d-items p-1 text-center">
                                                        {SVGICON.Dotes}
                                                      </td>
                                                      <td className="d-items p-1">
                                                        <span className="ms-2">
                                                          {item.DisplaySequence}
                                                        </span>
                                                      </td>
                                                      <td className="d-items p-1">
                                                        <Link
                                                          to="#"
                                                          className="icon-box icon-box-md bg-danger-light"
                                                          title="Delete"
                                                          onClick={() => {
                                                            deleteNonStandardParameters(
                                                              index
                                                            );
                                                          }}
                                                        >
                                                          {SVGICON.DeleteDanger}
                                                        </Link>
                                                      </td>
                                                      <td
                                                        className="d-items p-1"
                                                        style={{
                                                          minWidth: "200px",
                                                        }}
                                                      >
                                                        <Field
                                                          name={`ListOfTestMasterNonStandardParameters.[${index}].NonParameterName`}
                                                          placeholder="Parameter Name"
                                                          component={
                                                            CustomInputAutoSuggest
                                                          }
                                                          options={
                                                            nonStandardParameterOptions
                                                          }
                                                          noMarginBottom={true}
                                                        />
                                                      </td>
                                                      <td
                                                        className="d-items p-1"
                                                        style={{
                                                          minWidth: "200px",
                                                        }}
                                                      >
                                                        <Field
                                                          type="text"
                                                          name={`ListOfTestMasterNonStandardParameters.[${index}].DisplayName`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          placeholder="Display Name"
                                                          noMarginBottom={true}
                                                          maxLength={100}
                                                        />
                                                      </td>
                                                      <td
                                                        className="d-items p-1"
                                                        style={{
                                                          minWidth: "145px",
                                                        }}
                                                      >
                                                        <Field
                                                          type="text"
                                                          name={`ListOfTestMasterNonStandardParameters.[${index}].DisplayCode`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          placeholder="Display Code"
                                                          noMarginBottom={true}
                                                          maxLength={100}
                                                        />
                                                      </td>
                                                      <td className="d-items p-1">
                                                        <Field
                                                          type="text"
                                                          name={`ListOfTestMasterNonStandardParameters.[${index}].Requirement`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          placeholder="Requirement"
                                                          noMarginBottom={true}
                                                          maxLength={100}
                                                        />
                                                      </td>
                                                      <td className="d-items p-1">
                                                        <Field
                                                          type="text"
                                                          name={`ListOfTestMasterNonStandardParameters.[${index}].DefaultValue`}
                                                          component={
                                                            CustomInput
                                                          }
                                                          placeholder="Default Value"
                                                          noMarginBottom={true}
                                                          maxLength={100}
                                                        />
                                                      </td>
                                                      <td className="d-items p-1">
                                                        <div className="d-flex justify-content-between">
                                                          <div className="form-check form-switch me-2 ms-2">
                                                            <input
                                                              className="form-check-input mt-3"
                                                              type="checkbox"
                                                              name={`ListOfTestMasterNonStandardParameters.[${index}].ConsiderAdditionalCharge`}
                                                              role="switch"
                                                              id={`ListOfTestMasterNonStandardParameters.[${index}].ConsiderAdditionalCharge`}
                                                              checked={
                                                                item.ConsiderAdditionalCharge
                                                              }
                                                              onChange={(e) => {
                                                                setConsiderAdditionalChargeNonStdPara(
                                                                  index,
                                                                  e?.target
                                                                    .checked
                                                                );
                                                              }}
                                                              style={{ cursor: "pointer" }}
                                                            ></input>
                                                          </div>
                                                          <Field
                                                            type="number"
                                                            name={`ListOfTestMasterNonStandardParameters.[${index}].AdditionalChargeAmount`}
                                                            component={
                                                              CustomInput
                                                            }
                                                            placeholder="Amount"
                                                            noMarginBottom={
                                                              true
                                                            }
                                                          />
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  )}
                                                </Draggable>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan={8}
                                                style={{ textAlign: "left" }}
                                              >
                                                <div>
                                                  {"No Record Found..."}
                                                </div>
                                              </td>
                                            </tr>
                                          )}
                                          {provided.placeholder}
                                        </tbody>
                                      )}
                                    </Droppable>
                                  </table> */}
                                    </div>
                                  </div>
                                </DragDropContext>
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </Accordion.Item>
                        <Accordion.Item
                          className="accordion-item"
                          key={1}
                          eventKey={"1"}
                        >
                          <Accordion.Header className="accordion-header rounded-lg">
                            Standard Parameters
                            {/* &nbsp;&nbsp;&nbsp;&nbsp;
                        <Link
                          to="#"
                          className="icon-box icon-box-md bg-info-light"
                          title="New Parameters"
                          onClick={addParameters}
                        >
                          <i className="fa fa-plus"> </i>
                        </Link> */}
                          </Accordion.Header>
                          <Accordion.Collapse eventKey={"1"}>
                            <div className="card">
                              <div className="card-body p-0">
                                <DragDropContext onDragEnd={onDragSTParaEnd}>
                                  <div className="table-responsive active-projects style-1 shorting">
                                    <div
                                      id="StandardParameters-tbl_wrapper"
                                      className="dataTables_wrapper table-responsive no-footer"
                                    >
                                      <table
                                        id="StandardParameters-tbl"
                                        className="table dataTable no-footer mb-0"
                                      >
                                        <thead>
                                          <tr>
                                            <th width="2%">
                                              {AuthUser?.UserType !== 1 ||
                                              formsList?.filter(
                                                (x) =>
                                                  x?.FormID == 21 && x?.IsAdd
                                              )?.length > 0 ? (
                                                <Link
                                                  to="#"
                                                  className="icon-box icon-box-md bg-primary-light"
                                                  title="Add Standard Parameter"
                                                  onClick={() => {
                                                    addNewStandardParameters();
                                                  }}
                                                >
                                                  <i className="fa fa-plus">
                                                    {" "}
                                                  </i>
                                                </Link>
                                              ) : (
                                                ""
                                              )}
                                            </th>
                                            <th width="2%">S. No</th>
                                            <th width="2%"></th>
                                            <th width="25%">
                                              <div className="d-flex">
                                                <div
                                                  style={{
                                                    alignContent: "center",
                                                  }}
                                                >
                                                  Parameter Name
                                                </div>
                                                <input
                                                  type="text"
                                                  placeholder="Search Parameter"
                                                  className="form-control form-control-sm ms-2"
                                                  onChange={(e) => {
                                                    handleChangeSearchParameter(
                                                      e
                                                    );
                                                  }}
                                                />
                                              </div>
                                            </th>
                                            <th width="8%">Short Code</th>
                                            <th width="2%"></th>
                                            <th width="4%">Average</th>
                                            <th width="22%">Display Name</th>
                                            <th width="11%">
                                              {IsMixDesign == false
                                                ? "Requirement"
                                                : "Printing Group"}
                                            </th>
                                            <th
                                              width="10%"
                                              style={{
                                                textAlign: "left",
                                              }}
                                            >
                                              Default Value
                                            </th>
                                            {AuthUser?.Permissions?.Account ==
                                              1 && (
                                              <th
                                                width="12%"
                                                style={{
                                                  textAlign: "left",
                                                }}
                                              >
                                                Additional Charge
                                              </th>
                                            )}
                                          </tr>
                                        </thead>
                                        <Droppable droppableId="droppableStdParaTable">
                                          {(provided, _) => (
                                            <tbody
                                              {...provided.droppableProps}
                                              ref={provided.innerRef}
                                            >
                                              {ListOfTestMasterStandardParameters?.length >
                                              0 ? (
                                                ListOfTestMasterStandardParameters?.map(
                                                  (item, index) => (
                                                    <Draggable
                                                      key={`id_${index}`}
                                                      draggableId={`id_${index}`}
                                                      index={index}
                                                    >
                                                      {(provided, _) => (
                                                        <tr
                                                          role="row"
                                                          ref={
                                                            provided.innerRef
                                                          }
                                                          {...provided.draggableProps}
                                                          {...provided.dragHandleProps}
                                                          // className="sub-card draggable-handle draggable"
                                                          // className={`sub-card draggable-handle draggable ${
                                                          //   item.IsDelete == true &&
                                                          //   "d-none"
                                                          // }`}
                                                          // style={{
                                                          //   display:
                                                          //     item.IsDelete == true
                                                          //       ? "none"
                                                          //       : "",
                                                          // }}
                                                          // style={{
                                                          //   display:
                                                          //     item.IsShow == false
                                                          //       ? "none"
                                                          //       : "",
                                                          // }}
                                                          className={`sub-card draggable-handle draggable ${
                                                            item.IsShow ==
                                                              false && "d-none"
                                                          }`}
                                                        >
                                                          <td className="d-items p-1 text-center">
                                                            {SVGICON.Dotes}
                                                          </td>
                                                          <td className="d-items p-1">
                                                            <span className="ms-2">
                                                              {
                                                                item.DisplaySequence
                                                              }
                                                            </span>
                                                          </td>
                                                          <td className="d-items p-1">
                                                            <input
                                                              type="checkbox"
                                                              className="form-check-input"
                                                              id={`chkStandardParameters${index}`}
                                                              name={`chkStandardParameters${index}`}
                                                              checked={
                                                                item.IsSelected
                                                              }
                                                              onChange={(e) => {
                                                                formik.setFieldValue(
                                                                  `ListOfTestMasterStandardParameters[${index}].IsSelected`,
                                                                  e.target
                                                                    .checked
                                                                );
                                                              }}
                                                            />
                                                            {/* <Link
                                                          to="#"
                                                          className="icon-box icon-box-md bg-danger-light"
                                                          title="Delete"
                                                          onClick={() => {
                                                            deleteStandardParameters(
                                                              index
                                                            );
                                                          }}
                                                        >
                                                          {SVGICON.DeleteDanger}
                                                        </Link> */}
                                                          </td>
                                                          <td
                                                            className="d-items p-1"
                                                            style={{
                                                              minWidth: "300px",
                                                            }}
                                                          >
                                                            {item.ParameterName}
                                                          </td>
                                                          <td
                                                            className="d-items p-1"
                                                            style={{
                                                              minWidth: "100px",
                                                            }}
                                                          >
                                                            {item.ShortCode}
                                                          </td>
                                                          <td className="d-items p-1 text-center">
                                                            <Link
                                                              to="#"
                                                              className={`icon-box icon-box-md ${
                                                                item.FormulaEvaluationStatus ==
                                                                1
                                                                  ? "bg-success"
                                                                  : item.FormulaEvaluationStatus ==
                                                                    2
                                                                  ? "bg-danger"
                                                                  : "bg-secondary-light"
                                                              }`}
                                                              title={
                                                                item.FormulaExpression
                                                                  ? item.FormulaExpression
                                                                  : "Set Parameter Formula"
                                                              }
                                                              onClick={() => {
                                                                openParameterFormulaDialog(
                                                                  1,
                                                                  index,
                                                                  item.ParameterName
                                                                );
                                                              }}
                                                            >
                                                              {SVGICON.Formula}
                                                            </Link>
                                                          </td>
                                                          <td className="d-items p-1">
                                                            <div className="form-check form-switch ms-2">
                                                              <input
                                                                className="form-check-input"
                                                                type="checkbox"
                                                                name={`ListOfTestMasterStandardParameters.[${index}].IsAverageRequired`}
                                                                role="switch"
                                                                id={`ListOfTestMasterStandardParameters.[${index}].IsAverageRequired`}
                                                                checked={
                                                                  item.IsAverageRequired
                                                                }
                                                                onChange={(
                                                                  e
                                                                ) => {
                                                                  formik.setFieldValue(
                                                                    `ListOfTestMasterStandardParameters.[${index}].IsAverageRequired`,
                                                                    e?.target
                                                                      .checked
                                                                  );
                                                                }}
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                              ></input>
                                                            </div>
                                                          </td>
                                                          <td
                                                            className="d-items p-1"
                                                            style={{
                                                              minWidth: "270px",
                                                            }}
                                                          >
                                                            <Field
                                                              type="text"
                                                              name={`ListOfTestMasterStandardParameters.[${index}].DisplayName`}
                                                              component={
                                                                CustomInput
                                                              }
                                                              placeholder="Display Name"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={500}
                                                            />
                                                          </td>
                                                          <td className="d-items p-1 suggestMenuPositionFix">
                                                            {IsMixDesign ==
                                                            false ? (
                                                              <Field
                                                                type="text"
                                                                name={`ListOfTestMasterStandardParameters.[${index}].Requirement`}
                                                                component={
                                                                  CustomInput
                                                                }
                                                                placeholder="Requirement"
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                maxLength={2000}
                                                              />
                                                            ) : (
                                                              <Field
                                                                name={`ListOfTestMasterStandardParameters.[${index}].Requirement`}
                                                                placeholder="Printing Group"
                                                                component={
                                                                  CustomInputAutoSuggest
                                                                }
                                                                options={
                                                                  mixDesignPrintingGroupOptions
                                                                }
                                                                noMarginBottom={
                                                                  true
                                                                }
                                                                onBlur={(e) => {
                                                                  setIsPrintingGroupAdd(
                                                                    true
                                                                  );
                                                                }}
                                                              />
                                                            )}
                                                          </td>
                                                          <td className="d-items p-1">
                                                            <Field
                                                              type="text"
                                                              name={`ListOfTestMasterStandardParameters.[${index}].DefaultValue`}
                                                              component={
                                                                CustomInput
                                                              }
                                                              placeholder="Default Value"
                                                              noMarginBottom={
                                                                true
                                                              }
                                                              maxLength={2000}
                                                            />
                                                          </td>
                                                          {AuthUser?.Permissions
                                                            ?.Account == 1 && (
                                                            <td className="d-items p-1">
                                                              <div className="d-flex justify-content-between">
                                                                <div className="form-check form-switch me-2 ms-4">
                                                                  <input
                                                                    className="form-check-input mt-2"
                                                                    type="checkbox"
                                                                    name={`ListOfTestMasterStandardParameters.[${index}].ConsiderAdditionalCharge`}
                                                                    role="switch"
                                                                    id={`ListOfTestMasterStandardParameters.[${index}].ConsiderAdditionalCharge`}
                                                                    checked={
                                                                      item.ConsiderAdditionalCharge
                                                                    }
                                                                    onChange={(
                                                                      e
                                                                    ) => {
                                                                      setConsiderAdditionalCharge(
                                                                        index,
                                                                        e
                                                                          ?.target
                                                                          .checked
                                                                      );
                                                                    }}
                                                                    style={{
                                                                      cursor:
                                                                        "pointer",
                                                                    }}
                                                                  ></input>
                                                                </div>

                                                                <Field
                                                                  type="number"
                                                                  name={`ListOfTestMasterStandardParameters.[${index}].AdditionalChargeAmount`}
                                                                  component={
                                                                    CustomInput
                                                                  }
                                                                  placeholder="Amount"
                                                                  noMarginBottom={
                                                                    true
                                                                  }
                                                                  // disabled={
                                                                  //   !item.ConsiderAdditionalCharge
                                                                  // }
                                                                  disabled={
                                                                    IsRecordEdit ||
                                                                    !item.TestMasterStandardParameterIDEncrypted
                                                                      ? !item.ConsiderAdditionalCharge
                                                                      : true
                                                                  }
                                                                  onChange={(
                                                                    e
                                                                  ) => {
                                                                    if (
                                                                      (IsRecordEdit ||
                                                                        !item.TestMasterStandardParameterIDEncrypted) &&
                                                                      item.ConsiderAdditionalCharge
                                                                    ) {
                                                                      formik.setFieldValue(
                                                                        `ListOfTestMasterStandardParameters.[${index}].AdditionalChargeAmount`,
                                                                        e
                                                                          ?.target
                                                                          ?.value ??
                                                                          ""
                                                                      );
                                                                    }
                                                                  }}
                                                                />
                                                              </div>
                                                              {/* {item.ConsiderAdditionalCharge ? (
                                                          <div>
                                                            <Link
                                                              to="#"
                                                              className="text-primary p-1"
                                                              title="View Machining Parameter Rate"
                                                              onClick={() => {
                                                                getMachineWiseParameterRateList(
                                                                  item?.ParameterIDEncrypted,
                                                                  1,
                                                                  item?.ParameterName
                                                                );
                                                              }}
                                                            >
                                                              Set Machine wise
                                                              Parameter Rate
                                                            </Link>
                                                          </div>
                                                        ) : (
                                                          ""
                                                        )} */}
                                                            </td>
                                                          )}
                                                        </tr>
                                                      )}
                                                    </Draggable>
                                                  )
                                                )
                                              ) : (
                                                <tr>
                                                  <td
                                                    colSpan={11}
                                                    style={{
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    <div>
                                                      {"No Record Found..."}
                                                    </div>
                                                  </td>
                                                </tr>
                                              )}

                                              {provided.placeholder}
                                            </tbody>
                                          )}
                                        </Droppable>
                                      </table>
                                    </div>
                                  </div>
                                </DragDropContext>
                              </div>
                            </div>
                          </Accordion.Collapse>
                        </Accordion.Item>
                        <ErrorMessage
                          name={"ListOfTestMasterStandardParameters"}
                          component="div"
                          className="invalid-feedback animated fadeInUp mb-2"
                          style={{ display: "block" }}
                        />
                      </Accordion>
                    </Row>
                  </>
                )}
                <hr className="mt-1 mb-2"></hr>
                {IsDraft ? (
                  <button
                    type="submit"
                    // className="btn btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => {
                      formik.setFieldValue("IsDraft", true);
                      formik.setFieldValue("btnSubmitType", 1);
                    }}
                  >
                    <i className="fa-solid fa-bookmark"></i> Draft
                  </button>
                ) : (
                  ""
                )}
                <button
                  type="submit"
                  //  className="btn btn-primary"
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => {
                    //formik.setFieldValue("IsDraft", false);
                    formik.setFieldValue("btnSubmitType", 2);
                  }}
                >
                  <i className="fa-solid fa-floppy-disk"></i> Submit
                </button>
                <button
                  type="button"
                  // className="btn btn-danger light"
                  className="btn btn-danger btn-sm"
                  onClick={(e) => {
                    navigate(-1);
                  }}
                >
                  <i className="fa fa-cancel"></i> Cancel
                </button>
              </Form>
            </FormikProvider>
          </div>
        </Spin>
        <QuickAddMaterialCategory
          categoryType={categoryType}
          showModal={showQuickAddMaterialCategoryModal}
          setShowModal={setShowQuickAddMaterialCategoryModal}
          categoryTypeName={categoryTypeName}
          fnCallback={fnCallbackQuickAddMaterialCategory}
        />

        <QuickAddTestMethod
          showModal={showQuickAddTestMethodModal}
          setShowModal={setShowQuickAddTestMethodModal}
          fnCallback={fnCallbackQuickAddTestMethod}
        />
        <Modal
          className="fade"
          show={addTestMasterImageModal}
          onHide={setAddTestMasterImageModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestMasterImage}>
              <Form onSubmit={formikTestMasterImage.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Test Master Image</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddTestMasterImageModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-2">
                        <label className="mb-1">
                          Test Master Image{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="file"
                          id="ImageFile"
                          accept="image/png, image/gif, image/jpeg"
                          className="form-control form-control-sm"
                          onChange={uploadTestMasterImage}
                        />
                        <ErrorMessage
                          name="ImageFile"
                          component="div"
                          className="invalid-feedback animated fadeInUp"
                          style={{ display: "block" }}
                        />
                        {/* <label htmlFor="ImageFile" name=""></label> */}
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    // variant="primary"
                    variant="primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {actionFlagImage == 1 ? "Update" : "Add"}
                  </Button>
                  <Button
                    // variant="danger light"
                    variant="danger btn-sm"
                    onClick={() => setAddTestMasterImageModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showQuickAddParametersModal}
          onHide={setShowQuickAddParametersModal}
          size="xl"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikParametersAdd}>
              <Form onSubmit={formikParametersAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Parameters</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowQuickAddParametersModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Row>
                        <Col lg={3}>
                          {/* <Field
                            label="Parameter Name"
                            name="ParameterName"
                            placeholder={"Enter Parameter Name"}
                            component={CustomInput}
                            required
                            maxLength={100}
                            autoFocus={true}
                          /> */}
                          <Field
                            label="Parameter Name"
                            name="ParameterName"
                            placeholder="Parameter Name"
                            component={CustomInputAutoSuggest}
                            options={standardParameterUnmappedOptions}
                            onChange={(e, method) => {
                              // console.log(e);
                              // console.log(method);

                              formikParametersAdd.setFieldValue(
                                "ParameterName",
                                e?.name ?? e
                              );

                              // formikParametersAdd.setFieldValue(
                              //   "ParameterName",
                              //   capitalizeString(e)
                              // );

                              if (method == "click" || method == "enter") {
                                formikParametersAdd.setFieldValue(
                                  "UnmappedParameterIDEncrypted",
                                  e?.value ?? ""
                                );
                              } else {
                                formikParametersAdd.setFieldValue(
                                  "UnmappedParameterIDEncrypted",
                                  ""
                                );
                              }
                              if (method == "type") {
                                getStandardParametersListUnmapped(e?.name ?? e);
                              }
                            }}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <label className="mb-1">
                            Short Code &nbsp;
                            <OverlayTrigger
                              trigger={["hover", "focus"]}
                              responsive={true}
                              overlay={
                                <Tooltip className="toltip-popover">
                                  <strong className="p-1">
                                    {" "}
                                    Short code to be used in formula. It should
                                    be unique. Constant like 'Pi', 'E' & 'NULL'
                                    can not be used as short code.
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <span>
                                <i
                                  className="fa fa-info-circle"
                                  style={{
                                    cursor: "pointer",
                                    color: "#9698ab",
                                  }}
                                ></i>
                              </span>
                            </OverlayTrigger>
                          </label>
                          <Field
                            name="ShortCode"
                            placeholder={"Enter Short Code"}
                            component={CustomInput}
                            maxLength={50}
                            onChange={(e) => {
                              const inputValue = e?.target?.value ?? "";
                              formikParametersAdd.setFieldValue(
                                "ShortCode",
                                inputValue.replace(/\s+/g, "")
                              ); //doesn't allow space
                            }}
                          />
                        </Col>
                        <Col lg={3}>
                          <Field
                            label="Parameter Result Type"
                            name="ParameterResultType"
                            placeholder={"Select Parameter Result Type"}
                            component={CustomSelect}
                            options={ParameterResultTypeOptions}
                            isClearable={false}
                            onChange={(e) => {
                              formikParametersAdd.setFieldValue(
                                "ParameterResultType",
                                e?.value ?? ""
                              );
                            }}
                            required
                          />
                        </Col>
                        <Col lg={3}>
                          <label></label>
                          <div className="d-flex mb-2">
                            <label>NABL &nbsp;</label>
                            <div className="form-check form-switch">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                title={ParametersIsNABL == true ? "Yes" : "No"}
                                checked={ParametersIsNABL}
                                onChange={() => {
                                  formikParametersAdd.setFieldValue(
                                    "ParametersIsNABL",
                                    !ParametersIsNABL
                                  );
                                }}
                                style={{ cursor: "pointer" }}
                              ></input>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <hr className="mt-1 mb-1"></hr>
                      {/* <Row>
                        <Col lg={4}>
                          <Field
                            label="Material"
                            name="MaterialID"
                            value={MaterialText}
                            placeholder={"Select Material"}
                            component={CustomMultiColumnSelect}
                            options={materialOptions}
                            required
                            onChange={handleChangeMaterial}
                            ddlType={"Material"}
                            havingSelectedValue={
                              DepartmentIDEncrypt ||
                              ProductGroupIDEncrypt ||
                              MaterialTypeIDEncrypt
                                ? true
                                : false
                            }
                            setValuesOnSelectMultiColumn={
                              setValuesOnSelectMultiColumn
                            }
                            resetValueOnUnSelectMultiColumn={
                              resetValueOnUnSelectMultiColumn
                            }
                          />
                        </Col>
                        <Col lg={4}>
                          <Field
                            label="Test Method"
                            name="TestMethodIDEncrypt"
                            placeholder={"Select Test Method"}
                            component={CustomSelect}
                            options={testMethodOptions}
                            required
                            onChange={(e) => {
                              //console.log(e);
                              formikParametersAdd.setFieldValue(
                                "TestMethodIDEncrypt",
                                e?.value ?? ""
                              );
                              formikParametersAdd.setFieldValue(
                                "TestMethodName",
                                e?.label ?? ""
                              );
                            }}
                          />
                        </Col>
                        <Col lg={4}>
                          <label className="mb-1">Range</label>
                          <div className="d-flex">
                            <Field
                              name="NABLRangeFrom"
                              placeholder={"From"}
                              component={CustomInput}
                              maxLength={100}
                            />
                            <span>&nbsp;</span>
                            <Field
                              name="NABLRangeTo"
                              placeholder={"To"}
                              component={CustomInput}
                              maxLength={100}
                            />
                            <div className="ms-3">
                              <Link
                                // className="btn btn-primary btn-sm"
                                className="btn btn-outline-primary btn-sm"
                                onClick={(e) => {
                                  addParameterMaterialType();
                                }}
                              >
                                {Parameterindx != "" ? "Update" : "Add"}
                              </Link>
                            </div>
                            {Parameterindx != "" ? (
                              <div className="ms-1">
                                <Link
                                  // className="btn btn-danger light btn-sm"
                                  className="btn btn-outline-danger btn-sm"
                                  onClick={(e) => {
                                    cancelParameterMaterialType();
                                  }}
                                >
                                  Cancel
                                </Link>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                      </Row> */}
                      <Row>
                        <Col lg={4} className="mb-2">
                          <label className="mb-1">Departments</label>
                          <div
                            className="card mb-0 w-100"
                            style={{ maxHeight: "290px" }}
                          >
                            <div className="card-header p-0">
                              <input
                                type="text"
                                name="searchDepartment"
                                placeholder={"Search here..."}
                                className="form-control form-control-sm"
                                value={searchDepartment}
                                onChange={handleChangeSearchDepartment}
                                style={{
                                  borderBottomLeftRadius: "0",
                                  borderBottomRightRadius: "0",
                                }}
                              ></input>
                            </div>
                            <div
                              className="card-body p-0  table-responsive"
                              style={{
                                maxHeight: "260px",
                                overflow: "auto",
                              }}
                            >
                              <table className="table table-hover header-border no-footer">
                                <tbody>
                                  {ParameterDepartmentList?.filter(
                                    (x) => x.display == true
                                  )?.length > 0 ? (
                                    ParameterDepartmentList?.map(
                                      (item, indx) => (
                                        <tr
                                          key={indx}
                                          style={{
                                            display:
                                              item.display == true
                                                ? ""
                                                : "none",
                                          }}
                                        >
                                          <td
                                            style={{
                                              textAlign: "center",
                                              padding: "0.5rem",
                                              width: "15%",
                                            }}
                                          >
                                            <input
                                              type="checkbox"
                                              className="form-check-input"
                                              id={`chkDepartment${indx}`}
                                              name={`chkDepartment${indx}`}
                                              checked={item.IsSelected}
                                              disabled={item.IsDisabled}
                                              onChange={(e) => {
                                                formikParametersAdd.setFieldValue(
                                                  `ParameterDepartmentList[${indx}].IsSelected`,
                                                  e.target.checked
                                                );
                                              }}
                                            />
                                          </td>
                                          <td
                                            style={{
                                              textAlign: "left",
                                              padding: "0.5rem",
                                              width: "85%",
                                            }}
                                          >
                                            {item.DepartmentName}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={2}
                                        style={{ textAlign: "center" }}
                                      >
                                        <div>{"No options"}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Col>
                        {/* <Col lg={8}>
                        <div className="table-responsive active-projects style-1 shorting mb-2">
                          <div
                            id="ParameterMappingList-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="ParameterMappingList-tbl"
                              className="table dataTable no-footer mb-0"
                            >
                              <thead>
                                <tr>
                                  <th width="4%"></th>
                                  <th width="60%">Material</th>
                                  <th width="26%">Test Method</th>
                                  <th width="10%" style={{ textAlign: "left" }}>
                                    NABL Range
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {ParameterMaterialTypeList?.filter(
                                  (x) => x.IsDeleted == false
                                ).length > 0 ? (
                                  ParameterMaterialTypeList?.map(
                                    (item, idx) => (
                                      <tr
                                        style={{
                                          display:
                                            item?.IsDeleted == true
                                              ? "none"
                                              : "",
                                        }}
                                      >
                                        <td>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-primary-light me-1"
                                            className="icon-box icon-box-md me-1"
                                            title="Edit"
                                            onClick={() => {
                                              editParameterMaterialType(idx);
                                            }}
                                          >
                                            {SVGICON.EditPrimary}
                                          </Link>
                                          <Link
                                            to="#"
                                            // className="icon-box icon-box-md bg-danger-light"
                                            className="icon-box icon-box-md me-1"
                                            title="Delete"
                                            onClick={() => {
                                              //deleteParameterMaterialType(idx);
                                              delete_RecordWithoutApi(
                                                deleteParameterMaterialType,
                                                idx
                                              );
                                            }}
                                            // onClick={() => {
                                            //   deleteParameterMaterialType(idx);
                                            // }}
                                          >
                                            {SVGICON.DeleteDanger}
                                          </Link>
                                        </td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          className="popupOverlay"
                                        >
                                          <OverlayTrigger
                                            trigger={["hover", "focus"]}
                                            key={indx}
                                            responsive={true}
                                            overlay={
                                              <Tooltip
                                                className="toltip-popover"
                                                // id={`popover-positioned-${item.MaterialName.toLowerCase()}`}
                                              >
                                                <strong className="p-1">
                                                  {item.MaterialName}
                                                </strong>
                                              </Tooltip>
                                            }
                                          >
                                            <span>{item.MaterialName}</span>
                                          </OverlayTrigger>
                                        </td>
                                        <td
                                          style={{ cursor: "pointer" }}
                                          className="popupOverlay"
                                        >
                                          <OverlayTrigger
                                            trigger={["hover", "focus"]}
                                            key={indx}
                                            responsive={true}
                                            overlay={
                                              <Tooltip
                                                className="toltip-popover"
                                                // id={`popover-positioned-${item.TestMethodName.toLowerCase()}`}
                                              >
                                                <strong className="p-1">
                                                  {item.TestMethodName}
                                                </strong>
                                              </Tooltip>
                                            }
                                          >
                                            <span>{item.TestMethodName}</span>
                                          </OverlayTrigger>
                                        </td>
                                        <td style={{ textAlign: "left" }}>
                                          {item.NABLRangeFrom
                                            ? item.NABLRangeFrom +
                                              " - " +
                                              item.NABLRangeTo
                                            : ""}
                                        </td>
                                      </tr>
                                    )
                                  )
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      style={{ textAlign: "left" }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col> */}
                        {/* {ParametersIsNABL == true && ( */}
                        <Col lg={8}>
                          <div>
                            <label>Parameter Test Methods</label>
                            {AuthUser?.UserType !== 1 ||
                            formsList?.filter(
                              (x) => x?.FormID == 20 && x?.IsAdd
                            )?.length > 0 ? (
                              <Link
                                to="#"
                                className="icon-box icon-box-md bg-primary-light me-1"
                                title="New Test Method"
                                style={{ float: "right" }}
                                onClick={addTestMethod}
                              >
                                <i className="fa fa-plus"></i>
                              </Link>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className="table-responsive active-projects style-1 shorting mb-2">
                            <div
                              id="ParameterMappingList-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="ParameterMappingList-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th width="4%">
                                      <Link
                                        to="#"
                                        className="icon-box icon-box-md bg-primary-light"
                                        title="Add New"
                                        onClick={() => {
                                          AddNewNABLTestMethodRange();
                                        }}
                                      >
                                        <i className="fa fa-plus"></i>
                                      </Link>
                                    </th>
                                    <th width="60%">Test Method</th>
                                    <th
                                      width="26%"
                                      style={{ textAlign: "left" }}
                                    >
                                      NABL Range
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ParameterNABLTestMethodRangeList?.filter(
                                    (x) => x.IsDelete == false
                                  ).length > 0 ? (
                                    ParameterNABLTestMethodRangeList?.map(
                                      (item, idx) => (
                                        <tr
                                          style={{
                                            display:
                                              item?.IsDelete == true
                                                ? "none"
                                                : "",
                                          }}
                                        >
                                          <td className="p-1">
                                            <Link
                                              to="#"
                                              // className="icon-box icon-box-md bg-danger-light"
                                              className="icon-box icon-box-md"
                                              title="Delete"
                                              onClick={() => {
                                                delete_RecordWithoutApi(
                                                  deleteNABLTestMethodRange,
                                                  idx
                                                );
                                              }}
                                            >
                                              {SVGICON.DeleteDanger}
                                            </Link>
                                          </td>
                                          <td>
                                            <Field
                                              name={`ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`}
                                              placeholder={"Select Test Method"}
                                              options={testMethodOptions}
                                              component={CustomSelect}
                                              noMarginBottom={true}
                                              menuPosition="fixed"
                                              onChange={(e) => {
                                                if (e) {
                                                  if (
                                                    ParameterNABLTestMethodRangeList?.filter(
                                                      (x) =>
                                                        x?.IsDelete == false
                                                    )?.filter(
                                                      (item, index) =>
                                                        item?.TestMethodIDEncrypt ==
                                                          e?.value &&
                                                        idx != index
                                                    )?.length > 0
                                                  ) {
                                                    warningMessage(
                                                      "Selected Test Method already Exist...!"
                                                    );
                                                    formikParametersAdd.setFieldValue(
                                                      `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                      ""
                                                    );
                                                  } else {
                                                    formikParametersAdd.setFieldValue(
                                                      `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                      e?.value
                                                    );
                                                  }
                                                } else {
                                                  formikParametersAdd.setFieldValue(
                                                    `ParameterNABLTestMethodRangeList[${idx}].TestMethodIDEncrypt`,
                                                    ""
                                                  );
                                                }
                                              }}
                                            />
                                          </td>
                                          <td style={{ textAlign: "left" }}>
                                            <div className="d-flex">
                                              <Field
                                                type="number"
                                                name={`ParameterNABLTestMethodRangeList[${idx}].NABLRangeFrom`}
                                                placeholder={"From"}
                                                component={CustomInput}
                                                maxLength={100}
                                                noMarginBottom={true}
                                                disabled={
                                                  ParameterResultType == 2
                                                    ? true
                                                    : false
                                                }
                                              />
                                              <span>&nbsp;</span>
                                              <Field
                                                type="number"
                                                name={`ParameterNABLTestMethodRangeList[${idx}].NABLRangeTo`}
                                                placeholder={"To"}
                                                component={CustomInput}
                                                maxLength={100}
                                                noMarginBottom={true}
                                                disabled={
                                                  ParameterResultType == 2
                                                    ? true
                                                    : false
                                                }
                                              />
                                            </div>
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={3}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <ErrorMessage
                            name={"ParameterNABLTestMethodRangeList"}
                            component="div"
                            className="invalid-feedback animated fadeInUp"
                            style={{ display: "block" }}
                          />
                        </Col>
                        {/* )} */}
                      </Row>
                      {/* <Row>
                        <Col lg={12}>
                          <div className="table-responsive active-projects style-1 shorting">
                            <ErrorMessage
                              name={"ParameterMaterialTypeList"}
                              component="div"
                              className="invalid-feedback animated fadeInUp"
                              style={{ display: "block" }}
                            />
                            <div
                              id="ParameterMappingList-tbl_wrapper"
                              className="dataTables_wrapper no-footer"
                            >
                              <table
                                id="ParameterMappingList-tbl"
                                className="table dataTable no-footer mb-0"
                              >
                                <thead>
                                  <tr>
                                    <th width="4%"></th>
                                    <th width="46%">Material</th>
                                    <th width="30%">Test Method</th>
                                    <th
                                      width="20%"
                                      style={{ textAlign: "left" }}
                                    >
                                      Range
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {ParameterMaterialTypeList?.filter(
                                    (x) => x.IsDeleted == false
                                  ).length > 0 ? (
                                    ParameterMaterialTypeList?.map(
                                      (item, idx) => (
                                        <tr
                                          style={{
                                            display:
                                              item?.IsDeleted == true
                                                ? "none"
                                                : "",
                                          }}
                                        >
                                          <td>
                                            <Link
                                              to="#"
                                              // className="icon-box icon-box-md bg-primary-light me-1"
                                              className="icon-box icon-box-md me-1"
                                              title="Edit"
                                              onClick={() => {
                                                editParameterMaterialType(idx);
                                              }}
                                            >
                                              {SVGICON.EditPrimary}
                                            </Link>
                                            <Link
                                              to="#"
                                              // className="icon-box icon-box-md bg-danger-light"
                                              className="icon-box icon-box-md me-1"
                                              title="Delete"
                                              onClick={() => {
                                                //deleteParameterMaterialType(idx);
                                                delete_RecordWithoutApi(
                                                  deleteParameterMaterialType,
                                                  idx
                                                );
                                              }}
                                              // onClick={() => {
                                              //   deleteParameterMaterialType(
                                              //     idx
                                              //   );
                                              // }}
                                            >
                                              {SVGICON.DeleteDanger}
                                            </Link>
                                          </td>
                                          <td>{item.MaterialName}</td>
                                          <td>{item.TestMethodName}</td>
                                          <td style={{ textAlign: "left" }}>
                                            {item.NABLRangeFrom
                                              ? item.NABLRangeFrom +
                                                " - " +
                                                item.NABLRangeTo
                                              : ""}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  ) : (
                                    <tr>
                                      <td
                                        colSpan={4}
                                        style={{ textAlign: "left" }}
                                      >
                                        <div>{"No Record Found..."}</div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </Col>
                      </Row> */}
                    </Col>
                  </Row>
                  {showQuickAddTestMethodModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )}
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i>{" "}
                    {UnmappedParameterIDEncrypted ? "Update" : "Add"}
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setShowQuickAddParametersModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showQuickAddProductGroupModal}
          onHide={setShowQuickAddProductGroupModal}
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikProductGroupAdd}>
              <Form onSubmit={formikProductGroupAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Material Group</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowQuickAddProductGroupModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <Field
                        label="Material Group Name"
                        name="ProductGroupName"
                        placeholder={"Enter Material Group Name"}
                        component={CustomInput}
                        maxLength={500}
                        required
                        onChange={(e) => {
                          formikProductGroupAdd.setFieldValue(
                            "ProductGroupName",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setShowQuickAddProductGroupModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        {/* <Modal
          className="fade"
          show={showQuickAddTestMethodModal}
          onHide={setShowQuickAddTestMethodModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikTestMethodAdd}>
              <Form onSubmit={formikTestMethodAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Test Method</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowQuickAddTestMethodModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <label>
                        Name <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col lg={12}>
                      <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="customRadioStandard"
                          name="TestMethodCodeType"
                          title="Standard Name"
                          style={{ cursor: "pointer" }}
                          checked={TestMethodCodeType == 1 ? true : false}
                          onClick={() => {
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCodeType",
                              1
                            );
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodName",
                              ""
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customRadioStandard"
                        >
                          Standard Name
                        </label>
                      </div>
                      <div className="form-check custom-checkbox mb-2 form-check-inline ms-1">
                        <input
                          type="radio"
                          className="form-check-input"
                          id="customRadioManual"
                          name="TestMethodCodeType"
                          title="Manual"
                          style={{ cursor: "pointer" }}
                          checked={TestMethodCodeType == 2 ? true : false}
                          onClick={() => {
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCodeType",
                              2
                            );
                            formikTestMethodAdd.setFieldValue(
                              "TestMethodCountryCode",
                              ""
                            );
                            formikTestMethodAdd.setFieldValue(
                              "StandardCode",
                              ""
                            );
                            formikTestMethodAdd.setFieldValue("Delimiter", "");
                            formikTestMethodAdd.setFieldValue("MethodYear", "");
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="customRadioManual"
                        >
                          Manual
                        </label>
                      </div>
                    </Col>
                    {TestMethodCodeType == 1 ? (
                      <Col lg={12}>
                        <Row>
                          <Col lg={4} className="pe-zero">
                            <Field
                              label="Country Code"
                              name="TestMethodCountryCode"
                              placeholder={"Enter Country Code"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={4} className="pe-zero">
                            <Field
                              label="Standard Code"
                              name="StandardCode"
                              placeholder={"Enter Standard Code"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={2} className="pe-zero">
                            <Field
                              label="Delimiter"
                              name="Delimiter"
                              placeholder={"Delimiter"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                          <Col lg={2}>
                            <Field
                              label="Year"
                              name="MethodYear"
                              placeholder={"Year"}
                              component={CustomInput}
                              required
                              maxLength={4}
                              disabled={TestMethodCodeType == 2 ? true : false}
                            />
                          </Col>
                        </Row>
                      </Col>
                    ) : (
                      ""
                    )}
                    <Col lg={12}>
                      <Field
                        // label="Test Method Name"
                        name="TestMethodName"
                        placeholder={"Enter Test Method Name"}
                        component={CustomInput}
                        required
                        maxLength={100}
                        disabled={TestMethodCodeType == 1 ? true : false}
                        onChange={(e) => {
                          formikTestMethodAdd.setFieldValue(
                            "TestMethodName",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Description"
                        name="Description"
                        placeholder={"Enter Description"}
                        component={CustomTextArea}
                        rows={3}
                        maxLength={100}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Display Name"
                        name="DisplayName"
                        placeholder={"Enter Display Name"}
                        component={CustomInput}
                        required
                        maxLength={500}
                        onChange={(e) => {
                          formikTestMethodAdd.setFieldValue(
                            "DisplayName",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={12}>
                      <Field
                        label="Nick Name"
                        name="NickName"
                        placeholder={"Enter Nick Name"}
                        component={CustomInput}
                        maxLength={500}
                      />
                    </Col>
                    <Col lg={12}>
                      <div className="d-flex mb-2">
                        <label>NABL &nbsp;</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="flexSwitchCheckChecked"
                            title={TestMethodIsNABL == true ? "Yes" : "No"}
                            checked={TestMethodIsNABL}
                            onChange={() => {
                              formikTestMethodAdd.setFieldValue(
                                "TestMethodIsNABL",
                                !TestMethodIsNABL
                              );
                            }}
                            style={{ cursor: "pointer" }}
                          ></input>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm me-2"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setShowQuickAddTestMethodModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}

        <Modal
          className="fade"
          show={addNonStandardParametersModal}
          onHide={setAddNonStandardParametersModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikNonStandardParametersAdd}>
              <Form onSubmit={formikNonStandardParametersAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Non Standard Parameters</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setAddNonStandardParametersModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    {/* <Col lg={6}>
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="New Non Parameter Name"
                        style={{ float: "right" }}
                        onClick={() => {
                          setCategoryType(2); // 2 = Non Parameter Name
                          setCategoryTypeName("Non Parameter Name");
                          setShowQuickAddMaterialCategoryModal(true);
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </Link>
                      <label>Non Parameter Name</label>
                      <div className="">
                        <div className="card-header p-0">
                          <input
                            type="text"
                            name="NonParameterName"
                            placeholder={"Search here..."}
                            className="form-control"
                            value={NonParameterName}
                            onChange={handleChangeSearchNonParameterName}
                            autoComplete="off"
                          ></input>
                        </div>

                        {ListOfNonParameterName?.filter(
                          (x) => x.display == true
                        )?.length > 0 ? (
                          <div
                            className="card p-0"
                            style={{
                              maxHeight: "170px",
                              overflow: "auto",
                              width: "211px",
                              position: "absolute",
                              zIndex: "999",
                            }}
                          >
                            <table className="table table-hover header-border no-footer">
                              <tbody>
                                {ListOfNonParameterName?.filter(
                                  (x) => x.display == true
                                )?.length > 0 ? (
                                  ListOfNonParameterName?.map((item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "0.5rem",
                                          width: "85%",
                                        }}
                                        onClick={() => {
                                          formikNonStandardParametersAdd.setFieldValue(
                                            "NonParameterName",
                                            item.ParameterName
                                          );
                                          setHideRow();
                                        }}
                                      >
                                        {item.ParameterName}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "center" }}
                                    >
                                      <div>{"No options"}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </Col> */}
                    <Col lg={6}>
                      <Field
                        label="Parameter Name"
                        name="NonParameterName"
                        placeholder="Parameter Name"
                        component={CustomInputAutoSuggest}
                        options={nonStandardParameterOptions}
                        required
                        onChange={(e) => {
                          formikNonStandardParametersAdd.setFieldValue(
                            "NonParameterName",
                            // capitalizeString(e?.name ?? e) //Up down key not working, so capitalize at the time of adding
                            e?.name ?? e
                          );
                        }}
                        onSuggestionSelected={(e) => {
                          formikNonStandardParametersAdd.setFieldValue(
                            "NonParameterName",
                            e?.name ?? ""
                          );
                          formikNonStandardParametersAdd.setFieldValue(
                            "ShortCode",
                            e?.ShortCode ?? ""
                          );
                        }}
                        onBlur={(e) => {
                          if (
                            nonStandardParameterOptions.filter(
                              (x) =>
                                x.name ==
                                formikNonStandardParametersAdd.values.NonParameterName?.trim()
                            )?.length <= 0
                          ) {
                            formikNonStandardParametersAdd.setFieldValue(
                              "ShortCode",
                              ""
                            );
                          }
                        }}
                      />
                    </Col>
                    <Col lg={6}>
                      <Field
                        label="Display Name"
                        name="DisplayName"
                        placeholder={"Enter Display Name"}
                        component={CustomInput}
                        //required
                        maxLength={500}
                        onChange={(e) => {
                          formikNonStandardParametersAdd.setFieldValue(
                            "DisplayName",
                            capitalizeString(e)
                          );
                        }}
                      />
                    </Col>
                    <Col lg={6}>
                      <Field
                        label="Display Code"
                        name="DisplayCode"
                        placeholder={"Enter Display Code"}
                        component={CustomInput}
                        //required
                        maxLength={500}
                      />
                    </Col>
                    <Col lg={6}>
                      {IsMixDesign == false ? (
                        <Field
                          label="Requirement"
                          name="Requirement"
                          placeholder={"Enter Requirement"}
                          component={CustomInput}
                          //required
                          maxLength={2000}
                        />
                      ) : (
                        <Field
                          label="Printing Group"
                          name="Requirement"
                          placeholder="Printing Group"
                          component={CustomInputAutoSuggest}
                          options={mixDesignPrintingGroupOptions}
                        />
                      )}
                    </Col>
                    <Col lg={6}>
                      <Field
                        label="Default Value"
                        name="DefaultValue"
                        placeholder={"Enter Default Value"}
                        component={CustomInput}
                        //required
                        maxLength={2000}
                      />
                    </Col>
                    {AuthUser?.Permissions?.Account == 1 && (
                      <Col lg={6}>
                        <div className="d-flex mb-0">
                          <label className="mb-1">
                            Consider Additional Charge &nbsp;
                          </label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckChecked"
                              title={
                                ConsiderAdditionalCharge == true ? "Yes" : "No"
                              }
                              checked={ConsiderAdditionalCharge}
                              onChange={() => {
                                formikNonStandardParametersAdd.setFieldValue(
                                  "ConsiderAdditionalCharge",
                                  !ConsiderAdditionalCharge
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            ></input>
                          </div>
                        </div>
                        {ConsiderAdditionalCharge ? (
                          <>
                            <Field
                              type="number"
                              name="AdditionalChargeAmount"
                              placeholder={"Additional Amount"}
                              component={CustomInput}
                              required
                              maxLength={20}
                              disabled={
                                IsRecordEdit ||
                                !TestMasterNonStandardParameterIDEncrypted
                                  ? false
                                  : true
                              }
                              onChange={(e) => {
                                if (
                                  IsRecordEdit ||
                                  !TestMasterNonStandardParameterIDEncrypted
                                ) {
                                  formikNonStandardParametersAdd.setFieldValue(
                                    "AdditionalChargeAmount",
                                    e?.target?.value ?? ""
                                  );
                                }
                              }}
                            />
                            {/* {NonParameterName ? (
                            <Link
                              to="#"
                              className="text-primary p-1"
                              title="View Machining Parameter Rate"
                              onClick={() => {
                                getMachineWiseParameterRateList(
                                  "0",
                                  2,
                                  NonParameterName
                                );
                              }}
                            >
                              Set Machine wise Parameter Rate
                            </Link>
                          ) : (
                            ""
                          )} */}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    )}
                    <Col lg={6}>
                      <label className="mb-1">
                        Short Code &nbsp;
                        <OverlayTrigger
                          trigger={["hover", "focus"]}
                          responsive={true}
                          overlay={
                            <Tooltip className="toltip-popover">
                              <strong className="p-1">
                                {" "}
                                Short code to be used in formula. It should be
                                unique. Constant like 'Pi', 'E' & 'NULL' can not
                                be used as short code.
                              </strong>
                            </Tooltip>
                          }
                        >
                          <span>
                            <i
                              className="fa fa-info-circle"
                              style={{ cursor: "pointer", color: "#9698ab" }}
                            ></i>
                          </span>
                        </OverlayTrigger>
                      </label>
                      <Field
                        name="ShortCode"
                        placeholder={"Enter Short Code"}
                        component={CustomInput}
                        maxLength={50}
                        disabled={
                          nonStandardParameterOptions.filter(
                            (x) =>
                              x.name ==
                              formikNonStandardParametersAdd.values.NonParameterName?.trim()
                          )?.length > 0
                            ? true
                            : false
                        }
                        onChange={(e) => {
                          const inputValue = e?.target?.value ?? "";
                          formikNonStandardParametersAdd.setFieldValue(
                            "ShortCode",
                            inputValue.replace(/\s+/g, "")
                          ); //doesn't allow space
                        }}
                      />
                    </Col>
                    <Col lg={6}>
                      <div className="d-flex mb-2">
                        <label className="mb-1">Average Required &nbsp;</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsAverageRequiredNonStandardPara"
                            role="switch"
                            id="IsAverageRequiredNonStandardPara"
                            title={
                              formikNonStandardParametersAdd.values
                                .IsAverageRequired == true
                                ? "Yes"
                                : "No"
                            }
                            checked={
                              formikNonStandardParametersAdd.values
                                .IsAverageRequired
                            }
                            onChange={(e) => {
                              formikNonStandardParametersAdd.setFieldValue(
                                "IsAverageRequired",
                                !formikNonStandardParametersAdd.values
                                  .IsAverageRequired
                              );
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          ></input>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* {showMachineWiseParameterRateModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )} */}
                </Modal.Body>
                <Modal.Footer>
                  <button
                    // className="btn me-2 btn-primary"
                    className="btn btn-primary btn-sm"
                    type="submit"
                  >
                    <i className="fa-solid fa-floppy-disk"></i> Add
                  </button>
                  <button
                    type="button"
                    // className="btn btn-danger light"
                    className="btn btn-danger btn-sm"
                    onClick={() => setAddNonStandardParametersModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>

        <Modal
          className="fade"
          show={showAddStandardParametersModal}
          onHide={setShowAddStandardParametersModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikStandardParametersAdd}>
              <Form onSubmit={formikStandardParametersAdd.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Standard Parameters</Modal.Title>
                  <button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowAddStandardParametersModal(false)}
                  ></button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={6}>
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-primary-light me-1"
                        title="Reload Parameters"
                        style={{ float: "right" }}
                        onClick={() => {
                          setRefreshParameterKey(
                            Math.random().toString(9).substring(2, 9)
                          );
                        }}
                      >
                        <i className="fa fa-refresh"></i>
                      </Link>
                      <Link
                        to="#"
                        className="icon-box icon-box-md bg-info-light me-1"
                        title="New Parameters"
                        style={{ float: "right" }}
                        onClick={addParameters}
                      >
                        <i className="fa fa-plus"> </i>
                      </Link>
                      <Field
                        key={refreshParameterKey}
                        label="Parameter"
                        name="ParameterIDEncrypted"
                        placeholder={"Select Parameter"}
                        component={CustomSelectAsync}
                        loadOptionsFn={loadOptionsParameter}
                        title={ParameterName}
                        labelFieldName="ParameterName"
                        required
                        onChange={(e) => {
                          formikStandardParametersAdd.setFieldValue(
                            "ParameterIDEncrypted",
                            e?.value ?? ""
                          );
                          formikStandardParametersAdd.setFieldValue(
                            "ParameterName",
                            e?.label ?? ""
                          );
                          formikStandardParametersAdd.setFieldValue(
                            "ShortCode",
                            e?.ShortCode ?? ""
                          );
                        }}
                      />
                    </Col>
                    <Col lg={6}>
                      <Field
                        type="text"
                        label="DisplayName"
                        name="DisplayName"
                        component={CustomInput}
                        placeholder="Display Name"
                      />
                    </Col>
                    <Col lg={6}>
                      {IsMixDesign == false ? (
                        <Field
                          type="text"
                          label="Requirement"
                          name="Requirement"
                          component={CustomInput}
                          placeholder="Requirement"
                        />
                      ) : (
                        <Field
                          label="Printing Group"
                          name="Requirement"
                          placeholder="Printing Group"
                          component={CustomInputAutoSuggest}
                          options={mixDesignPrintingGroupOptions}
                        />
                      )}
                    </Col>
                    <Col lg={6}>
                      <Field
                        type="text"
                        label="DefaultValue"
                        name="DefaultValue"
                        component={CustomInput}
                        placeholder="Default Value"
                        noMarginBottom={true}
                      />
                    </Col>
                    {AuthUser?.Permissions?.Account == 1 && (
                      <Col lg={6}>
                        <div className="d-flex mb-0">
                          <label className="mb-1">
                            Consider Additional Charge &nbsp;
                          </label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="ConsiderAdditionalChargeStandardPara"
                              role="switch"
                              id="ConsiderAdditionalChargeStandardPara"
                              title={
                                ConsiderAdditionalChargeStandardPara == true
                                  ? "Yes"
                                  : "No"
                              }
                              checked={ConsiderAdditionalChargeStandardPara}
                              onChange={(e) => {
                                formikStandardParametersAdd.setFieldValue(
                                  "ConsiderAdditionalChargeStandardPara",
                                  !ConsiderAdditionalChargeStandardPara
                                );
                              }}
                              style={{
                                cursor: "pointer",
                              }}
                            ></input>
                          </div>
                        </div>
                        {ConsiderAdditionalChargeStandardPara ? (
                          <>
                            <Field
                              type="number"
                              // label="AdditionalChargeAmount"
                              name="AdditionalChargeAmount"
                              component={CustomInput}
                              placeholder="Amount"
                              required
                            />
                            {/* {ParameterIDEncrypted ? (
                            <Link
                              to="#"
                              className="text-primary p-1"
                              title="View Machining Parameter Rate"
                              onClick={() => {
                                getMachineWiseParameterRateList(
                                  ParameterIDEncrypted,
                                  1,
                                  ParameterName
                                );
                              }}
                            >
                              Set Machine wise Parameter Rate
                            </Link>
                          ) : (
                            ""
                          )} */}
                          </>
                        ) : (
                          ""
                        )}
                      </Col>
                    )}
                    <Col lg={6}>
                      <div className="d-flex mb-2">
                        <label className="mb-1">Average Required &nbsp;</label>
                        <div className="form-check form-switch">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="IsAverageRequiredStandardPara"
                            role="switch"
                            id="IsAverageRequiredStandardPara"
                            title={
                              formikStandardParametersAdd.values
                                .IsAverageRequired == true
                                ? "Yes"
                                : "No"
                            }
                            checked={
                              formikStandardParametersAdd.values
                                .IsAverageRequired
                            }
                            onChange={(e) => {
                              formikStandardParametersAdd.setFieldValue(
                                "IsAverageRequired",
                                !formikStandardParametersAdd.values
                                  .IsAverageRequired
                              );
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          ></input>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  {/* {showMachineWiseParameterRateModal == true && (
                    <div className="fade modal-backdrop show"></div>
                  )} */}
                </Modal.Body>
                <Modal.Footer>
                  <button className="btn btn-primary btn-sm" type="submit">
                    <i className="fa-solid fa-floppy-disk"></i> Add
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => setShowAddStandardParametersModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        {/* 
        <Modal
          className="fade"
          show={showMachineWiseParameterRateModal}
          onHide={setShowMachineWiseParameterRateModal}
          size="lg"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMachineWiseParameterRate}>
              <Form onSubmit={formikMachineWiseParameterRate.handleSubmit}>
                <Modal.Header>
                  <Modal.Title> Machine wise Parameter Rate</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMachineWiseParameterRateModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="ParameterWiseMachineRate-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="ParameterWiseMachineRate-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="5%"></th>
                                <th width="30%">Machine Name</th>
                                <th width="30%" style={{ textAlign: "left" }}>
                                  Rate
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {ListOfMachineWiseParameterRate?.length > 0 ? (
                                ListOfMachineWiseParameterRate?.map(
                                  (item, indx) => (
                                    <tr key={indx}>
                                      <td>{indx + 1}</td>
                                      <td>{item?.MachinesName}</td>
                                      <td
                                        className="p-1"
                                        style={{
                                          textAlign: "left",
                                          minWidth: "150px",
                                        }}
                                      >
                                        <Field
                                          name={`ListOfMachineWiseParameterRate[${indx}].ParameterRate`}
                                          placeholder={"Parameter Rate"}
                                          type="number"
                                          component={CustomInput}
                                          maxLength={100}
                                          noMarginBottom={true}
                                          // disabled={IsRecordEdit}
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                              ) : (
                                <tr>
                                  <td
                                    colSpan={10}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-plus"></i> Add
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowMachineWiseParameterRateModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal> */}
        <Modal
          className="fade"
          show={showParameterFormulaModal}
          onHide={setShowParameterFormulaModal}
          size="lg"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikParameterFormula}>
              <Form onSubmit={formikParameterFormula.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>
                    Parameter Formula {" - "}
                    {formikParameterFormula?.values?.ParameterName}
                  </Modal.Title>

                  {/* <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowParameterFormulaModal(false)}
                  ></Button> */}
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="card mb-3" style={{ height: "auto" }}>
                        <div className="card-header p-2 ps-3 pb-0">
                          <label>Short Codes</label>
                        </div>
                        <div className="card-body fs-14 pt-1 pb-2">
                          <ul className="unorder-list ps-3 row">
                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>Pi</b>
                              </span>
                              <span className="fs-13"> - Constant (π)</span>
                            </li>

                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>E</b>
                              </span>
                              <span className="fs-13"> - Constant (e)</span>
                            </li>
                            <li className="col-lg-4 ps-1">
                              <span className="text-primary">
                                <b>NULL</b>
                              </span>
                              <span className="fs-13"> - Constant (NULL)</span>
                            </li>
                            {formikParameterFormula?.values
                              ?.ParameterShortCodeList?.length > 0
                              ? formikParameterFormula?.values?.ParameterShortCodeList?.map(
                                  (p) => (
                                    <li className="col-lg-12 ps-1">
                                      <span className="text-primary">
                                        <b>{p.ShortCode}</b>
                                      </span>
                                      <span className="fs-13">
                                        {" - "} {p.ParameterName}
                                      </span>
                                    </li>
                                  )
                                )
                              : ""}
                          </ul>
                        </div>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <Field
                        label={`Formula Expression for ${formikParameterFormula?.values?.ParameterName}`}
                        name="FormulaExpression"
                        placeholder={"Enter Formula Expression"}
                        component={CustomTextArea}
                        rows={4}
                        maxLength={2000}
                      />
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={onCancelParameterFormulaDialog}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showMixDesignTestModal}
          onHide={setShowMixDesignTestModal}
          size="lg"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikMixDesignTest}>
              <Form onSubmit={formikMixDesignTest.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Tests includes in mix design</Modal.Title>
                  {/* <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowMixDesignTestModal(false)}
                  ></Button> */}
                </Modal.Header>
                <Modal.Body>
                  <Row>
                    <Col lg={12}>
                      <div className="mb-2">
                        <label className="mb-1">Test Mapping</label>
                        <div className="card mb-0 w-100">
                          <div className="card-header p-0">
                            <input
                              type="text"
                              name="searchTests"
                              placeholder={"Search here..."}
                              className="form-control form-control-sm"
                              value={searchTests}
                              onChange={handleChangeSearchTests}
                              style={{
                                borderBottomLeftRadius: "0",
                                borderBottomRightRadius: "0",
                              }}
                            ></input>
                          </div>
                          <div
                            className="card-body p-0 table-responsive"
                            style={{
                              maxHeight: "250px",
                              overflow: "auto",
                            }}
                          >
                            <table className="table table-hover header-border no-footer">
                              <tbody>
                                {TestMasterList?.filter(
                                  (x) => x.display == true
                                )?.length > 0 ? (
                                  TestMasterList?.map((item, indx) => (
                                    <tr
                                      key={indx}
                                      style={{
                                        display:
                                          item.display == true ? "" : "none",
                                      }}
                                    >
                                      <td
                                        style={{
                                          textAlign: "center",
                                          padding: "0.5rem",
                                          width: "10%",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkTest${indx}`}
                                          name={`chkTest${indx}`}
                                          checked={item.IsSelected}
                                          onChange={(e) => {
                                            formikMixDesignTest.setFieldValue(
                                              `TestMasterList[${indx}].IsSelected`,
                                              e.target.checked
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "left",
                                          padding: "0.5rem",
                                          width: "90%",
                                        }}
                                      >
                                        {item.TestName}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={2}
                                      style={{ textAlign: "center" }}
                                    >
                                      <div>{"No options"}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  <Button type="submit" variant="primary btn-sm">
                    <i className="fa-solid fa-floppy-disk"></i> Submit
                  </Button>
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowMixDesignTestModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
        <Modal
          className="fade"
          show={showDefineMoreRatesModal}
          onHide={setShowDefineMoreRatesModal}
          size="lg"
          backdrop="static"
        >
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <FormikProvider value={formikDefineMoreRates}>
              <Form onSubmit={formikDefineMoreRates.handleSubmit}>
                <Modal.Header>
                  <Modal.Title>Define More Rates</Modal.Title>
                  <Button
                    type="button"
                    variant=""
                    className="btn-close"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  ></Button>
                </Modal.Header>
                <Modal.Body
                  className={IsRecordEdit == true ? "" : "disableDiv"}
                >
                  <Row>
                    <Col lg={6}>
                      <div className="me-5">
                        <div className="d-flex mb-2">
                          <label>Include Standard Rate &nbsp;</label>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="flexSwitchCheckIncudeStandardRate"
                              title={
                                IsIncudeStandardRate == true ? "Yes" : "No"
                              }
                              checked={IsIncudeStandardRate}
                              onChange={() => {
                                formikDefineMoreRates.setFieldValue(
                                  "IsIncudeStandardRate",
                                  !IsIncudeStandardRate
                                );
                              }}
                              style={{ cursor: "pointer" }}
                            ></input>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-2"></hr>
                  <Row>
                    <Col lg={12}>
                      <div className="table-responsive active-projects style-1 shorting mb-2">
                        <div
                          id="DefineMoreRates-tbl_wrapper"
                          className="dataTables_wrapper no-footer"
                        >
                          <table
                            id="DefineMoreRates-tbl"
                            className="table dataTable no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="4%"></th>
                                <th width="28%">Rate Type</th>
                                <th width="24%">Unit</th>
                                <th width="12%">Min Value</th>
                                <th width="12%">Max Value</th>
                                <th width="20%" style={{ textAlign: "left" }}>
                                  Rate
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {MoreTestRatesList?.length > 0 ? (
                                MoreTestRatesList?.map((itemTest, indxTest) => (
                                  <tr
                                    key={indxTest}
                                    style={{
                                      display:
                                        itemTest.IsDeleted == true
                                          ? "none"
                                          : "",
                                    }}
                                  >
                                    <td className="p-1">
                                      {IsRecordEdit == true && (
                                        <>
                                          <Link
                                            to="#"
                                            className="icon-box icon-box-md bg-primary-light"
                                            title="New More Test Rates"
                                            onClick={(e) => {
                                              addDefineMoreRates(indxTest);
                                              e.preventDefault();
                                            }}
                                          >
                                            <i className="fa fa-plus"></i>
                                          </Link>
                                          {MoreTestRatesList?.filter(
                                            (x) => x.IsDeleted == false
                                          )?.length > 1 ? (
                                            <Link
                                              to="#"
                                              className="icon-box icon-box-md bg-danger-light ms-1"
                                              title="Remove More Test Rates"
                                              onClick={(e) => {
                                                removeMoreRates(indxTest);
                                                e.preventDefault();
                                              }}
                                            >
                                              <i className="fa fa-minus"></i>
                                            </Link>
                                          ) : (
                                            ""
                                          )}
                                        </>
                                      )}
                                    </td>

                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "150px",
                                      }}
                                    >
                                      <Field
                                        name={`MoreTestRatesList[${indxTest}].RateType`}
                                        placeholder={"Rate Type"}
                                        options={RateTypeOptions}
                                        component={CustomSelect}
                                        noMarginBottom={true}
                                        menuPosition="fixed"
                                        isClearable={false}
                                        onChange={(e) => {
                                          const selectedRateType =
                                            e?.value ?? "";
                                          formikDefineMoreRates.setFieldValue(
                                            `MoreTestRatesList[${indxTest}].RateType`,
                                            e?.value ?? ""
                                          );

                                          // If RateType is NOT 4 or 7, clear MinValue & MaxValue
                                          if (
                                            ![1, 4, 7].includes(
                                              selectedRateType
                                            )
                                          ) {
                                            formikDefineMoreRates.setFieldValue(
                                              `MoreTestRatesList[${indxTest}].MinValue`,
                                              ""
                                            );
                                            formikDefineMoreRates.setFieldValue(
                                              `MoreTestRatesList[${indxTest}].MaxValue`,
                                              ""
                                            );
                                          }
                                          checkValidationMoreRates(indxTest);
                                        }}
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "150px",
                                      }}
                                    >
                                      {itemTest.RateType === 4 ? (
                                        <Field
                                          name={`MoreTestRatesList[${indxTest}].Unit`}
                                          placeholder={"Unit"}
                                          options={unitOptions}
                                          component={CustomSelect}
                                          noMarginBottom={true}
                                          menuPosition="fixed"
                                          isDisabled={
                                            itemTest.RateType === 4
                                              ? false
                                              : true
                                          }
                                          onChange={(e) => {
                                            formikDefineMoreRates.setFieldValue(
                                              `MoreTestRatesList[${indxTest}].Unit`,
                                              e?.value ?? ""
                                            );
                                          }}
                                        />
                                      ) : (
                                        ""
                                      )}
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "105px",
                                      }}
                                    >
                                      <Field
                                        name={`MoreTestRatesList[${indxTest}].MinValue`}
                                        placeholder={"Min Value"}
                                        component={CustomInput}
                                        type="number"
                                        noMarginBottom={true}
                                        numberTypeWithoutDot={true}
                                        maxLength={5}
                                        disabled={
                                          ![1, 4, 7].includes(itemTest.RateType)
                                        }
                                        onBlur={() =>
                                          checkValidationMoreRates(indxTest)
                                        }
                                      />
                                    </td>
                                    <td
                                      className="p-1"
                                      style={{
                                        minWidth: "105px",
                                      }}
                                    >
                                      <Field
                                        name={`MoreTestRatesList[${indxTest}].MaxValue`}
                                        placeholder={"Max Value"}
                                        component={CustomInput}
                                        type="number"
                                        maxLength={5}
                                        noMarginBottom={true}
                                        numberTypeWithoutDot={true}
                                        disabled={
                                          ![1, 4, 7].includes(itemTest.RateType)
                                        }
                                        onBlur={() =>
                                          checkValidationMoreRates(indxTest)
                                        }
                                      />
                                    </td>

                                    <td
                                      className="p-1"
                                      style={{
                                        textAlign: "left",
                                        minWidth: "150px",
                                      }}
                                    >
                                      <Field
                                        name={`MoreTestRatesList[${indxTest}].TestRate`}
                                        placeholder={"TestRate"}
                                        type="number"
                                        component={CustomInput}
                                        maxLength={10}
                                        noMarginBottom={true}
                                        onBlur={() =>
                                          checkValidationMoreRates(indxTest)
                                        }
                                      />
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan={4}
                                    style={{
                                      textAlign: "left",
                                    }}
                                  >
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Modal.Body>
                <Modal.Footer>
                  {IsRecordEdit === true && (
                    <Button type="submit" variant="primary btn-sm">
                      <i className="fa-solid fa-plus"></i> Add
                    </Button>
                  )}
                  <Button
                    variant="danger btn-sm"
                    onClick={() => setShowDefineMoreRatesModal(false)}
                  >
                    <i className="fa fa-cancel"></i> Cancel
                  </Button>
                </Modal.Footer>
              </Form>
            </FormikProvider>
          </Spin>
        </Modal>
      </div>
    </div>
  );
};

export default AddTestMaster;
